var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLotus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.91 199.689C346.646 209.654 350.611 230.764 352.461 257.119 354.312 283.474 358.542 324.253 358.013 357.82 357.484 391.386 352.065 430.329 349.289 458.52 346.514 486.711 342.945 502.052 341.359 526.965 339.773 551.877 339.069 594.356 339.773 607.997 340.476 621.638 344.258 609.729 345.58 608.811 346.902 607.893 347.349 609.968 347.703 602.49 348.057 595.011 346.514 586.362 347.703 563.94 348.893 541.519 352.329 495.365 354.841 467.961 357.352 440.556 361.185 418.397 362.771 399.516 364.357 380.634 364.754 374.865 364.357 354.673 363.961 334.48 362.11 304.585 360.392 278.361 358.674 252.137 356.294 210.703 354.048 197.329 351.801 183.954 347.174 189.724 346.91 199.689Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "#748E32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.06 120.63C495.969 131.134 495.055 152.928 495.708 177.349 496.361 201.77 499.889 240.764 501.98 267.154 504.07 293.544 506.683 316.652 508.251 335.689 509.819 354.727 510.995 366.018 511.387 381.379 511.779 396.741 511.779 407.901 510.603 427.857 509.427 447.814 505.899 481.95 504.332 501.119 502.764 520.288 501.326 527.772 501.196 542.871 501.065 557.97 502.241 579.896 503.548 591.712 504.854 603.529 507.206 610.356 509.035 613.769 510.865 617.183 514 614.951 514.523 612.194 515.046 609.437 513.086 604.973 512.171 597.226 511.257 589.48 509.166 578.189 509.035 565.716 508.905 553.243 510.342 536.569 511.387 522.389 512.433 508.209 514.131 497.049 515.307 480.638 516.483 464.226 518.182 444.4 518.443 423.919 518.704 403.437 518.051 380.854 516.875 357.747 515.699 334.639 513.609 313.107 511.387 285.272 509.166 257.438 504.593 216.343 503.548 190.741 502.502 165.139 503.94 144.788 505.116 131.659 506.291 118.529 509.427 116.691 508.251 114.328 507.075 111.965 500.15 110.127 498.06 120.63Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "#748E32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.149 430.549C233.832 434.828 235.785 439.078 237.104 446.294 238.422 453.51 240.4 460.201 241.059 473.847 241.718 487.492 241.455 511.109 241.059 528.165 240.664 545.222 238.686 560.048 238.686 576.186 238.686 592.324 239.872 612.267 241.059 624.994 242.246 637.72 244.091 648.217 245.805 652.546 247.519 656.876 250.683 652.94 251.343 650.972 252.002 649.004 250.42 647.036 249.76 640.738 249.101 634.44 248.178 623.55 247.387 613.185 246.596 602.82 245.146 594.423 245.014 578.547 244.882 562.672 246.201 534.463 246.596 517.931 246.992 501.399 248.047 492.478 247.387 479.357 246.728 466.237 244.195 448.131 242.641 439.209 241.087 430.287 239.384 428.713 238.066 425.826 236.747 422.94 233.821 419.837 233.001 420.624 232.182 421.411 232.465 426.271 233.149 430.549Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "#748E32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.275 307.159C289.164 310.3 289.323 317.997 290.275 326.008 291.227 334.018 293.686 346.427 295.987 355.223 298.288 364.019 301.857 369.91 304.079 378.785 306.3 387.659 307.966 395.749 309.315 408.471 310.664 421.195 311.06 439.101 312.171 455.122 313.282 471.144 314.472 490.857 315.979 504.601 317.487 518.345 318.915 524.549 321.215 537.586 323.516 550.623 326.61 570.886 329.783 582.824 332.957 594.761 337.638 604.343 340.256 609.212 342.874 614.081 345.333 614.474 345.492 612.039 345.65 609.605 343.508 603.793 341.208 594.604 338.907 585.415 334.464 570.965 331.688 556.906 328.911 542.848 326.293 523.607 324.547 510.255 322.802 496.904 322.009 487.715 321.215 476.799 320.422 465.882 320.581 456.615 319.787 444.756 318.994 432.897 317.804 416.168 316.455 405.644 315.106 395.12 313.917 389.78 311.695 381.612 309.474 373.444 305.586 365.59 303.127 356.637 300.667 347.684 297.97 336.139 296.939 327.893 295.907 319.646 297.494 311.086 296.939 307.159 296.383 303.232 291.385 304.017 290.275 307.159Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "#748E32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.144 214.906C458.796 224.615 466.133 244.659 470.365 263.793 474.598 282.927 479.914 306.067 482.54 329.712 485.166 353.356 486.479 378.912 486.121 405.661 485.763 432.411 480.033 464.654 480.392 490.209 480.75 515.765 485.047 541.201 488.269 558.994 491.492 576.788 496.267 587.774 499.728 596.969 503.189 606.164 507.367 612.732 509.038 614.165 510.709 615.598 510.948 612.374 509.754 605.567 508.561 598.76 504.502 584.789 501.876 573.324 499.251 561.86 496.147 550.874 493.999 536.783 491.85 522.691 489.463 505.256 488.986 488.776 488.508 472.297 490.298 454.145 491.134 437.904 491.969 421.664 494.118 409.602 493.999 391.331 493.879 373.06 493.282 350.371 490.418 328.279 487.553 306.186 481.227 277.884 476.811 258.777 472.395 239.67 463.729 212.851 460.451 205.54 457.173 198.228 455.491 205.197 457.144 214.906Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1.33333",
    fill: "#748E32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.539 264.765C769.941 278.201 782.904 320.356 789.156 335.349 795.409 350.343 796.326 350.112 807.053 354.726 817.779 359.339 839.117 370.411 853.514 363.03 867.911 355.648 892.232 327.045 893.437 310.437 894.641 293.829 878.523 272.665 860.742 263.381 842.96 254.096 801.89 254.385 786.747 254.731 771.604 255.077 769.138 251.328 769.539 264.765Z",
    stroke: "#213315",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.936 158.354C431.671 155.069 431.957 150.282 434.121 149.593 436.285 148.903 440.859 152.229 443.922 154.217 446.985 156.204 452.375 158.963 452.498 161.518 452.62 164.074 447.638 167.887 444.657 169.55 441.676 171.213 437.102 171.537 434.611 171.497 432.12 171.456 430.405 171.335 429.71 169.306 429.016 167.278 430.201 161.64 430.936 158.354Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.283 153.516C439.623 153.87 441.896 160.146 441.123 164.33 440.35 168.514 436.742 172.763 437.644 178.62 438.546 184.478 442.412 195.163 446.535 199.476 450.658 203.789 458.021 204.557 462.385 204.497 466.748 204.437 471.076 202.24 472.714 199.117 474.352 195.994 473.051 189.752 472.214 185.761 471.376 181.77 469.905 177.166 467.383 173.24 464.861 169.314 461.142 165.616 457.083 162.204 453.024 158.793 444.943 153.162 442.283 153.516Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.134 159.921C427.147 163.919 425.865 180.298 426.826 188.166 427.788 196.033 431.25 202.352 434.904 207.124 438.558 211.896 444.456 215.379 448.751 216.797 453.046 218.216 457.085 217.313 460.674 215.636 464.264 213.96 468.431 210.671 470.29 206.738 472.149 202.804 473.303 197 471.829 192.035 470.355 187.069 466.957 181.588 461.444 176.945 455.931 172.302 444.135 167.014 438.75 164.177 433.365 161.34 431.121 155.923 429.134 159.921Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.858 336.136C856.978 345.195 868.216 357.069 873.766 363.734 879.315 370.398 882.626 373.074 889.155 376.125 895.684 379.175 905.15 381.147 912.938 382.038 920.726 382.93 929.073 382.414 935.882 381.475 942.69 380.536 944.229 380.302 953.789 376.406 963.349 372.511 984.381 362.044 993.241 358.102 1002.1 354.159 1002.75 354.065 1006.95 352.751 1011.15 351.437 1015.16 350.404 1018.42 350.216 1021.69 350.029 1024.86 352.282 1026.54 351.625 1028.22 350.968 1028.54 350.357 1028.5 346.274 1028.45 342.191 1027.52 332.522 1026.26 327.125 1025 321.727 1024.49 318.582 1020.94 313.889 1017.4 309.195 1011.94 302.718 1004.99 298.964 998.044 295.209 992.775 292.674 979.251 291.36 965.727 290.046 942.55 288.075 923.85 291.079 905.15 294.082 878.429 302.061 867.051 309.383 855.672 316.705 854.739 327.078 855.858 336.136Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.203 110.035C752.177 116.223 746.022 132.865 742.851 142.663 739.679 152.461 737.488 157.055 734.177 168.822 730.865 180.589 723.777 198.638 722.984 213.264 722.192 227.891 721.352 242.752 729.42 256.581 737.488 270.411 753.25 293.898 771.391 296.242 789.531 298.586 825.86 284.569 838.264 270.646 850.669 256.722 847.591 230.797 845.819 212.702 844.047 194.606 836.399 175.714 827.632 162.071 818.865 148.429 803.335 137.975 793.216 130.849 783.096 123.724 769.106 117.442 762.437 113.973 755.768 110.503 754.229 103.846 753.203 110.035Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.173 131.796C974.445 130.343 971.737 134.656 968.889 135.734 966.04 136.812 964.032 136.953 959.083 138.265 954.133 139.578 946.194 141.265 939.19 143.609 932.186 145.953 925.321 148.109 917.056 152.328 908.791 156.547 898.331 160.016 889.599 168.923 880.867 177.829 871.621 183.126 864.663 205.768 857.706 228.41 841.782 287.615 847.853 304.772 853.923 321.929 882.968 314.804 901.086 308.71 919.204 302.616 943.626 280.959 956.561 268.208 969.495 255.458 974.212 244.16 978.695 232.207 983.177 220.253 983.084 207.737 983.458 196.486 983.831 185.236 981.636 173.376 980.936 164.704 980.236 156.031 980.049 149.937 979.255 144.453 978.461 138.968 977.901 133.249 976.173 131.796Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.312 177.828C813.504 168.729 818.403 161.948 826.219 152.531 834.035 143.114 846.447 129.808 856.207 121.328 865.968 112.848 879.076 104.321 884.781 101.65 890.487 98.9794 887.893 101.275 890.44 105.304 892.986 109.334 897.324 119.875 900.058 125.826 902.793 131.776 905.057 136.508 906.848 141.006 908.64 145.503 909.536 147.705 910.809 152.812 912.082 157.919 913.287 162.268 914.487 171.647 915.687 181.025 916.287 193.377 913.576 204.683 910.865 215.988 902.312 229.336 898.221 239.478 894.129 249.621 895.461 257.587 889.025 265.538 882.589 273.489 870.117 284.372 859.602 287.183 849.088 289.994 835.225 288.261 825.936 282.404 816.647 276.548 807.877 266.147 803.869 252.044 799.861 237.942 800.165 219.489 801.072 207.12 801.98 194.75 805.121 186.926 809.312 177.828Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.77 212.557C1029.88 211.156 1025.36 209.242 1019.62 208.074 1013.89 206.907 1005.41 205.739 998.371 205.552 991.334 205.366 984.576 205.646 977.399 206.953 970.221 208.261 962.811 209.942 955.308 213.398 947.804 216.854 938.576 221.617 932.378 227.688 926.179 233.76 921.519 242.82 918.116 249.825 914.714 256.83 913.969 262.247 911.965 269.719 909.961 277.191 910.333 285.317 906.092 294.657 901.851 303.997 887.077 322.024 886.518 325.76 885.959 329.496 898.729 317.914 902.737 317.074 906.745 316.233 903.762 321.09 910.566 320.716 917.371 320.343 933.03 320.016 943.563 314.832 954.096 309.648 964.209 299.794 973.763 289.614 983.318 279.433 994.596 262.434 1000.89 253.747 1007.18 245.061 1007.88 242.166 1011.51 237.496 1015.15 232.826 1019.06 228.809 1022.7 225.727 1026.33 222.645 1035.14 218.488 1036.96 216.48 1038.78 214.472 1035.66 213.959 1032.77 212.557Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.9 328.345C842.05 325.187 845.828 318.594 847.18 314.415 848.533 310.236 851.611 306.522 855.016 303.272 858.42 300.021 864.437 296.632 867.608 294.914 870.78 293.196 872.692 293.707 874.044 292.964 875.397 292.221 872.832 293.8 875.723 290.457 878.615 287.114 885.564 278.199 891.394 272.905 897.224 267.612 907.205 261.344 910.703 258.697 914.201 256.051 911.076 258.976 912.382 257.026 913.688 255.076 916.066 248.9 918.538 246.996 921.01 245.093 924.088 245.511 927.213 245.604 930.338 245.696 935.002 247.368 937.287 247.554 939.572 247.739 945.729 245.604 944.283 251.175 942.837 256.747 932.483 271.698 928.612 280.984 924.741 290.271 924.974 299.789 921.057 306.893 917.139 313.997 912.568 319.198 905.106 323.609 897.644 328.02 885.984 332.57 876.283 333.359 866.582 334.149 851.751 331.502 846.9 328.345Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.558 244.036C735.197 241.847 721.643 239.099 715.077 238.167 708.511 237.236 707.854 237.235 700.163 238.447 692.471 239.658 679.966 242.011 668.927 245.434 657.889 248.856 642.135 255.026 633.932 258.982 625.728 262.938 621.022 266.834 619.705 269.169 618.388 271.504 623.751 271.085 626.03 272.993 628.31 274.9 629.374 275.824 633.384 280.612 637.395 285.4 644.264 295.008 650.094 301.721 655.924 308.435 660.817 314.343 668.365 320.892 675.912 327.44 686.374 336.03 695.379 341.014 704.383 345.998 713.247 349.398 722.393 350.795 731.538 352.193 743.404 351.401 750.251 349.398 757.099 347.395 759.678 345.905 765.166 343.809L783.175 336.822C790.961 333.748 809.439 333.701 811.878 325.363 814.317 317.026 809.58 299.139 797.808 286.796 786.036 274.452 750.58 258.476 741.247 251.302 731.914 244.129 743.92 246.225 739.558 244.036Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.63 141.7C880.689 140.706 881.806 143.629 883.159 145.91 884.512 148.19 886.276 152.284 887.746 155.383 889.217 158.482 889.687 159.418 891.981 164.505 894.274 169.592 899.274 178.714 901.508 185.906 903.743 193.098 905.037 199.004 905.39 207.659 905.743 216.313 905.272 228.651 903.626 237.831 901.979 247.012 899.332 255.081 895.51 262.741 891.687 270.401 887.452 278.354 880.689 283.792 873.925 289.23 860.281 293.323 854.929 295.37 849.577 297.416 845.46 298.586 848.577 296.071 851.694 293.557 866.809 286.423 873.631 280.283 880.454 274.144 885.747 266.366 889.511 259.233 893.275 252.099 895.98 246.369 896.215 237.48 896.45 228.592 893.216 214.734 890.922 205.904 888.629 197.075 884.629 190.993 882.453 184.503 880.277 178.012 879.042 172.516 877.866 166.961 876.69 161.406 876.572 156.026 876.807 151.874 877.042 147.723 878.572 142.694 879.63 141.7Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.514 326.26C766.327 329.369 768.052 341.189 770.71 347.452 773.367 353.716 777.237 358.99 782.459 363.841 787.68 368.691 794.394 373.966 802.04 376.556 809.686 379.146 820.177 379.805 828.335 379.381 836.494 378.957 844.094 376.885 850.994 374.013 857.894 371.14 864.888 367.373 869.736 362.145 874.585 356.918 878.734 349.383 880.086 342.649 881.439 335.915 879.154 325.931 877.849 321.74 876.543 317.548 875.611 317.548 872.254 317.501 868.897 317.454 862.883 318.773 857.708 321.457 852.533 324.141 845.446 329.463 841.203 333.607 836.961 337.751 834.676 343.308 832.252 346.322 829.827 349.336 828.102 350.466 826.657 351.691 825.212 352.915 825.025 353.574 823.58 353.669 822.135 353.763 819.384 353.056 817.985 352.256 816.586 351.455 816.4 350.137 815.188 348.865 813.976 347.594 812.95 346.275 810.712 344.627 808.474 342.978 805.117 340.624 801.761 338.976 798.404 337.327 794.021 335.679 790.571 334.737 787.121 333.795 784.184 334.313 781.06 333.324 777.936 332.335 773.927 330.169 771.829 328.803 769.731 327.438 766.7 323.152 766.514 326.26Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.13 171.627C694.841 176.452 699.089 187.984 701.949 198.329 704.809 208.674 707.037 222.577 709.287 233.695 711.537 244.814 712.137 253.695 715.449 265.039 718.762 276.384 722.903 292.269 729.163 301.762 735.423 311.256 743.331 318.908 753.01 321.999 762.689 325.091 778.166 322.842 787.238 320.313 796.309 317.783 804.632 312.771 807.437 306.822 810.243 300.872 806.923 290.332 804.071 284.617 801.219 278.902 794.438 275.576 790.324 272.531 786.209 269.486 781.299 270.704 779.382 266.348 777.465 261.991 779.195 252.622 778.821 246.392 778.447 240.161 778.26 234.165 777.138 228.965 776.015 223.766 774.285 219.643 772.088 215.193 769.89 210.743 768.3 207.089 763.951 202.264 759.603 197.439 753.197 190.834 745.996 186.243 738.795 181.652 728.274 177.53 720.746 174.719 713.218 171.908 705.596 169.894 700.827 169.379 696.057 168.864 689.418 166.803 692.13 171.627Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.927 249.272C672.145 259.317 702.064 294.799 716.105 308.757 730.146 322.716 735.395 328.064 749.173 333.021 762.952 337.978 788.409 338.5 798.776 338.5 809.143 338.5 810.324 334.587 811.373 333.021 812.423 331.456 806.649 331.586 805.075 329.108 803.5 326.629 803.763 321.933 801.925 318.15 800.088 314.367 799.563 311.888 794.052 306.409 788.541 300.93 778.699 291.669 768.857 285.277 759.015 278.884 747.992 273.536 735.001 268.057 722.01 262.578 701.276 255.664 690.91 252.403 680.543 249.142 677.131 248.881 672.801 248.489 668.47 248.098 657.71 239.227 664.927 249.272Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.5 170.5C693.646 170.745 695.791 170.989 700.082 174.169 704.373 177.349 712.26 183.749 717.245 189.579 722.231 195.409 726.767 202.176 729.995 209.147 733.224 216.119 734.572 222.315 736.615 231.407 738.659 240.498 742.255 256.112 742.255 263.694 742.255 271.277 742.459 268.505 742.5 272.5",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.492 108.5C754.513 110.2 754.534 111.9 753.986 114.153 753.437 116.406 752.424 117.922 751.2 122.019 749.976 126.115 748.246 132.915 746.642 138.732 745.038 144.549 743.434 149.793 741.577 156.921 739.72 164.049 737.019 174.454 735.5 181.5",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 142.5C882.739 148.512 885.978 154.524 888.221 160.474 890.463 166.424 891.418 171.431 892.955 178.202 894.491 184.973 896.526 192.934 897.44 201.101 898.353 209.267 898.644 219.936 898.436 227.2 898.229 234.463 897.398 239.798 896.194 244.682 894.99 249.565 893.412 252.273 891.211 256.5",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.5 101.5C888.16 104.617 888.82 107.735 889.975 111.46 891.129 115.184 892.248 118.621 894.429 123.848 896.61 129.075 900.843 137.222 903.061 142.823 905.278 148.425 906.669 151.013 907.733 157.455 908.797 163.897 909.744 174.134 909.444 181.475 909.143 188.816 907.174 196.348 905.928 201.5",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.5 309.5C927.929 305.219 935.359 300.938 942.526 295.201 949.693 289.464 957.166 281.255 963.503 275.076 969.839 268.898 974.69 263.867 980.546 258.129 986.402 252.392 993.438 245.331 998.639 240.653 1003.84 235.975 1007.77 232.753 1011.75 230.061 1015.73 227.369 1019.62 225.78 1022.5 224.5",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.522 144.5C978.191 150.748 977.64 156.951 977.529 161.515 977.419 166.079 977.64 167.895 977.86 171.883 978.081 175.871 978.343 180.782 978.853 185.442 979.363 190.102 980.477 196.335 980.918 199.845 981.359 203.354 981.5 203.841 981.5 206.5",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.5 352.5 885.753 352.242C888.793 352.027 891.217 351.812 894.741 351.21 898.266 350.607 902.981 349.403 906.902 348.628 910.824 347.854 914.305 346.822 918.27 346.563 922.236 346.305 926.466 346.908 930.695 347.08 934.925 347.252 938.759 347.295 943.649 347.596 948.54 347.897 954.268 348.284 960.04 348.887 965.812 349.489 972.642 350.693 978.282 351.21 983.922 351.726 989.077 351.941 993.879 351.984 998.682 352.027 1003.66 351.769 1007.1 351.468 1010.53 351.166 1011.15 350.994 1014.5 350.177",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.5 285.5C644.131 293.118 651.288 299.952 656.672 304.567 662.056 309.181 663.938 310.095 669.803 313.186 675.668 316.276 683.854 320.281 691.864 323.111 699.874 325.94 711.736 328.291 717.864 330.163 723.992 332.035 728.631 334.342 728.631 334.342 732.571 335.865 737.823 338.172 741.5 339.304 745.177 340.436 747.453 340.784 750.692 341.133 753.931 341.481 758.133 341.611 760.934 341.394 763.736 341.176 764.918 340.305 767.5 339.827",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.28 292.527C772.739 292.884 782.326 293.206 789.776 292.4 797.226 291.594 815.005 288.426 816.981 287.692 818.956 286.959 805.39 287.179 801.629 287.999 797.867 288.82 791.778 289.565 787.025 290.255 782.273 290.945 771.822 292.169 772.28 292.527Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.752 290.868C770.807 290.665 767.362 292.01 766.847 292.598 766.333 293.186 767.722 294.194 768.667 294.397 769.612 294.6 771.751 294.158 772.517 293.816 773.284 293.474 772.697 291.071 771.752 290.868Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.48 326.841C863.47 326.259 857.692 318.602 852.382 313.316 847.071 308.029 833.428 296.196 831.616 295.121 829.803 294.046 838.504 304.456 841.507 306.865 844.51 309.274 848.919 313.541 852.443 316.803 855.967 320.065 863.49 327.422 863.48 326.841Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.523 328.295C862.959 329.157 866.171 330.991 866.952 331.021 867.733 331.051 867.643 329.337 867.207 328.475 866.77 327.612 865.082 326.227 864.334 325.846 863.586 325.465 862.086 327.432 862.523 328.295Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.79 318.801C871.657 318.235 864.395 311.969 858.088 307.921 851.782 303.873 835.951 295.183 833.952 294.515 831.954 293.846 842.654 302.188 846.098 303.909 849.542 305.631 854.751 308.872 858.884 311.317 863.017 313.762 871.922 319.367 871.79 318.801Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.161 320.424C871.769 321.175 875.296 322.29 876.065 322.155 876.834 322.019 876.385 320.363 875.777 319.612 875.169 318.861 873.226 317.863 872.414 317.648 871.603 317.434 870.552 319.673 871.161 320.424Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.643 265.745C872.064 265.687 863.784 270.529 857.912 275.185 852.041 279.84 838.692 292.005 837.413 293.679 836.133 295.353 847.49 287.93 850.234 285.23 852.978 282.529 857.731 278.65 861.383 275.532 865.035 272.413 873.221 265.803 872.643 265.745Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.975 266.866C874.882 266.533 877.079 263.558 877.2 262.786 877.321 262.014 875.609 261.903 874.702 262.235 873.794 262.568 872.22 264.082 871.754 264.78 871.289 265.479 873.067 267.198 873.975 266.866Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.983 278.961C877.463 278.702 868.006 280.31 860.869 282.594 853.732 284.878 836.949 291.548 835.161 292.663 833.373 293.778 846.619 290.841 850.14 289.283 853.66 287.724 859.476 285.773 863.994 284.144 868.511 282.515 878.504 279.219 877.983 278.961Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.834 280.479C879.8 280.489 882.906 278.48 883.292 277.801 883.677 277.121 882.115 276.413 881.148 276.404 880.182 276.394 878.175 277.256 877.492 277.745 876.81 278.234 877.867 280.47 878.834 280.479Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.429 311.169C875.211 310.63 867.068 305.56 860.213 302.534 853.357 299.509 836.374 293.367 834.296 293.015 832.219 292.662 844.079 299.252 847.747 300.422 851.415 301.591 857.062 303.989 861.523 305.767 865.984 307.545 875.648 311.708 875.429 311.169Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.058 312.87C875.775 313.518 879.432 314.075 880.171 313.822 880.91 313.57 880.211 312.003 879.494 311.355 878.777 310.707 876.704 310.02 875.869 309.934 875.034 309.847 874.341 312.222 875.058 312.87Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.497 260.97C867.917 260.942 859.899 266.208 854.278 271.163 848.656 276.118 835.958 288.96 834.767 290.698 833.576 292.437 844.532 284.433 847.132 281.594 849.732 278.754 854.277 274.633 857.762 271.329 861.246 268.025 869.078 260.998 868.497 260.97Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.886 262.02C870.775 261.641 872.814 258.555 872.895 257.778 872.976 257.001 871.26 256.979 870.371 257.358 869.482 257.737 867.989 259.332 867.56 260.053 867.131 260.775 868.997 262.399 869.886 262.02Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.671 272.372C875.114 272.207 866.071 275.406 859.429 278.875 852.786 282.344 837.389 291.782 835.818 293.186 834.246 294.59 846.796 289.434 849.999 287.298 853.201 285.161 858.599 282.245 862.772 279.868 866.945 277.492 876.228 272.538 875.671 272.372Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.768 273.724C877.722 273.568 880.439 271.058 880.703 270.323 880.967 269.588 879.307 269.156 878.353 269.312 877.399 269.468 875.569 270.66 874.98 271.258 874.391 271.857 875.815 273.879 876.768 273.724Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.391 287.635C878.909 287.31 869.323 287.648 861.946 288.965 854.569 290.281 837.049 294.665 835.129 295.533 833.208 296.4 846.727 295.248 850.423 294.17 854.119 293.093 860.143 291.931 864.837 290.915 869.531 289.9 879.872 287.96 879.391 287.635Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.032 289.253C880.989 289.391 884.333 287.812 884.806 287.19 885.279 286.568 883.824 285.658 882.867 285.521 881.91 285.383 879.807 285.971 879.065 286.365 878.324 286.759 879.075 289.116 880.032 289.253Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.123 296.273C875.732 295.843 866.337 293.907 858.858 293.443 851.379 292.979 833.319 293.099 831.248 293.488 829.177 293.878 842.586 295.952 846.432 295.778 850.278 295.605 856.406 295.899 861.206 296.022 866.007 296.145 876.514 296.703 876.123 296.273Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.364 297.997C877.261 298.357 880.884 297.613 881.49 297.12 882.096 296.627 880.898 295.4 880.001 295.04 879.104 294.68 876.921 294.754 876.107 294.962 875.294 295.17 875.467 297.637 876.364 297.997Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.761 256.58C860.207 256.758 854.553 264.507 851.032 271.121 847.511 277.736 840.138 294.222 839.634 296.268 839.13 298.315 846.573 286.97 848.009 283.398 849.444 279.826 852.251 274.37 854.352 270.052 856.452 265.734 861.314 256.402 860.761 256.58Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.429 257.075C863.128 256.407 863.953 252.802 863.755 252.046 863.558 251.29 861.944 251.872 861.245 252.54 860.546 253.207 859.709 255.225 859.561 256.051 859.413 256.877 861.73 257.742 862.429 257.075Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.334 331.393C855.416 330.817 850.931 322.338 846.529 316.274 842.128 310.21 830.542 296.356 828.924 295.006 827.306 293.656 834.239 305.319 836.82 308.175 839.402 311.031 843.075 315.945 846.035 319.727 848.995 323.508 855.251 331.968 855.334 331.393Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.157 332.676C854.451 333.597 857.33 335.918 858.096 336.072 858.862 336.226 859.046 334.52 858.753 333.599 858.459 332.678 857.013 331.042 856.335 330.546 855.657 330.051 853.864 331.755 854.157 332.676Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.128 329.9C850.281 329.339 846.892 320.366 843.284 313.798 839.675 307.231 829.914 292.036 828.477 290.495 827.041 288.953 832.46 301.391 834.664 304.548 836.868 307.705 839.897 313.04 842.361 317.162 844.825 321.284 849.974 330.46 850.128 329.9Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.8 331.025C848.976 331.976 851.542 334.639 852.283 334.888 853.023 335.136 853.42 333.467 853.244 332.516 853.068 331.566 851.838 329.761 851.227 329.185 850.616 328.609 848.624 330.075 848.8 331.025Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.19 331.251C842.411 330.714 840.151 321.392 837.378 314.43 834.605 307.469 826.786 291.189 825.55 289.483 824.314 287.776 828.162 300.787 829.961 304.191 831.76 307.594 834.11 313.262 836.049 317.655 837.987 322.049 841.968 331.789 842.19 331.251Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.734 332.205C840.792 333.17 843.011 336.129 843.715 336.466 844.42 336.804 845.018 335.196 844.96 334.232 844.903 333.267 843.904 331.324 843.369 330.677 842.833 330.031 840.676 331.24 840.734 332.205Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.41 271.41C777.573 271.968 785.165 277.83 791.682 281.53 798.198 285.229 814.478 293.047 816.51 293.606 818.542 294.165 807.404 286.417 803.872 284.885 800.34 283.353 794.963 280.399 790.703 278.182 786.443 275.965 777.247 270.852 777.41 271.41Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.95 269.755C777.302 269.038 773.72 268.116 772.959 268.293 772.198 268.47 772.736 270.099 773.384 270.816 774.033 271.533 776.027 272.424 776.849 272.594 777.671 272.765 778.598 270.472 777.95 269.755Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.447 283.271C771.839 283.7 781.235 285.629 788.715 286.087 796.194 286.545 814.254 286.411 816.324 286.02 818.395 285.629 804.985 283.565 801.139 283.742 797.293 283.919 791.165 283.629 786.364 283.51 781.563 283.391 771.056 282.841 771.447 283.271Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.205 281.547C770.308 281.188 766.685 281.935 766.079 282.428 765.474 282.921 766.673 284.148 767.571 284.507 768.468 284.866 770.651 284.79 771.464 284.582 772.277 284.373 772.102 281.906 771.205 281.547Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.952 297.962C771.407 298.324 780.99 298.732 788.448 297.994 795.905 297.256 813.712 294.249 815.694 293.533 817.676 292.818 804.109 292.915 800.34 293.701 796.571 294.488 790.475 295.178 785.717 295.825 780.958 296.471 770.497 297.601 770.952 297.962Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.438 296.299C769.495 296.088 766.038 297.401 765.518 297.985 764.999 298.568 766.378 299.588 767.321 299.8 768.264 300.011 770.408 299.589 771.177 299.254 771.947 298.919 771.381 296.511 770.438 296.299Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.943 316.338C776.5 316.505 785.547 313.318 792.195 309.859 798.842 306.4 814.252 296.983 815.826 295.582 817.4 294.18 804.842 299.318 801.636 301.45 798.431 303.582 793.029 306.49 788.852 308.861 784.676 311.231 775.386 316.172 775.943 316.338Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.847 314.985C773.893 315.14 771.173 317.646 770.907 318.38 770.642 319.115 772.302 319.549 773.256 319.395 774.21 319.24 776.043 318.051 776.632 317.453 777.222 316.856 775.801 314.831 774.847 314.985Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.096 324.472C781.671 324.557 790.167 320.105 796.249 315.728 802.331 311.35 816.231 299.82 817.587 298.207 818.944 296.594 807.253 303.481 804.387 306.051 801.52 308.621 796.591 312.274 792.799 315.22 789.006 318.165 780.521 324.387 781.096 324.472Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.817 323.29C778.895 323.58 776.562 326.45 776.405 327.216 776.249 327.981 777.953 328.172 778.876 327.882 779.798 327.592 781.44 326.153 781.938 325.477 782.436 324.801 780.739 323.001 779.817 323.29Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.933 341.557C811.425 341.247 814.976 332.336 816.743 325.054 818.51 317.772 821.554 299.971 821.533 297.863 821.513 295.756 817.122 308.594 816.62 312.411 816.117 316.228 814.754 322.21 813.793 326.915 812.831 331.62 810.442 341.867 810.933 341.557Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.194 341.492C808.682 342.313 808.78 346.01 809.159 346.693 809.538 347.376 810.957 346.411 811.468 345.591 811.979 344.77 812.289 342.608 812.227 341.771 812.164 340.934 809.705 340.672 809.194 341.492Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.978 337.832C798.534 337.663 804.322 330.013 807.957 323.461 811.591 316.908 819.248 300.551 819.787 298.514 820.326 296.477 812.688 307.691 811.191 311.238 809.694 314.785 806.794 320.191 804.619 324.472 802.444 328.754 797.422 338 797.978 337.832Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.318 337.308C795.607 337.963 794.721 341.554 794.905 342.313 795.09 343.072 796.713 342.518 797.424 341.863 798.134 341.207 799.006 339.205 799.168 338.381 799.33 337.557 797.028 336.652 796.318 337.308Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.239 331.706C789.819 331.668 797.191 325.531 802.218 319.974 807.244 314.417 818.412 300.224 819.399 298.362 820.386 296.5 810.403 305.689 808.141 308.803 805.878 311.918 801.827 316.526 798.737 320.202 795.648 323.878 788.659 331.744 789.239 331.706Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.741 330.819C786.9 331.297 785.222 334.593 785.23 335.374 785.237 336.155 786.944 335.984 787.785 335.507 788.625 335.029 789.929 333.277 790.273 332.511 790.618 331.746 788.581 330.342 787.741 330.819Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.801 309.033C775.332 309.269 784.713 307.265 791.747 304.683 798.782 302.101 815.269 294.73 817.009 293.541 818.749 292.352 805.638 295.843 802.186 297.548 798.734 299.254 793.005 301.448 788.56 303.266 784.115 305.084 774.27 308.797 774.801 309.033Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.887 307.551C772.921 307.583 769.903 309.721 769.546 310.415 769.189 311.11 770.78 311.753 771.746 311.721 772.712 311.69 774.682 310.744 775.343 310.227 776.004 309.71 774.853 307.52 773.887 307.551Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.781 339.655C840.044 339.136 838.524 329.665 836.307 322.508 834.089 315.35 827.575 298.506 826.477 296.707 825.378 294.909 828.192 308.182 829.718 311.716 831.243 315.251 833.141 321.086 834.728 325.618 836.315 330.15 839.518 340.173 839.781 339.655Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.254 340.491C838.236 341.458 840.216 344.582 840.892 344.974 841.567 345.366 842.29 343.81 842.309 342.844 842.327 341.877 841.484 339.862 841.001 339.175 840.519 338.489 838.273 339.525 838.254 340.491Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.676 340.546C832.001 340.064 831.657 330.478 830.337 323.102 829.016 315.726 824.623 298.209 823.754 296.289 822.886 294.369 824.046 307.887 825.125 311.583 826.205 315.278 827.37 321.301 828.388 325.995 829.405 330.688 831.351 341.029 831.676 340.546Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.058 341.189C829.921 342.146 831.502 345.489 832.124 345.962 832.747 346.434 833.656 344.979 833.792 344.022 833.929 343.065 833.341 340.962 832.946 340.221 832.552 339.48 830.195 340.232 830.058 341.189Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.703 342.37C826.071 341.919 826.6 332.342 825.957 324.876 825.313 317.41 822.531 299.566 821.84 297.575 821.15 295.584 821.076 309.152 821.814 312.93 822.553 316.709 823.166 322.813 823.752 327.579 824.339 332.346 825.336 342.82 825.703 342.37Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.034 342.862C823.81 343.803 825.08 347.277 825.657 347.803 826.234 348.33 827.271 346.964 827.495 346.023 827.718 345.083 827.323 342.935 826.998 342.161 826.672 341.387 824.257 341.922 824.034 342.862Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.526 342.747C817.946 342.345 819.649 332.905 819.929 325.417 820.208 317.929 819.642 299.878 819.201 297.817 818.761 295.757 817.018 309.212 817.287 313.053 817.555 316.893 817.413 323.027 817.409 327.829 817.405 332.631 817.106 343.149 817.526 342.747Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.808 343.031C815.471 343.936 816.304 347.54 816.812 348.134 817.319 348.727 818.517 347.499 818.854 346.593 819.192 345.687 819.064 343.507 818.836 342.699 818.608 341.891 816.146 342.125 815.808 343.031Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.708 303.971C772.229 304.231 781.688 302.64 788.829 300.369 795.97 298.099 812.765 291.459 814.556 290.348 816.346 289.236 803.094 292.148 799.571 293.7 796.048 295.252 790.228 297.193 785.707 298.814 781.187 300.435 771.188 303.712 771.708 303.971Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.86 302.451C769.894 302.44 766.785 304.443 766.398 305.122 766.011 305.8 767.572 306.512 768.538 306.523 769.505 306.534 771.514 305.676 772.197 305.188 772.88 304.7 771.827 302.462 770.86 302.451Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.136 276.97C781.499 277.424 790.75 279.96 798.184 280.903 805.618 281.846 823.648 282.886 825.74 282.631 827.831 282.376 814.584 279.444 810.735 279.37 806.886 279.297 800.789 278.61 796.006 278.179 791.223 277.748 780.773 276.516 781.136 276.97Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.007 275.234C780.134 274.818 776.471 275.327 775.835 275.78 775.198 276.233 776.315 277.535 777.187 277.951 778.06 278.368 780.243 278.434 781.068 278.279 781.893 278.124 781.879 275.651 781.007 275.234Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.895 331.494C862.02 330.926 858.175 322.138 854.235 315.764 850.294 309.39 839.767 294.716 838.253 293.25 836.739 291.784 842.789 303.929 845.152 306.968 847.515 310.008 850.814 315.181 853.486 319.171 856.158 323.161 861.77 332.061 861.895 331.494Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.627 332.686C860.851 333.626 863.551 336.154 864.303 336.365 865.055 336.575 865.366 334.887 865.141 333.947 864.917 333.007 863.596 331.268 862.956 330.724 862.317 330.18 860.402 331.746 860.627 332.686Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.842 325.6C871.844 325.018 866.233 317.239 861.037 311.839 855.841 306.44 842.455 294.316 840.666 293.202 838.877 292.089 847.353 302.684 850.303 305.157 853.254 307.63 857.57 311.991 861.023 315.327 864.477 318.664 871.84 326.181 871.842 325.6Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.854 327.032C871.272 327.904 874.444 329.806 875.223 329.853 876.003 329.9 875.951 328.185 875.533 327.313 875.115 326.442 873.457 325.02 872.717 324.623 871.977 324.226 870.436 326.161 870.854 327.032Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.973 274.187C884.424 273.997 875.247 276.787 868.455 279.954 861.664 283.122 845.859 291.86 844.226 293.192 842.593 294.524 855.362 289.936 858.657 287.946 861.953 285.955 867.476 283.284 871.751 281.097 876.026 278.91 885.522 274.377 884.973 274.187Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.009 275.586C886.969 275.473 889.796 273.088 890.092 272.365 890.389 271.643 888.75 271.137 887.79 271.25 886.83 271.363 884.948 272.472 884.333 273.043 883.718 273.614 885.049 275.699 886.009 275.586Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.104 288.281C886.657 287.909 877.086 287.281 869.614 287.847 862.142 288.414 844.27 291.012 842.272 291.682 840.274 292.351 853.84 292.566 857.626 291.866 861.412 291.166 867.522 290.617 872.294 290.079 877.066 289.542 887.551 288.653 887.104 288.281Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.579 289.956C888.517 290.189 892.004 288.955 892.537 288.383 893.07 287.812 891.714 286.76 890.776 286.527 889.838 286.294 887.686 286.667 886.909 286.985 886.132 287.302 886.641 289.722 887.579 289.956Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.499 319.464C877.412 318.895 870.676 312.146 864.717 307.661 858.759 303.176 843.684 293.367 841.747 292.552 839.81 291.736 849.805 300.8 853.097 302.767 856.39 304.734 861.32 308.339 865.242 311.073 869.163 313.808 877.587 320.032 877.499 319.464Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.653 321.3C877.266 322.129 881.108 323.574 881.979 323.497 882.851 323.42 882.496 321.666 881.882 320.838 881.269 320.009 879.187 318.815 878.299 318.526 877.411 318.237 876.04 320.472 876.653 321.3Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.048 268.581C881.489 268.419 872.47 271.683 865.852 275.2 859.235 278.716 843.906 288.264 842.344 289.679 840.783 291.094 853.296 285.849 856.483 283.689 859.67 281.53 865.047 278.575 869.203 276.169 873.359 273.763 882.606 268.743 882.048 268.581Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.155 269.925C884.108 269.762 886.807 267.233 887.065 266.496 887.324 265.759 885.661 265.339 884.708 265.502 883.755 265.665 881.933 266.87 881.349 267.472 880.764 268.075 882.202 270.087 883.155 269.925Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.382 281.336C885.879 281.046 876.34 282.061 869.075 283.896 861.809 285.73 844.644 291.342 842.789 292.343 840.935 293.344 854.339 291.238 857.949 289.903 861.56 288.567 867.487 286.981 872.097 285.637 876.707 284.293 886.886 281.626 886.382 281.336Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.137 282.905C888.101 282.974 891.326 281.163 891.753 280.509 892.18 279.855 890.665 279.051 889.701 278.981 888.737 278.912 886.68 279.647 885.968 280.092 885.257 280.538 886.173 282.835 887.137 282.905Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.462 297.045C886.069 296.617 876.665 294.724 869.184 294.294 861.703 293.864 843.644 294.067 841.575 294.466 839.506 294.864 852.923 296.877 856.769 296.686 860.614 296.495 866.743 296.761 871.544 296.862 876.345 296.963 886.855 297.473 886.462 297.045Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.711 298.768C887.61 299.124 891.229 298.363 891.833 297.868 892.437 297.372 891.233 296.15 890.334 295.795 889.435 295.439 887.253 295.523 886.44 295.734 885.628 295.946 885.812 298.413 886.711 298.768Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.28 304.69C880.999 304.182 872.309 300.12 865.142 297.935 857.974 295.749 840.379 291.679 838.274 291.577 836.169 291.476 848.731 296.602 852.513 297.325 856.294 298.048 862.187 299.755 866.829 300.987 871.47 302.22 881.562 305.199 881.28 304.69Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.115 306.423C881.905 306.981 885.601 307.098 886.305 306.759 887.009 306.42 886.128 304.948 885.339 304.39 884.549 303.832 882.409 303.398 881.569 303.412 880.73 303.425 880.326 305.865 881.115 306.423Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.915 334.033C853.129 333.493 850.732 324.205 847.856 317.285 844.981 310.365 836.923 294.203 835.662 292.514 834.401 290.826 838.44 303.779 840.289 307.156 842.138 310.533 844.572 316.164 846.575 320.529 848.578 324.893 852.702 334.574 852.915 334.033Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.474 335.008C851.546 335.972 853.808 338.898 854.518 339.225 855.227 339.553 855.802 337.936 855.73 336.972 855.658 336.008 854.63 334.081 854.086 333.442 853.541 332.803 851.401 334.045 851.474 335.008Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.197 331.373C848.477 330.864 847.26 321.349 845.273 314.124 843.285 306.899 837.313 289.855 836.273 288.022 835.233 286.19 837.621 299.546 839.032 303.128 840.444 306.709 842.154 312.601 843.596 317.182 845.037 321.763 847.918 331.883 848.197 331.373Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.645 332.161C846.595 333.126 848.474 336.312 849.137 336.725 849.8 337.139 850.572 335.607 850.622 334.641 850.671 333.676 849.893 331.635 849.432 330.933 848.972 330.231 846.694 331.195 846.645 332.161Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.162 330.848C840.503 330.377 840.465 320.784 839.382 313.37 838.298 305.955 834.467 288.306 833.66 286.36 832.853 284.413 833.58 297.961 834.541 301.689 835.502 305.418 836.474 311.475 837.341 316.198 838.208 320.922 839.822 331.319 840.162 330.848Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.525 331.438C838.357 332.39 839.83 335.783 840.437 336.275 841.044 336.767 841.999 335.341 842.166 334.389 842.334 333.438 841.813 331.316 841.442 330.563 841.071 329.81 838.692 330.486 838.525 331.438Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.022 257.618C791.051 258.198 797.077 265.661 802.559 270.771 808.04 275.88 822.064 287.26 823.911 288.275 825.757 289.289 816.72 279.17 813.639 276.861 810.558 274.552 806.012 270.432 802.383 267.287 798.753 264.143 790.993 257.037 791.022 257.618Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.931 256.133C791.467 255.285 788.196 253.558 787.415 253.554 786.634 253.55 786.779 255.259 787.244 256.107 787.708 256.954 789.441 258.284 790.201 258.64 790.962 258.996 792.396 256.981 791.931 256.133Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.472 267.773C782.753 268.282 791.446 272.336 798.616 274.516 805.785 276.696 823.383 280.753 825.488 280.852 827.593 280.952 815.027 275.836 811.245 275.116 807.463 274.396 801.569 272.693 796.927 271.465 792.284 270.236 782.19 267.264 782.472 267.773Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.636 266.04C781.846 265.483 778.149 265.369 777.446 265.708 776.742 266.048 777.624 267.519 778.414 268.077 779.204 268.634 781.345 269.066 782.184 269.052 783.023 269.038 783.426 266.597 782.636 266.04Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.584 281.95C778.943 282.407 788.17 285.026 795.595 286.037 803.02 287.048 821.04 288.251 823.134 288.015 825.228 287.778 812.007 284.727 808.159 284.618 804.311 284.51 798.221 283.767 793.442 283.293 788.663 282.819 778.225 281.492 778.584 281.95Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.47 280.213C777.601 279.788 773.933 280.264 773.293 280.711 772.652 281.159 773.758 282.471 774.626 282.895 775.494 283.32 777.677 283.406 778.503 283.258 779.33 283.11 779.338 280.637 778.47 280.213Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.178 300.982C779.681 301.273 789.221 300.271 796.489 298.447 803.757 296.623 820.931 291.036 822.787 290.038 824.643 289.039 811.236 291.125 807.623 292.456 804.011 293.787 798.082 295.364 793.47 296.701 788.857 298.039 778.675 300.691 779.178 300.982Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.426 299.412C777.462 299.341 774.235 301.148 773.807 301.801 773.378 302.454 774.892 303.261 775.856 303.332 776.82 303.403 778.878 302.671 779.59 302.226 780.302 301.782 779.39 299.483 778.426 299.412Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.305 310.089C782.844 310.304 792.142 307.944 799.073 305.096 806.004 302.248 822.198 294.255 823.892 293 825.585 291.746 812.616 295.734 809.232 297.569 805.848 299.405 800.206 301.816 795.834 303.802 791.461 305.787 781.765 309.873 782.305 310.089Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.335 308.643C780.371 308.711 777.436 310.962 777.106 311.67 776.776 312.378 778.39 312.959 779.354 312.891 780.318 312.823 782.25 311.803 782.891 311.261 783.532 310.719 782.299 308.575 781.335 308.643Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.368 333.626C807.918 333.438 813.439 325.594 816.846 318.92 820.253 312.246 827.341 295.635 827.81 293.581 828.279 291.526 821.031 302.996 819.657 306.593 818.283 310.189 815.571 315.692 813.545 320.046 811.518 324.4 806.818 333.814 807.368 333.626Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.691 333.16C805.004 333.839 804.241 337.458 804.452 338.211 804.662 338.963 806.266 338.353 806.953 337.674 807.641 336.994 808.443 334.963 808.577 334.134 808.71 333.305 806.378 332.48 805.691 333.16Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.63 326.998C796.21 326.963 803.613 320.864 808.668 315.333 813.723 309.801 824.964 295.666 825.96 293.809 826.957 291.952 816.927 301.089 814.648 304.193 812.37 307.296 808.295 311.882 805.187 315.543 802.078 319.203 795.049 327.033 795.63 326.998Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.136 326.104C793.293 326.577 791.598 329.864 791.602 330.645 791.605 331.427 793.313 331.264 794.156 330.791 794.999 330.318 796.311 328.572 796.66 327.809 797.009 327.045 794.979 325.631 794.136 326.104Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.549 319.014C789.122 319.111 797.716 314.851 803.894 310.61 810.072 306.37 824.226 295.153 825.618 293.571 827.01 291.989 815.169 298.612 812.246 301.117 809.322 303.623 804.313 307.165 800.456 310.025 796.598 312.885 787.976 318.916 788.549 319.014Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.297 317.804C786.369 318.073 783.972 320.89 783.798 321.652 783.624 322.413 785.325 322.643 786.253 322.373 787.181 322.104 788.856 320.701 789.368 320.037 789.881 319.372 788.225 317.535 787.297 317.804Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.761 293.611C780.223 293.964 789.813 294.189 797.254 293.308 804.696 292.427 822.443 289.08 824.411 288.327 826.379 287.573 812.816 287.93 809.063 288.789 805.31 289.647 799.228 290.453 794.482 291.191 789.737 291.929 779.299 293.258 779.761 293.611Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.216 291.958C778.269 291.765 774.837 293.144 774.329 293.737 773.821 294.331 775.22 295.324 776.167 295.518 777.114 295.711 779.248 295.248 780.011 294.898 780.774 294.548 780.163 292.151 779.216 291.958Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.871 338.464C836.247 338.021 836.964 328.455 836.466 320.979 835.969 313.502 833.537 295.606 832.886 293.602 832.235 291.598 831.895 305.162 832.559 308.954 833.224 312.746 833.717 318.861 834.21 323.638 834.703 328.415 835.495 338.907 835.871 338.464Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.192 338.924C833.95 339.86 835.152 343.358 835.718 343.896 836.284 344.434 837.348 343.088 837.59 342.152 837.832 341.216 837.479 339.061 837.169 338.281 836.859 337.501 834.434 337.988 834.192 338.924Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.78 337.452C828.208 337.059 830.096 327.654 830.522 320.173 830.948 312.691 830.735 294.633 830.335 292.564 829.935 290.495 827.93 303.914 828.123 307.759 828.316 311.604 828.053 317.733 827.955 322.534 827.857 327.336 827.352 337.846 827.78 337.452Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.057 337.702C825.702 338.601 826.464 342.22 826.96 342.824 827.456 343.427 828.678 342.223 829.033 341.324 829.388 340.425 829.303 338.242 829.091 337.43 828.879 336.618 826.412 336.803 826.057 337.702Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.547 337.841C822.009 337.488 824.745 328.294 825.849 320.883 826.954 313.471 828.385 295.468 828.175 293.371 827.965 291.275 824.747 304.455 824.59 308.302 824.432 312.149 823.613 318.229 823.079 323.001 822.544 327.774 821.085 338.194 821.547 337.841Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.809 337.933C819.374 338.796 819.803 342.47 820.242 343.116 820.681 343.762 822.007 342.674 822.443 341.811 822.878 340.948 822.992 338.766 822.855 337.938 822.717 337.11 820.244 337.07 819.809 337.933Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.505 336.312C814.007 336.019 817.853 327.231 819.86 320.012 821.868 312.792 825.502 295.102 825.552 292.995 825.601 290.888 820.787 303.573 820.157 307.371 819.528 311.169 817.967 317.103 816.85 321.773 815.733 326.444 813.003 336.606 813.505 336.312Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.769 336.19C811.231 336.993 811.205 340.691 811.561 341.386 811.918 342.082 813.367 341.164 813.906 340.362 814.444 339.559 814.825 337.408 814.791 336.569 814.756 335.73 812.307 335.387 811.769 336.19Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.926 287.97C778.372 288.343 787.943 288.989 795.416 288.436 802.889 287.883 820.765 285.318 822.765 284.652 824.764 283.986 811.198 283.746 807.411 284.439 803.624 285.132 797.512 285.671 792.739 286.199 787.966 286.728 777.48 287.597 777.926 287.97Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.454 286.295C776.516 286.06 773.027 287.288 772.494 287.858 771.96 288.428 773.314 289.482 774.251 289.717 775.189 289.952 777.342 289.583 778.119 289.267 778.897 288.951 778.392 286.53 777.454 286.295Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.974 443.868C826.314 444.236 824.593 444.787 822.073 446.075 819.552 447.362 815.926 449.937 812.852 451.592 809.779 453.248 807.467 454.042 803.632 456.006 799.796 457.971 794.694 459.884 789.84 463.38 784.985 466.876 779.397 471.283 774.504 476.982 769.61 482.68 764.211 489.146 760.48 497.572 756.749 505.998 753.304 517.16 752.117 527.538 750.931 537.915 751.514 549.522 753.361 559.839 755.208 570.155 758.253 580.617 763.199 589.436 768.145 598.256 776.545 606.977 783.038 612.756 789.531 618.534 796.367 621.314 802.156 624.107 807.946 626.9 813.35 627.736 817.776 629.513 822.201 631.291 826.09 633.53 828.711 634.774 831.333 636.019 832.154 636.552 833.506 636.981 834.858 637.411 835.596 637.288 836.825 637.349 838.055 637.411 839.407 637.656 840.882 637.349 842.358 637.043 844.386 636.184 845.677 635.51 846.968 634.836 846.968 634.223 848.628 633.303 850.287 632.383 853.381 631.033 855.635 629.992 857.889 628.952 860.31 627.917 862.154 627.058 863.998 626.2 864.774 625.948 866.7 624.843 868.625 623.738 871.531 621.859 873.707 620.429 875.883 618.999 877.48 618.163 879.754 616.263 882.029 614.362 883.259 613.604 887.353 609.026 891.448 604.448 899.953 595.906 904.319 588.795 908.685 581.683 911.52 574.817 913.548 566.357 915.577 557.897 916.615 547.23 916.49 538.034 916.366 528.838 915.261 519.335 912.802 511.182 910.343 503.028 907.024 496.162 901.737 489.112 896.451 482.061 887.23 474.521 881.083 468.881 874.937 463.241 870.572 459.133 864.856 455.271 859.139 451.409 851.148 447.669 846.784 445.707 842.419 443.745 840.575 443.623 838.669 443.5L832.031 443.868C830.248 443.929 829.633 443.5 827.974 443.868Z",
    stroke: "#213315",
    strokeMiterlimit: 8,
    fill: "#C5E0B4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.62 462.794C817.196 463.661 814.895 464.61 811.238 466.261 807.581 467.912 803.185 469.068 797.679 472.7 792.173 476.332 783.667 480.995 778.202 488.053 772.737 495.111 767.642 504.686 764.889 515.045 762.136 525.404 761.027 539.272 761.684 550.209 762.342 561.146 765.588 572.703 768.834 580.668 772.08 588.634 776.435 593.132 781.161 598.003 785.886 602.873 791.228 606.67 797.186 609.889 803.143 613.108 811.279 616.451 816.908 617.318 822.538 618.185 828.085 615.708 830.961 615.089 833.837 614.47 832.481 613.81 834.166 613.604 835.851 613.397 841.069 613.851 841.069 613.851 843.657 613.975 844.931 615.378 849.698 614.346 854.464 613.315 863.668 610.673 869.667 607.66 875.666 604.647 881.213 600.603 885.692 596.269 890.171 591.936 893.581 587.808 896.54 581.659 899.498 575.509 901.963 567.667 903.443 559.372 904.922 551.076 905.784 540.056 905.415 531.884 905.045 523.712 903.196 516.201 901.224 510.34 899.251 504.479 895.718 500.022 893.581 496.72 891.444 493.418 890.13 492.345 888.404 490.529 886.678 488.713 885.117 487.64 883.227 485.824 881.336 484.008 879.857 482.068 877.063 479.633 874.269 477.198 869.708 473.773 866.462 471.214 863.216 468.655 860.956 466.22 857.587 464.28 854.217 462.34 849.615 460.524 846.246 459.575 842.877 458.626 840.781 458.337 837.371 458.584 833.96 458.832 829.153 459.988 825.784 461.061 822.455 461.886 822.044 461.928 819.62 462.794Z",
    stroke: "#869644",
    strokeMiterlimit: 8,
    fill: "#E2F0D9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.145 604.5C840.324 603.1 843.151 603.425 843.801 600.778 844.451 598.13 843.963 592.547 844.044 588.617 844.126 584.688 844.126 580.841 844.288 577.201 844.451 573.562 844.491 569.756 845.019 566.778 845.547 563.8 846.279 562.436 847.457 559.333 848.635 556.231 851.194 553.625 852.088 548.166 852.981 542.706 852.697 532.117 852.819 526.575 852.941 521.033 852.575 518.137 852.819 514.911 853.063 511.685 853.956 511.023 854.281 507.218 854.606 503.413 854.566 495.678 854.769 492.08 854.972 488.481 855.5 487.571 855.5 485.627 855.5 483.683 855.174 482.607 854.769 480.416 854.363 478.224 853.919 474.215 853.066 472.478 852.213 470.741 851.113 470.655 849.65 469.993 848.187 469.33 846.116 469.083 844.288 468.504 842.46 467.924 840.916 466.311 838.682 466.518 836.448 466.725 832.873 468.545 830.883 469.744 828.892 470.944 827.917 471.109 826.739 473.715 825.561 476.321 824.627 481.491 823.814 485.379 823.002 489.267 822.514 493.61 821.864 497.043 821.214 500.476 820.646 504.488 819.914 505.977 819.183 507.466 818.533 504.902 817.477 505.977 816.421 507.053 814.105 510.94 813.577 512.429 813.049 513.918 813.455 514.911 814.308 514.911 815.162 514.911 817.965 512.429 818.696 512.429 819.427 512.429 819.386 513.381 818.696 514.911 818.005 516.441 815.568 519.337 814.552 521.612 813.537 523.887 813.374 527.154 812.602 528.56 811.831 529.967 810.409 528.312 809.921 530.049 809.434 531.787 809.393 536.212 809.677 538.984 809.962 541.755 810.896 543.533 811.627 546.677 812.359 549.82 812.968 554.99 814.065 557.844 815.162 560.698 817.68 561.567 818.208 563.8 818.736 566.034 817.355 568.102 817.233 571.246 817.111 574.389 817.883 577.946 817.477 582.661 817.071 587.376 814.877 596.145 814.796 599.537 814.715 602.928 816.799 600.749 816.99 603.011",
    stroke: "#213315",
    strokeMiterlimit: 8,
    fill: "#62983E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.222 76.3428C446.595 74.4664 446.752 72.9809 443.928 71.6517 441.105 70.3226 430.282 68.3679 430.282 68.3679 426.439 67.4296 422.439 68.1332 420.87 66.0223 419.302 63.9112 420.243 59.4548 420.87 55.7019 421.498 51.949 424.478 46.085 424.635 43.5049 424.792 40.9248 422.596 41.0029 421.811 40.2211 421.027 39.4393 420.243 39.9084 419.929 38.8138 419.616 37.7192 419.145 35.2954 419.929 33.6536 420.714 32.0117 422.753 29.9788 424.635 28.9624 426.517 27.9459 429.262 28.5715 431.223 27.555 433.184 26.5386 434.203 24.5058 436.399 22.864 438.595 21.2221 441.34 18.7202 444.399 17.7037 447.458 16.6873 451.379 16.1399 454.752 16.7655 458.124 17.3909 462.046 20.5184 464.634 21.4566 467.222 22.3949 468.947 22.3949 470.281 22.3949 471.614 22.3949 471.143 20.9876 472.633 21.4566 474.124 21.9257 477.104 24.6623 479.221 25.2096 481.339 25.7568 482.515 23.8021 485.339 24.7404 488.162 25.6786 493.025 30.2135 496.162 30.8389 499.299 31.4643 504.162 28.4933 504.162 28.4933 506.828 27.7114 509.417 26.3823 512.161 26.1477 514.906 25.9132 518.044 27.2423 520.632 27.086 523.22 26.9296 524.553 25.1314 527.69 25.2096 530.828 25.2877 535.925 26.2259 539.455 27.555 542.984 28.8842 545.729 32.4026 548.866 33.1845 552.003 33.9664 555.69 31.6208 558.278 32.2462 560.866 32.8717 562.591 35.3736 564.395 36.9373 566.199 38.501 566.277 39.7521 569.101 41.6285 571.924 43.5049 578.199 45.4596 581.336 48.1961 584.473 50.9325 585.963 56.0928 587.924 58.0474 589.884 60.002 590.747 59.533 593.1 59.9239 595.453 60.3148 599.453 59.6112 602.041 60.393 604.629 61.1748 607.453 63.1295 608.629 64.615 609.805 66.1005 608.943 67.6643 609.1 69.3061 609.256 70.948 608.55 72.2772 609.57 74.4664 610.59 76.6556 614.433 80.0175 615.217 82.4413 616.001 84.8651 614.982 87.2107 614.276 89.0089 613.57 90.8071 611.688 91.1981 610.982 93.2309 610.276 95.2637 610.511 98.3911 610.041 101.206 609.57 104.02 609.256 108.243 608.158 110.119 607.06 111.995 604.864 111.213 603.453 112.464 602.041 113.715 600.786 116.686 599.688 117.625 598.59 118.563 597.806 116.999 596.865 118.094 595.923 119.189 595.296 122.785 594.041 124.192 592.786 125.6 591.845 126.303 589.335 126.538L578.983 125.6C575.767 125.287 572.787 124.349 570.042 124.661 567.297 124.974 564.63 126.382 562.513 127.476 560.395 128.571 559.454 130.525 557.336 131.229 555.219 131.933 552.003 131.62 549.807 131.698 547.611 131.776 546.905 131.307 544.16 131.698 541.415 132.089 537.337 133.262 533.337 134.044 529.337 134.826 523.691 137.015 520.161 136.389 516.632 135.764 512.161 130.291 512.161 130.291 509.495 128.258 506.985 126.069 504.162 124.192 501.338 122.316 496.946 120.752 495.221 119.032 493.495 117.312 495.142 114.888 493.809 113.872 492.476 112.855 489.103 112.621 487.221 112.934 485.339 113.246 484.241 115.514 482.515 115.748 480.79 115.983 478.594 114.654 476.869 114.341 475.143 114.028 473.888 114.654 472.163 113.872 470.437 113.09 468.633 111.526 466.516 109.65 464.398 107.773 462.438 105.662 459.457 102.613 456.477 99.5639 450.595 94.6382 448.634 91.3544 446.673 88.0706 447.771 85.4905 447.693 82.9104 447.615 80.3303 447.85 78.2192 447.222 76.3428Z",
    stroke: "#385624",
    strokeMiterlimit: 8,
    fill: "#68A042",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.625 420.965C158.117 419.706 155.53 418.762 156.863 417.188 158.195 415.614 161.723 413.41 168.621 411.522 175.52 409.633 190.179 406.8 198.254 405.855 206.328 404.911 211.659 406.406 217.068 405.855 222.477 405.304 225.299 402.865 230.708 402.55 236.117 402.235 245.524 403.494 249.522 403.966 253.521 404.439 252.658 405.383 254.696 405.383 256.734 405.383 258.93 404.124 261.752 403.966 264.574 403.809 268.807 403.966 271.629 404.439 274.451 404.911 276.019 406.485 278.684 406.8 281.35 407.114 284.172 405.934 287.621 406.327 291.07 406.721 296.401 407.665 299.38 409.161 302.359 410.656 305.651 413.174 305.495 415.299 305.338 417.424 301.732 420.257 298.439 421.91 295.147 423.562 289.032 424.664 285.74 425.215 282.447 425.766 281.036 425.136 278.684 425.215 276.333 425.294 274.059 425.136 271.629 425.687 269.199 426.238 266.69 427.812 264.103 428.52 261.517 429.229 258.694 429.78 256.107 429.937 253.521 430.094 250.777 429.701 248.582 429.465 246.387 429.229 244.819 428.678 242.938 428.52 241.056 428.363 239.723 428.284 237.293 428.52 234.863 428.757 231.179 429.622 228.357 429.937 225.534 430.252 223.026 430.331 220.361 430.409 217.695 430.488 215.343 430.567 212.364 430.409 209.386 430.252 204.996 430.016 202.487 429.465 199.978 428.914 198.881 427.497 197.313 427.104 195.745 426.71 195.667 427.183 193.08 427.104 190.493 427.025 185.319 427.025 181.791 426.632 178.264 426.238 174.814 425.373 171.914 424.743 169.013 424.113 163.134 422.225 160.625 420.965Z",
    stroke: "#385624",
    strokeMiterlimit: 8,
    fill: "#68A042",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.232 97.3965C425.288 100.077 420.488 106.068 418.206 108.748 415.924 111.428 414.35 110.246 412.54 113.478 410.73 116.71 410.179 122.465 407.347 128.141 404.514 133.817 399.871 140.99 395.543 147.533 391.216 154.076 387.124 161.25 381.379 167.399 375.635 173.548 365.098 180.997 361.078 184.426 357.058 187.856 358.754 185.925 357.259 187.974 355.764 190.024 353.91 194.793 352.107 196.724 350.305 198.655 347.78 199.404 346.442 199.562 345.104 199.72 346.048 198.301 344.081 197.67 342.114 197.039 338.888 196.251 334.639 195.778 330.389 195.305 323.78 194.99 318.586 194.832 313.393 194.674 309.38 194.044 303.478 194.832 297.577 195.62 288.527 198.143 283.177 199.562 277.826 200.981 271.373 203.346 271.373 203.346 267.281 204.686 262.088 206.893 258.626 207.603 255.163 208.312 253.196 207.76 250.6 207.603 248.003 207.445 245.485 206.657 243.046 206.657 240.606 206.657 237.695 207.13 235.963 207.603 234.232 208.076 234.154 209.416 232.659 209.495 231.164 209.573 228.488 208.785 226.993 208.076 225.498 207.366 224.475 206.341 223.688 205.238 222.901 204.134 222.901 202.4 222.272 201.454 221.642 200.508 220.777 200.744 219.911 199.562 219.045 198.379 217.629 196.488 217.078 194.359 216.528 192.231 216.37 189.629 216.606 186.791 216.842 183.953 217 180.406 218.495 177.331 219.99 174.257 222.665 170.631 225.577 168.345 228.488 166.059 232.423 165.27 235.963 163.615 239.504 161.959 244.698 160.54 246.822 158.412 248.947 156.283 247.059 154.076 248.711 150.844 250.363 147.612 253.826 141.857 256.737 139.019 259.649 136.181 263.977 135.236 266.18 133.817 268.383 132.398 269.17 132.477 269.957 130.506 270.744 128.535 269.642 124.751 270.901 121.992 272.16 119.233 275.544 116.631 277.511 113.951 279.478 111.271 280.737 108.433 282.704 105.91 284.672 103.388 286.717 100.629 289.314 98.8154 291.911 97.0023 295.373 95.6622 298.285 95.0316 301.196 94.401 304.029 95.5835 306.783 95.0316 309.537 94.4797 312.291 91.9571 314.809 91.7206 317.327 91.4842 319.452 92.4302 321.891 93.6126 324.331 94.7951 326.927 97.4753 329.445 98.8154 331.963 100.156 334.245 102.599 336.999 101.653 339.753 100.707 343.452 95.1103 345.97 93.1396 348.488 91.1689 349.904 89.9864 352.107 89.8287 354.311 89.6711 355.963 92.3512 359.189 92.1936 362.416 92.0359 367.373 90.144 371.465 88.8827 375.557 87.6214 379.806 85.0988 383.74 84.6258 387.675 84.1529 392.081 85.0988 395.071 86.0448 398.061 86.9908 399.32 89.3557 401.681 90.3017 404.042 91.2477 406.796 91.8783 409.235 91.7206 411.674 91.563 413.878 89.198 416.317 89.3557 418.756 89.5133 422.297 91.1689 423.871 92.6666 425.445 94.1644 427.176 94.7162 426.232 97.3965Z",
    stroke: "#385624",
    strokeMiterlimit: 8,
    fill: "#68A042",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.175 291.027C793.497 291.278 800.239 291.504 805.478 290.937 810.716 290.371 823.219 288.143 824.608 287.627 825.997 287.111 816.458 287.266 813.813 287.843 811.168 288.42 806.885 288.944 803.543 289.429 800.202 289.914 792.853 290.775 793.175 291.027Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.803 289.86C792.139 289.717 789.716 290.663 789.354 291.077 788.993 291.49 789.969 292.199 790.634 292.342 791.298 292.484 792.803 292.174 793.342 291.933 793.881 291.693 793.468 290.003 792.803 289.86Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.306 315.156C857.299 314.747 853.236 309.363 849.501 305.645 845.767 301.928 836.173 293.607 834.899 292.851 833.624 292.095 839.743 299.415 841.854 301.109 843.966 302.803 847.066 305.804 849.544 308.098 852.023 310.391 857.313 315.564 857.306 315.156Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.633 316.178C856.939 316.785 859.198 318.074 859.747 318.095 860.296 318.116 860.233 316.911 859.926 316.305 859.619 315.699 858.432 314.724 857.906 314.456 857.38 314.188 856.326 315.572 856.633 316.178Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.149 309.502C863.056 309.104 857.949 304.698 853.514 301.852 849.08 299.005 837.947 292.895 836.542 292.424 835.137 291.954 842.661 297.82 845.083 299.03 847.504 300.241 851.167 302.52 854.074 304.24 856.98 305.959 863.242 309.9 863.149 309.502Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.707 310.644C863.134 311.172 865.614 311.956 866.155 311.861 866.696 311.765 866.381 310.601 865.953 310.073 865.525 309.545 864.159 308.843 863.588 308.692 863.018 308.541 862.279 310.115 862.707 310.644Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.749 272.194C863.342 272.153 857.519 275.558 853.39 278.832 849.262 282.105 839.875 290.659 838.975 291.837 838.075 293.014 846.062 287.794 847.991 285.895 849.92 283.996 853.263 281.269 855.831 279.076 858.399 276.883 864.155 272.234 863.749 272.194Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.685 272.982C865.324 272.748 866.868 270.656 866.953 270.113 867.039 269.57 865.835 269.492 865.197 269.726 864.558 269.959 863.452 271.024 863.124 271.515 862.797 272.007 864.047 273.215 864.685 272.982Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.504 281.487C867.138 281.305 860.488 282.436 855.47 284.042 850.451 285.648 838.65 290.338 837.392 291.122 836.135 291.906 845.449 289.841 847.925 288.745 850.4 287.649 854.49 286.277 857.667 285.132 860.844 283.986 867.871 281.669 867.504 281.487Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.103 282.555C868.782 282.561 870.966 281.149 871.237 280.671 871.509 280.194 870.41 279.695 869.73 279.689 869.051 279.682 867.639 280.288 867.159 280.632 866.68 280.976 867.423 282.548 868.103 282.555Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.708 304.136C865.555 303.757 859.829 300.191 855.008 298.064 850.188 295.936 838.245 291.617 836.784 291.37 835.323 291.122 843.663 295.756 846.242 296.578 848.822 297.4 852.793 299.087 855.93 300.337 859.067 301.587 865.862 304.514 865.708 304.136Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.448 305.332C865.952 305.787 868.523 306.179 869.043 306.002 869.563 305.824 869.071 304.722 868.567 304.267 868.063 303.811 866.604 303.328 866.017 303.267 865.43 303.206 864.943 304.876 865.448 305.332Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.834 268.836C860.426 268.816 854.788 272.52 850.835 276.004 846.882 279.488 837.953 288.518 837.115 289.741 836.278 290.963 843.982 285.335 845.81 283.339 847.638 281.342 850.834 278.444 853.285 276.121 855.735 273.797 861.242 268.855 860.834 268.836Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.81 269.574C862.435 269.308 863.869 267.138 863.926 266.591 863.983 266.045 862.777 266.029 862.151 266.296 861.526 266.563 860.476 267.684 860.175 268.191 859.873 268.699 861.185 269.841 861.81 269.574Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.878 276.854C865.486 276.738 859.128 278.987 854.457 281.427 849.786 283.866 838.959 290.503 837.854 291.49 836.749 292.477 845.574 288.852 847.826 287.349 850.078 285.847 853.874 283.796 856.808 282.125 859.742 280.454 866.27 276.971 865.878 276.854Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.65 277.804C867.321 277.695 869.231 275.93 869.417 275.413 869.603 274.896 868.435 274.593 867.764 274.702 867.094 274.812 865.806 275.65 865.392 276.071 864.978 276.491 865.979 277.914 866.65 277.804Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.494 287.587C868.155 287.358 861.414 287.596 856.227 288.522 851.039 289.447 838.72 292.53 837.369 293.14 836.019 293.75 845.525 292.94 848.124 292.182 850.723 291.425 854.959 290.607 858.26 289.893 861.561 289.18 868.833 287.815 868.494 287.587Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.945 288.725C869.618 288.821 871.97 287.711 872.302 287.274 872.634 286.836 871.611 286.197 870.939 286.1 870.266 286.003 868.787 286.416 868.265 286.694 867.744 286.971 868.272 288.628 868.945 288.725Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.196 293.661C865.921 293.359 859.315 291.997 854.055 291.671 848.796 291.345 836.097 291.429 834.641 291.703 833.184 291.976 842.613 293.435 845.317 293.313 848.022 293.191 852.331 293.398 855.707 293.484 859.083 293.57 866.471 293.963 866.196 293.661Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.365 294.873C866.996 295.126 869.544 294.603 869.97 294.257 870.397 293.91 869.554 293.047 868.923 292.794 868.292 292.541 866.757 292.593 866.185 292.739 865.613 292.885 865.735 294.62 866.365 294.873Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.393 265.749C855.004 265.874 851.028 271.323 848.552 275.974 846.076 280.626 840.892 292.219 840.537 293.658 840.183 295.097 845.417 287.12 846.427 284.608 847.436 282.096 849.41 278.259 850.887 275.223 852.364 272.186 855.782 265.624 855.393 265.749Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.567 266.097C857.058 265.628 857.638 263.092 857.499 262.561 857.36 262.029 856.226 262.439 855.734 262.908 855.242 263.377 854.654 264.796 854.55 265.377 854.446 265.958 856.075 266.567 856.567 266.097Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.577 318.357C851.635 317.952 848.481 311.99 845.386 307.725 842.291 303.461 834.144 293.719 833.006 292.77 831.868 291.821 836.744 300.022 838.559 302.03 840.374 304.039 842.957 307.494 845.039 310.153 847.12 312.812 851.519 318.761 851.577 318.357Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.75 319.259C850.957 319.907 852.981 321.539 853.52 321.647 854.058 321.755 854.188 320.556 853.982 319.908 853.775 319.261 852.758 318.11 852.281 317.762 851.805 317.414 850.544 318.611 850.75 319.259Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.916 317.307C848.025 316.913 845.641 310.603 843.104 305.984 840.566 301.366 833.702 290.682 832.692 289.598 831.682 288.513 835.493 297.26 837.042 299.48 838.592 301.7 840.722 305.451 842.455 308.35 844.188 311.248 847.808 317.701 847.916 317.307Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.983 318.098C847.107 318.767 848.911 320.64 849.432 320.814 849.953 320.989 850.231 319.815 850.108 319.147 849.984 318.479 849.119 317.209 848.689 316.804 848.26 316.399 846.859 317.43 846.983 318.098Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.335 318.257C842.491 317.88 840.901 311.324 838.951 306.429 837.001 301.534 831.503 290.086 830.634 288.886 829.764 287.686 832.471 296.835 833.736 299.229 835 301.622 836.653 305.607 838.016 308.697 839.38 311.786 842.179 318.635 842.335 318.257Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.311 318.928C841.351 319.607 842.912 321.687 843.407 321.925 843.903 322.162 844.324 321.031 844.283 320.353 844.242 319.675 843.54 318.309 843.164 317.854 842.787 317.399 841.27 318.25 841.311 318.928Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.782 276.177C796.897 276.57 802.235 280.692 806.818 283.293 811.4 285.895 822.848 291.392 824.277 291.785 825.706 292.179 817.874 286.73 815.39 285.653 812.906 284.575 809.125 282.498 806.13 280.939 803.134 279.38 796.667 275.785 796.782 276.177Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.162 275.014C796.706 274.509 794.187 273.861 793.652 273.986 793.117 274.11 793.496 275.256 793.951 275.76 794.407 276.264 795.81 276.891 796.388 277.01 796.966 277.13 797.618 275.518 797.162 275.014Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.589 284.518C792.865 284.82 799.472 286.176 804.732 286.498 809.991 286.82 822.69 286.726 824.146 286.451 825.602 286.176 816.173 284.725 813.468 284.849 810.764 284.973 806.454 284.77 803.079 284.686 799.703 284.602 792.314 284.216 792.589 284.518Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.419 283.305C791.788 283.053 789.24 283.578 788.815 283.925 788.389 284.272 789.232 285.134 789.863 285.387 790.494 285.639 792.029 285.586 792.601 285.439 793.173 285.293 793.05 283.558 792.419 283.305Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.241 294.849C792.561 295.103 799.3 295.39 804.544 294.871 809.787 294.352 822.309 292.237 823.703 291.734 825.097 291.231 815.556 291.299 812.906 291.852 810.256 292.405 805.969 292.891 802.623 293.345 799.277 293.8 791.921 294.594 792.241 294.849Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.88 293.679C791.216 293.53 788.785 294.454 788.42 294.865 788.055 295.275 789.025 295.992 789.688 296.141 790.351 296.29 791.858 295.993 792.399 295.757 792.94 295.521 792.543 293.828 791.88 293.679Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.75 307.77C796.142 307.887 802.504 305.647 807.179 303.214 811.853 300.782 822.689 294.16 823.796 293.175 824.903 292.189 816.072 295.802 813.818 297.301 811.564 298.8 807.765 300.845 804.828 302.512 801.892 304.179 795.359 307.653 795.75 307.77Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.98 306.819C794.309 306.928 792.396 308.69 792.21 309.206 792.023 309.723 793.19 310.028 793.861 309.92 794.532 309.811 795.821 308.975 796.235 308.554 796.65 308.134 795.651 306.71 794.98 306.819Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.374 313.49C799.778 313.55 805.753 310.419 810.03 307.341 814.307 304.263 824.081 296.155 825.034 295.021 825.988 293.887 817.768 298.729 815.752 300.536 813.736 302.344 810.27 304.913 807.603 306.984 804.936 309.055 798.969 313.431 799.374 313.49Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.475 312.659C797.827 312.863 796.186 314.881 796.076 315.42 795.965 315.958 797.164 316.092 797.813 315.888 798.461 315.684 799.616 314.672 799.966 314.197 800.316 313.721 799.123 312.455 798.475 312.659Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.355 325.504C820.701 325.286 823.198 319.02 824.441 313.899 825.683 308.778 827.824 296.261 827.809 294.779 827.795 293.297 824.708 302.325 824.354 305.009 824.001 307.693 823.042 311.899 822.366 315.208 821.69 318.516 820.01 325.722 820.355 325.504Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.132 325.458C818.773 326.035 818.841 328.635 819.108 329.116 819.375 329.596 820.372 328.917 820.732 328.341 821.091 327.764 821.309 326.243 821.265 325.655 821.221 325.066 819.492 324.882 819.132 325.458Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.245 322.884C811.637 322.766 815.706 317.387 818.262 312.779 820.818 308.171 826.202 296.669 826.581 295.237 826.96 293.804 821.589 301.69 820.537 304.184 819.484 306.678 817.444 310.48 815.915 313.49 814.386 316.501 810.854 323.003 811.245 322.884Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.078 322.516C809.578 322.977 808.955 325.502 809.085 326.036 809.214 326.57 810.356 326.18 810.856 325.719 811.355 325.258 811.968 323.85 812.082 323.271 812.196 322.692 810.578 322.055 810.078 322.516Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.1 318.577C805.508 318.55 810.692 314.235 814.227 310.327 817.761 306.419 825.614 296.439 826.309 295.13 827.003 293.82 819.983 300.282 818.392 302.472 816.801 304.662 813.952 307.902 811.779 310.487 809.607 313.072 804.692 318.604 805.1 318.577Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.047 317.953C803.455 318.289 802.276 320.607 802.281 321.156 802.286 321.705 803.486 321.585 804.077 321.249 804.668 320.914 805.585 319.681 805.827 319.143 806.07 318.605 804.638 317.618 804.047 317.953Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.948 302.633C795.321 302.799 801.917 301.39 806.864 299.574 811.811 297.759 823.404 292.575 824.628 291.739 825.851 290.903 816.632 293.358 814.204 294.557 811.777 295.757 807.748 297.3 804.623 298.578 801.497 299.856 794.574 302.467 794.948 302.633Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.305 301.592C793.626 301.614 791.503 303.117 791.252 303.606 791.001 304.094 792.12 304.546 792.799 304.524 793.479 304.502 794.864 303.837 795.328 303.473 795.793 303.109 794.984 301.569 794.305 301.592Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.641 324.167C840.826 323.802 839.757 317.142 838.198 312.109 836.638 307.075 832.057 295.231 831.285 293.966 830.513 292.702 832.492 302.035 833.564 304.521 834.637 307.006 835.972 311.109 837.088 314.296 838.204 317.483 840.456 324.531 840.641 324.167Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.567 324.755C839.555 325.434 840.947 327.631 841.422 327.907 841.897 328.183 842.405 327.088 842.418 326.409 842.431 325.729 841.838 324.312 841.499 323.829 841.159 323.346 839.58 324.075 839.567 324.755Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.942 324.793C835.17 324.454 834.928 317.714 834 312.527 833.071 307.34 829.982 295.022 829.371 293.672 828.76 292.322 829.576 301.828 830.335 304.426 831.094 307.025 831.914 311.26 832.629 314.561 833.345 317.861 834.713 325.132 834.942 324.793Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.804 325.245C833.708 325.918 834.819 328.269 835.257 328.601 835.694 328.933 836.333 327.91 836.43 327.237 836.526 326.565 836.112 325.085 835.835 324.564 835.557 324.043 833.9 324.572 833.804 325.245Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.742 326.076C831 325.759 831.372 319.024 830.92 313.774 830.467 308.524 828.511 295.976 828.025 294.576 827.54 293.176 827.487 302.717 828.007 305.374 828.526 308.031 828.957 312.323 829.37 315.675 829.782 319.027 830.483 326.393 830.742 326.076Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.568 326.422C829.41 327.083 830.303 329.526 830.709 329.897 831.115 330.267 831.844 329.306 832.001 328.645 832.158 327.984 831.881 326.473 831.652 325.929 831.423 325.385 829.725 325.761 829.568 326.422Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.991 326.341C825.287 326.058 826.484 319.42 826.681 314.155 826.877 308.889 826.479 296.196 826.169 294.747 825.86 293.298 824.634 302.759 824.823 305.46 825.012 308.161 824.912 312.474 824.909 315.851 824.906 319.227 824.696 326.624 824.991 326.341Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.784 326.54C823.546 327.177 824.132 329.711 824.489 330.129 824.846 330.546 825.688 329.682 825.925 329.046 826.163 328.409 826.073 326.875 825.913 326.307 825.752 325.739 824.021 325.903 823.784 326.54Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.773 299.074C793.138 299.257 799.79 298.138 804.812 296.542 809.833 294.945 821.643 290.276 822.902 289.494 824.161 288.713 814.843 290.761 812.365 291.852 809.888 292.943 805.795 294.308 802.616 295.448 799.438 296.588 792.407 298.892 792.773 299.074Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.176 298.005C791.497 297.998 789.31 299.406 789.038 299.883 788.766 300.361 789.864 300.861 790.544 300.869 791.223 300.876 792.636 300.273 793.116 299.93 793.597 299.587 792.856 298.013 792.176 298.005Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.402 280.087C799.658 280.406 806.163 282.189 811.39 282.853 816.618 283.516 829.296 284.248 830.767 284.068 832.238 283.888 822.922 281.827 820.216 281.775 817.509 281.723 813.222 281.24 809.859 280.937 806.495 280.634 799.147 279.768 799.402 280.087Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.311 278.866C798.698 278.574 796.122 278.932 795.674 279.25 795.227 279.569 796.012 280.484 796.625 280.777 797.239 281.07 798.774 281.117 799.354 281.008 799.934 280.899 799.924 279.159 799.311 278.866Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.191 318.428C856.279 318.028 853.575 311.849 850.805 307.367 848.034 302.885 840.631 292.566 839.566 291.535 838.502 290.504 842.756 299.044 844.418 301.182 846.079 303.319 848.399 306.957 850.278 309.762 852.157 312.568 856.103 318.827 856.191 318.428Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.299 319.266C855.457 319.927 857.355 321.705 857.884 321.853 858.414 322.001 858.632 320.814 858.474 320.153 858.316 319.492 857.387 318.269 856.937 317.886 856.488 317.504 855.141 318.605 855.299 319.266Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.186 314.283C863.188 313.874 859.241 308.404 855.588 304.607 851.934 300.81 842.521 292.285 841.263 291.502 840.005 290.719 845.965 298.169 848.04 299.908 850.115 301.647 853.15 304.713 855.578 307.06 858.007 309.406 863.184 314.692 863.186 314.283Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.491 315.291C862.785 315.904 865.015 317.241 865.564 317.274 866.112 317.307 866.075 316.101 865.781 315.488 865.487 314.875 864.321 313.875 863.801 313.596 863.281 313.317 862.197 314.678 862.491 315.291Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.42 278.13C872.033 277.996 865.58 279.958 860.804 282.186 856.029 284.413 844.915 290.558 843.767 291.494 842.618 292.431 851.597 289.205 853.914 287.805 856.232 286.405 860.115 284.527 863.122 282.989 866.128 281.451 872.806 278.264 872.42 278.13Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.148 279.114C873.823 279.034 875.811 277.357 876.019 276.849 876.228 276.341 875.075 275.986 874.4 276.065 873.725 276.144 872.402 276.924 871.969 277.326 871.537 277.727 872.473 279.193 873.148 279.114Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.918 288.041C873.604 287.779 866.873 287.337 861.619 287.736 856.365 288.135 843.797 289.961 842.392 290.432 840.987 290.903 850.527 291.054 853.189 290.562 855.851 290.07 860.148 289.683 863.504 289.305 866.859 288.928 874.232 288.302 873.918 288.041Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.252 289.218C874.912 289.382 877.364 288.515 877.738 288.113 878.113 287.711 877.16 286.972 876.5 286.808 875.841 286.644 874.327 286.906 873.781 287.129 873.234 287.353 873.593 289.055 874.252 289.218Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.5 310.473C867.439 310.052 862.761 305.053 858.623 301.731 854.485 298.408 844.016 291.143 842.671 290.538 841.327 289.934 848.267 296.648 850.554 298.106 852.84 299.563 856.264 302.232 858.987 304.258 861.711 306.284 867.56 310.894 867.5 310.473Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.602 311.18C867.011 311.677 869.572 312.545 870.153 312.498 870.734 312.452 870.497 311.4 870.088 310.903 869.679 310.406 868.291 309.689 867.699 309.515 867.108 309.342 866.193 310.683 866.602 311.18Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.363 274.188C869.97 274.074 863.627 276.37 858.974 278.842 854.321 281.315 843.541 288.029 842.443 289.024 841.345 290.019 850.144 286.331 852.386 284.812 854.627 283.294 858.408 281.216 861.33 279.524 864.252 277.832 870.755 274.302 870.363 274.188Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.141 275.133C871.811 275.018 873.709 273.24 873.891 272.722 874.073 272.203 872.903 271.908 872.233 272.023 871.563 272.137 870.282 272.985 869.871 273.408 869.46 273.832 870.471 275.247 871.141 275.133Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.411 283.157C873.056 282.953 866.349 283.667 861.24 284.957 856.131 286.247 844.06 290.193 842.756 290.897 841.452 291.601 850.878 290.121 853.417 289.181 855.956 288.242 860.123 287.127 863.365 286.182 866.607 285.236 873.765 283.361 873.411 283.157Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.941 284.261C874.619 284.309 876.887 283.036 877.187 282.576 877.488 282.116 876.422 281.55 875.744 281.501 875.066 281.453 873.62 281.969 873.12 282.283 872.619 282.596 873.263 284.212 873.941 284.261Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.466 294.204C873.19 293.903 866.577 292.572 861.317 292.269 856.056 291.967 843.357 292.109 841.902 292.39 840.447 292.67 849.883 294.086 852.586 293.951 855.29 293.817 859.6 294.004 862.977 294.075 866.353 294.146 873.743 294.505 873.466 294.204Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.641 295.415C874.273 295.665 876.819 295.131 877.243 294.782 877.668 294.434 876.821 293.574 876.189 293.324 875.557 293.074 874.022 293.133 873.451 293.282 872.88 293.431 873.009 295.165 873.641 295.415Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.823 299.58C869.625 299.222 863.515 296.366 858.474 294.829 853.434 293.292 841.061 290.43 839.581 290.359 838.101 290.287 846.935 293.892 849.594 294.401 852.253 294.909 856.397 296.109 859.66 296.976 862.924 297.843 870.021 299.938 869.823 299.58Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.707 300.798C870.262 301.191 872.861 301.273 873.356 301.034 873.851 300.796 873.232 299.761 872.677 299.369 872.121 298.976 870.616 298.671 870.026 298.681 869.436 298.69 869.152 300.406 869.707 300.798Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.877 320.213C850.027 319.833 848.341 313.302 846.319 308.436 844.297 303.57 838.631 292.205 837.744 291.018 836.857 289.831 839.698 298.939 840.998 301.313 842.298 303.688 844.01 307.648 845.418 310.717 846.827 313.786 849.727 320.594 849.877 320.213Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.863 320.899C848.914 321.577 850.505 323.634 851.004 323.865 851.502 324.095 851.906 322.958 851.856 322.28 851.805 321.602 851.083 320.247 850.7 319.798 850.317 319.349 848.812 320.221 848.863 320.899Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.559 318.343C846.756 317.985 845.9 311.294 844.503 306.214 843.105 301.133 838.905 289.148 838.174 287.859 837.443 286.57 839.122 295.962 840.114 298.481 841.107 301 842.31 305.143 843.323 308.364 844.337 311.585 846.362 318.702 846.559 318.343Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.467 318.897C845.433 319.576 846.754 321.816 847.22 322.107 847.686 322.397 848.229 321.32 848.264 320.641 848.298 319.963 847.751 318.527 847.427 318.034 847.104 317.54 845.502 318.218 845.467 318.897Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.909 317.974C841.148 317.642 841.122 310.897 840.36 305.683 839.598 300.469 836.904 288.059 836.337 286.69 835.769 285.321 836.281 294.848 836.956 297.47 837.632 300.091 838.315 304.351 838.925 307.672 839.535 310.994 840.67 318.305 840.909 317.974Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.757 318.389C839.64 319.058 840.675 321.444 841.102 321.79 841.529 322.136 842.201 321.134 842.318 320.464 842.436 319.795 842.07 318.303 841.809 317.773 841.548 317.244 839.875 317.72 839.757 318.389Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.354 266.479C806.375 266.887 810.612 272.135 814.466 275.728 818.321 279.321 828.182 287.323 829.481 288.036 830.78 288.75 824.424 281.634 822.258 280.01 820.092 278.387 816.895 275.49 814.343 273.278 811.79 271.067 806.333 266.07 806.354 266.479Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.993 265.435C806.667 264.839 804.367 263.624 803.817 263.621 803.268 263.618 803.371 264.82 803.697 265.416 804.024 266.012 805.242 266.947 805.777 267.198 806.312 267.448 807.32 266.031 806.993 265.435Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.341 273.62C800.539 273.978 806.652 276.829 811.694 278.362 816.735 279.895 829.11 282.747 830.59 282.817 832.07 282.888 823.234 279.289 820.575 278.783 817.915 278.277 813.77 277.08 810.506 276.216 807.242 275.352 800.144 273.262 800.341 273.62Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.457 272.401C799.901 272.01 797.302 271.93 796.807 272.168 796.312 272.407 796.933 273.442 797.488 273.833 798.043 274.225 799.549 274.53 800.139 274.519 800.729 274.509 801.012 272.793 800.457 272.401Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.607 283.589C797.86 283.91 804.349 285.752 809.57 286.463 814.791 287.174 827.462 288.02 828.935 287.854 830.407 287.687 821.111 285.542 818.404 285.465 815.698 285.389 811.416 284.867 808.055 284.534 804.695 284.2 797.355 283.267 797.607 283.589Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.527 282.367C796.917 282.069 794.337 282.404 793.887 282.718 793.436 283.033 794.214 283.955 794.824 284.254 795.435 284.552 796.97 284.613 797.551 284.509 798.132 284.405 798.138 282.666 797.527 282.367Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.025 296.972C798.379 297.177 805.088 296.472 810.198 295.19 815.309 293.907 827.386 289.979 828.691 289.276 829.996 288.574 820.568 290.041 818.028 290.977 815.488 291.913 811.318 293.022 808.075 293.962 804.832 294.903 797.672 296.768 798.025 296.972Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.497 295.868C796.819 295.818 794.549 297.089 794.248 297.548 793.947 298.008 795.012 298.575 795.69 298.625 796.367 298.675 797.815 298.16 798.315 297.847 798.816 297.535 798.174 295.918 797.497 295.868Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.224 303.376C800.604 303.528 807.141 301.868 812.015 299.865 816.889 297.862 828.277 292.242 829.468 291.359 830.658 290.477 821.539 293.282 819.159 294.573 816.779 295.863 812.812 297.559 809.738 298.955 806.663 300.351 799.844 303.224 800.224 303.376Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.542 302.359C798.864 302.407 796.8 303.99 796.568 304.488 796.336 304.986 797.471 305.395 798.149 305.347 798.827 305.299 800.186 304.582 800.636 304.2 801.087 303.819 800.22 302.311 799.542 302.359Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.848 319.927C818.235 319.795 822.117 314.279 824.513 309.586 826.909 304.893 831.893 293.212 832.223 291.768 832.552 290.323 827.456 298.389 826.49 300.917 825.524 303.446 823.616 307.316 822.192 310.378 820.767 313.439 817.461 320.059 817.848 319.927Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.669 319.599C816.186 320.077 815.65 322.622 815.798 323.151 815.945 323.68 817.073 323.251 817.557 322.774 818.04 322.296 818.604 320.867 818.698 320.284 818.792 319.702 817.152 319.121 816.669 319.599Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.594 315.267C810.002 315.242 815.208 310.953 818.763 307.063 822.317 303.174 830.221 293.234 830.922 291.928 831.623 290.623 824.57 297.048 822.968 299.23 821.366 301.412 818.5 304.637 816.314 307.211 814.129 309.785 809.186 315.291 809.594 315.267Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.544 314.638C807.951 314.97 806.759 317.282 806.761 317.831 806.764 318.381 807.965 318.266 808.558 317.934 809.15 317.601 810.073 316.374 810.318 315.837 810.564 315.3 809.136 314.305 808.544 314.638Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.615 309.652C805.018 309.721 811.061 306.725 815.405 303.743 819.75 300.761 829.703 292.873 830.682 291.761 831.66 290.648 823.334 295.306 821.278 297.068 819.223 298.829 815.7 301.32 812.987 303.331 810.275 305.342 804.212 309.583 804.615 309.652Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.734 308.801C803.082 308.99 801.397 310.972 801.274 311.507 801.152 312.043 802.347 312.204 803 312.014 803.653 311.825 804.831 310.839 805.191 310.371 805.552 309.904 804.387 308.612 803.734 308.801Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.436 291.789C798.76 292.037 805.504 292.195 810.737 291.576 815.969 290.957 828.449 288.603 829.833 288.073 831.216 287.543 821.679 287.794 819.04 288.398 816.401 289.001 812.124 289.569 808.787 290.087 805.451 290.606 798.111 291.541 798.436 291.789Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.052 290.627C797.386 290.491 794.973 291.461 794.616 291.878 794.258 292.295 795.242 292.994 795.908 293.13 796.574 293.266 798.075 292.94 798.611 292.694 799.148 292.448 798.718 290.763 798.052 290.627Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.891 323.329C838.156 323.018 838.66 316.291 838.31 311.034 837.96 305.776 836.25 293.192 835.793 291.783 835.335 290.373 835.095 299.911 835.563 302.578 836.03 305.244 836.377 309.545 836.723 312.904 837.07 316.263 837.627 323.641 837.891 323.329Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.711 323.653C836.541 324.311 837.385 326.77 837.784 327.149 838.182 327.527 838.93 326.581 839.1 325.923 839.27 325.265 839.022 323.749 838.804 323.2 838.586 322.652 836.881 322.995 836.711 323.653Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.202 322.618C832.503 322.341 833.83 315.728 834.13 310.467 834.429 305.206 834.28 292.508 833.999 291.053 833.718 289.598 832.307 299.034 832.443 301.738 832.579 304.441 832.394 308.752 832.325 312.128 832.256 315.504 831.901 322.895 832.202 322.618Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.99 322.793C830.741 323.426 831.277 325.971 831.626 326.395 831.974 326.82 832.833 325.972 833.083 325.34 833.333 324.708 833.273 323.173 833.124 322.602 832.975 322.031 831.24 322.161 830.99 322.793Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.819 322.891C828.144 322.643 830.068 316.178 830.844 310.966 831.621 305.755 832.628 293.095 832.48 291.621 832.332 290.146 830.069 299.415 829.959 302.12 829.848 304.825 829.272 309.1 828.896 312.456 828.52 315.812 827.494 323.14 827.819 322.891Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.597 322.956C826.29 323.563 826.593 326.146 826.901 326.601 827.21 327.055 828.143 326.289 828.449 325.683 828.755 325.076 828.835 323.542 828.738 322.96 828.642 322.377 826.903 322.349 826.597 322.956Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.164 321.816C822.517 321.61 825.221 315.43 826.633 310.354 828.045 305.277 830.6 292.837 830.635 291.356 830.67 289.875 827.284 298.794 826.842 301.465 826.399 304.136 825.302 308.308 824.516 311.593 823.73 314.877 821.811 322.023 822.164 321.816Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.943 321.73C820.564 322.295 820.547 324.895 820.797 325.384 821.048 325.873 822.067 325.228 822.445 324.664 822.824 324.099 823.092 322.587 823.068 321.997 823.044 321.407 821.321 321.165 820.943 321.73Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.145 287.822C797.459 288.085 804.188 288.539 809.443 288.15 814.698 287.761 827.269 285.957 828.675 285.489 830.081 285.021 820.541 284.852 817.878 285.339 815.215 285.827 810.918 286.205 807.561 286.577 804.205 286.949 796.831 287.56 797.145 287.822Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.813 286.644C796.154 286.479 793.7 287.342 793.325 287.744 792.949 288.145 793.901 288.886 794.561 289.051 795.22 289.216 796.734 288.957 797.281 288.734 797.828 288.512 797.472 286.809 796.813 286.644Z",
    stroke: "#7E6942",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#FFF2CC",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.139 280.264C271.9 282.711 272.706 286.625 273.511 289.805 274.317 292.985 276.361 296.838 277.972 299.345 279.583 301.853 280.698 303.076 283.176 304.849 285.654 306.623 290.301 309.13 292.841 309.987 295.382 310.843 295.382 310.476 298.417 309.987 301.453 309.497 307.463 308.825 311.056 307.051 314.65 305.278 317.748 302.036 319.978 299.345 322.209 296.654 324.129 293.352 324.439 290.906 324.749 288.459 323.881 286.931 321.837 284.668 319.792 282.405 315.455 279.164 312.172 277.329 308.888 275.494 305.418 274.455 302.135 273.659 298.851 272.864 296.001 272.314 292.47 272.559 288.938 272.803 283.982 273.965 280.946 275.127 277.91 276.289 274.378 277.818 273.139 280.264Z",
    stroke: "#4F4437",
    strokeMiterlimit: 8,
    fill: "#A9D18E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.219 225.506C831.216 225.561 821.463 226.12 815.144 227.529 808.825 228.939 803.163 231.03 799.306 233.962 795.448 236.895 792.763 241.292 791.999 245.125 791.235 248.959 790.843 250.889 794.719 256.965 798.595 263.04 809.718 275.317 815.255 281.578 820.791 287.839 824.944 291.587 827.939 294.531 830.934 297.476 832.761 297.566 834.999 297.482 837.238 297.398 838.068 297.069 841.371 294.027 844.674 290.985 850.177 286.132 855.832 280.237 861.487 274.342 871.431 264.565 875.298 258.656 879.166 252.748 880.228 248.959 879.038 244.787 877.848 240.615 873.088 236.5 868.158 233.624 863.228 230.749 856.655 228.606 851.159 227.197 845.662 225.788 843.221 225.45 837.219 225.506Z",
    stroke: "#4F4437",
    strokeMiterlimit: 8,
    fill: "#A9D18E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.591 295.786C300.915 305.117 281.902 299.801 274.591 285.953",
    stroke: "#4F4437",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.733 256.494C851.231 278.019 815.583 277.348 795.11 254.995",
    stroke: "#4F4437",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.5 262.5C806.328 268.221 811.157 273.942 816.123 279.46 820.262 283.633 822.499 286.507 825.028 289.199 827.557 291.891 829.672 293.154 830.5 294.5",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.5 263.5C808.035 269.159 812.57 274.819 817.235 280.278 821.122 284.406 823.411 287.482 825.787 290.145 828.162 292.808 831.723 296.168 832.5 297.5",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.5 268.5C814.077 273.377 816.454 276.699 820.34 281.404 823.578 284.961 825.285 287.495 827.264 289.79 829.243 292.085 832.852 295.353 833.5 296.5",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.5 270.5C819.665 276.87 821.633 279.53 824.878 285.339 827.745 288.846 827.897 289.317 829.649 291.579 831.402 293.842 833.926 296.369 834.5 297.5",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.5 241.5C800.5 239.843 802.291 238.5 804.5 238.5 806.709 238.5 808.5 239.843 808.5 241.5 808.5 243.157 806.709 244.5 804.5 244.5 802.291 244.5 800.5 243.157 800.5 241.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.5 235.5C811.5 233.843 813.291 232.5 815.5 232.5 817.709 232.5 819.5 233.843 819.5 235.5 819.5 237.157 817.709 238.5 815.5 238.5 813.291 238.5 811.5 237.157 811.5 235.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.5 233.5C825.5 231.843 827.067 230.5 829 230.5 830.933 230.5 832.5 231.843 832.5 233.5 832.5 235.157 830.933 236.5 829 236.5 827.067 236.5 825.5 235.157 825.5 233.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.5 233.5C839.5 231.843 841.067 230.5 843 230.5 844.933 230.5 846.5 231.843 846.5 233.5 846.5 235.157 844.933 236.5 843 236.5 841.067 236.5 839.5 235.157 839.5 233.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.5 237.5C852.5 235.843 854.291 234.5 856.5 234.5 858.709 234.5 860.5 235.843 860.5 237.5 860.5 239.157 858.709 240.5 856.5 240.5 854.291 240.5 852.5 239.157 852.5 237.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.5 243.5C865.5 241.843 867.067 240.5 869 240.5 870.933 240.5 872.5 241.843 872.5 243.5 872.5 245.157 870.933 246.5 869 246.5 867.067 246.5 865.5 245.157 865.5 243.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 250.5C796.5 248.843 798.067 247.5 800 247.5 801.933 247.5 803.5 248.843 803.5 250.5 803.5 252.157 801.933 253.5 800 253.5 798.067 253.5 796.5 252.157 796.5 250.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.5 246.5C811.5 244.843 813.067 243.5 815 243.5 816.933 243.5 818.5 244.843 818.5 246.5 818.5 248.157 816.933 249.5 815 249.5 813.067 249.5 811.5 248.157 811.5 246.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.5 242.5C822.5 240.843 824.067 239.5 826 239.5 827.933 239.5 829.5 240.843 829.5 242.5 829.5 244.157 827.933 245.5 826 245.5 824.067 245.5 822.5 244.157 822.5 242.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.5 257.5C805.5 255.843 807.067 254.5 809 254.5 810.933 254.5 812.5 255.843 812.5 257.5 812.5 259.157 810.933 260.5 809 260.5 807.067 260.5 805.5 259.157 805.5 257.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.5 261.5C816.5 259.843 818.067 258.5 820 258.5 821.933 258.5 823.5 259.843 823.5 261.5 823.5 263.157 821.933 264.5 820 264.5 818.067 264.5 816.5 263.157 816.5 261.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.5 253C820.5 251.619 822.067 250.5 824 250.5 825.933 250.5 827.5 251.619 827.5 253 827.5 254.381 825.933 255.5 824 255.5 822.067 255.5 820.5 254.381 820.5 253Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.5 263.5C827.5 261.843 829.291 260.5 831.5 260.5 833.709 260.5 835.5 261.843 835.5 263.5 835.5 265.157 833.709 266.5 831.5 266.5 829.291 266.5 827.5 265.157 827.5 263.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.5 263.5C840.5 261.843 842.067 260.5 844 260.5 845.933 260.5 847.5 261.843 847.5 263.5 847.5 265.157 845.933 266.5 844 266.5 842.067 266.5 840.5 265.157 840.5 263.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.5 260.5C851.5 258.843 853.291 257.5 855.5 257.5 857.709 257.5 859.5 258.843 859.5 260.5 859.5 262.157 857.709 263.5 855.5 263.5 853.291 263.5 851.5 262.157 851.5 260.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.5 253C861.5 251.619 863.291 250.5 865.5 250.5 867.709 250.5 869.5 251.619 869.5 253 869.5 254.381 867.709 255.5 865.5 255.5 863.291 255.5 861.5 254.381 861.5 253Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.5 254.5C832.5 252.843 834.291 251.5 836.5 251.5 838.709 251.5 840.5 252.843 840.5 254.5 840.5 256.157 838.709 257.5 836.5 257.5 834.291 257.5 832.5 256.157 832.5 254.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.5 252.5C844.5 250.843 846.291 249.5 848.5 249.5 850.709 249.5 852.5 250.843 852.5 252.5 852.5 254.157 850.709 255.5 848.5 255.5 846.291 255.5 844.5 254.157 844.5 252.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.5 245.5C853.5 243.843 855.067 242.5 857 242.5 858.933 242.5 860.5 243.843 860.5 245.5 860.5 247.157 858.933 248.5 857 248.5 855.067 248.5 853.5 247.157 853.5 245.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.5 242.5C832.5 240.843 834.291 239.5 836.5 239.5 838.709 239.5 840.5 240.843 840.5 242.5 840.5 244.157 838.709 245.5 836.5 245.5 834.291 245.5 832.5 244.157 832.5 242.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.5 243.5C844.5 241.843 846.067 240.5 848 240.5 849.933 240.5 851.5 241.843 851.5 243.5 851.5 245.157 849.933 246.5 848 246.5 846.067 246.5 844.5 245.157 844.5 243.5Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.129 277.6C279.345 276.617 280.447 276.024 281.592 276.276 282.736 276.527 283.488 277.528 283.272 278.511 283.056 279.494 281.953 280.087 280.809 279.835 279.665 279.584 278.913 278.583 279.129 277.6Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.254 275.153C286.47 274.17 287.573 273.578 288.717 273.829 289.861 274.081 290.614 275.081 290.397 276.064 290.181 277.047 289.079 277.64 287.935 277.389 286.79 277.137 286.038 276.136 286.254 275.153Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.275 275.853C294.491 274.87 295.593 274.277 296.738 274.529 297.882 274.78 298.634 275.781 298.418 276.764 298.202 277.747 297.099 278.34 295.955 278.089 294.811 277.837 294.059 276.836 294.275 275.853Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.476 277.815C302.692 276.832 303.795 276.239 304.939 276.491 306.083 276.742 306.835 277.743 306.619 278.726 306.403 279.709 305.3 280.302 304.156 280.05 303.012 279.799 302.26 278.798 302.476 277.815Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.745 281.529C309.961 280.546 311.064 279.953 312.208 280.205 313.352 280.456 314.104 281.457 313.888 282.44 313.672 283.423 312.569 284.016 311.425 283.764 310.281 283.513 309.529 282.512 309.745 281.529Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.032 286.67C316.248 285.687 317.351 285.094 318.495 285.345 319.639 285.597 320.391 286.598 320.175 287.581 319.959 288.564 318.856 289.157 317.712 288.905 316.568 288.653 315.816 287.653 316.032 286.67Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.234 282.277C275.45 281.294 276.553 280.701 277.697 280.952 278.841 281.204 279.594 282.205 279.377 283.188 279.161 284.171 278.059 284.764 276.914 284.512 275.77 284.26 275.018 283.26 275.234 282.277Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.526 282.115C284.742 281.133 285.845 280.54 286.989 280.791 288.133 281.043 288.885 282.043 288.669 283.026 288.453 284.009 287.35 284.602 286.206 284.351 285.062 284.099 284.31 283.098 284.526 282.115Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.133 281.022C291.35 280.039 292.452 279.446 293.596 279.698 294.74 279.949 295.493 280.95 295.277 281.933 295.06 282.916 293.958 283.509 292.814 283.257 291.67 283.006 290.917 282.005 291.133 281.022Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.477 287.528C279.693 286.545 280.795 285.952 281.939 286.203 283.084 286.455 283.836 287.456 283.62 288.439 283.404 289.422 282.301 290.014 281.157 289.763 280.013 289.511 279.26 288.511 279.477 287.528Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.274 291.529C285.49 290.547 286.593 289.954 287.737 290.205 288.881 290.457 289.633 291.457 289.417 292.44 289.201 293.423 288.098 294.016 286.954 293.765 285.81 293.513 285.058 292.512 285.274 291.529Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91 286.971C289.126 285.988 290.228 285.395 291.373 285.647 292.517 285.899 293.269 286.899 293.053 287.882 292.837 288.865 291.734 289.458 290.59 289.207 289.446 288.955 288.694 287.954 288.91 286.971Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.753 294.398C291.969 293.415 293.072 292.823 294.216 293.074 295.36 293.326 296.112 294.326 295.896 295.309 295.68 296.292 294.578 296.885 293.433 296.634 292.289 296.382 291.537 295.381 291.753 294.398Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.934 295.628C299.15 294.645 300.252 294.052 301.397 294.304 302.541 294.556 303.293 295.556 303.077 296.539 302.861 297.522 301.758 298.115 300.614 297.864 299.47 297.612 298.718 296.611 298.934 295.628Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.031 295.506C306.247 294.523 307.35 293.93 308.494 294.181 309.638 294.433 310.39 295.434 310.174 296.417 309.958 297.4 308.856 297.992 307.711 297.741 306.567 297.489 305.815 296.489 306.031 295.506Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.766 292.187C312.982 291.204 314.085 290.611 315.229 290.863 316.373 291.115 317.125 292.115 316.909 293.098 316.693 294.081 315.59 294.674 314.446 294.423 313.302 294.171 312.55 293.17 312.766 292.187Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.952 289.251C296.168 288.268 297.271 287.675 298.415 287.927 299.559 288.178 300.311 289.179 300.095 290.162 299.879 291.145 298.776 291.738 297.632 291.486 296.488 291.235 295.736 290.234 295.952 289.251Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.055 289.771C303.271 288.788 304.374 288.195 305.518 288.447 306.662 288.698 307.415 289.699 307.198 290.682 306.982 291.665 305.88 292.258 304.736 292.006 303.591 291.755 302.839 290.754 303.055 289.771Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.862 286.782C309.078 285.799 310.18 285.206 311.325 285.458 312.469 285.71 313.221 286.71 313.005 287.693 312.789 288.676 311.686 289.269 310.542 289.018 309.398 288.766 308.646 287.765 308.862 286.782Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.437 282.059C297.653 281.076 298.756 280.484 299.9 280.735 301.044 280.987 301.796 281.987 301.58 282.97 301.364 283.953 300.261 284.546 299.117 284.295 297.973 284.043 297.221 283.042 297.437 282.059Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.798 283.945C304.014 282.962 305.117 282.37 306.261 282.621 307.405 282.873 308.157 283.873 307.941 284.856 307.725 285.839 306.622 286.432 305.478 286.181 304.334 285.929 303.582 284.928 303.798 283.945Z",
    stroke: "#353600",
    strokeMiterlimit: 8,
    fill: "#EDCC79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.458 655.853C178.218 653.522 189.625 653.216 196.433 652.173 203.24 651.13 208.331 651.437 216.304 649.597 224.276 647.758 235.316 644.323 244.27 641.134 253.224 637.945 270.028 630.463 270.028 630.463L304.618 615.744C316.148 610.715 330.07 602.804 339.208 600.29 348.346 597.775 349.634 600.29 359.447 600.658 369.26 601.026 398.085 602.498 398.085 602.498 412.252 603.049 429.67 603.969 444.45 603.969 459.231 603.969 477.077 603.417 486.768 602.498 496.458 601.578 497.316 599.002 502.591 598.45 507.865 597.898 511.606 599.431 518.414 599.186 525.221 598.94 543.436 596.978 543.436 596.978 551.532 596.303 563.246 593.176 566.987 595.138 570.728 597.101 570.237 606.484 565.883 608.753 561.528 611.022 540.86 608.753 540.86 608.753L519.15 608.753C513.385 608.876 511.974 608.692 506.27 609.489 500.567 610.286 495.231 612.31 484.928 613.537 474.624 614.763 459.108 616.664 444.45 616.848 429.792 617.032 396.981 614.64 396.981 614.64L363.127 612.801C353.866 612.31 346.997 610.838 341.416 611.697 335.835 612.555 335.222 615.131 329.641 617.952 324.06 620.773 317.927 624.76 307.93 628.623 297.933 632.487 278.737 637.7 269.66 641.134 260.584 644.569 257.394 647.696 253.469 649.229 249.544 650.763 249.36 649.107 246.11 650.333 242.859 651.56 238.628 654.688 233.966 656.589 229.305 658.49 225.012 660.391 218.143 661.74 211.274 663.09 192.753 664.684 192.753 664.684 186.375 665.42 183.308 667.26 179.874 666.156 176.439 665.052 172.698 658.183 175.458 655.853Z",
    stroke: "#413707",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "#F2E5B4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5 657.5C182.223 656.419 186.947 655.338 192.79 654.589 198.634 653.839 206.06 654.059 212.563 653 219.065 651.942 226.052 649.957 231.807 648.236 237.563 646.516 239.628 645.589 247.098 642.678 254.567 639.766 266.562 635.09 276.624 630.767 286.686 626.443 307.469 616.738 307.469 616.738L329.614 606.416C334.842 603.989 334.666 602.886 338.841 602.181 343.015 601.475 348.507 602.004 354.658 602.181 360.81 602.357 368.674 602.886 375.749 603.239 382.823 603.592 384.955 604.794 397.102 604.298 409.25 603.803 427.835 606.544 442.386 606.538 456.936 606.531 488.301 604.174 498.978 603.737 509.655 603.299 561.826 596.558 565.5 596.5",
    stroke: "#413707",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "0.666667 0.666667",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5 658.5C182.231 657.393 186.962 656.874 192.816 656.224 198.669 655.574 206.049 655.623 212.621 654.598 219.194 653.572 225.661 652.068 232.251 650.071 238.841 648.074 244.679 645.538 252.161 642.615 259.643 639.692 267.83 636.432 277.143 632.534 286.456 628.636 308.039 619.226 308.039 619.226L330.22 608.654C335.458 606.17 335.282 605.04 339.463 604.317 343.644 603.595 349.145 604.137 355.307 604.317 361.468 604.498 369.346 605.04 376.432 605.402 383.518 605.763 385.654 606.993 397.822 606.486 409.989 605.979 428.606 608.786 443.181 608.78 457.755 608.773 489.173 606.359 499.867 605.911 510.562 605.463 562.82 598.559 566.5 598.5",
    stroke: "#413707",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "0.666667 0.666667",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5 665.5C185.232 664.391 190.181 665.04 197.118 664.259 204.056 663.477 215.767 662.271 222.124 660.81 228.482 659.35 229.84 657.626 235.262 655.495 240.685 653.365 248.039 650.737 254.657 648.025 261.274 645.312 268.391 641.702 274.966 639.223 281.541 636.743 288.048 635.284 294.107 633.148 300.167 631.013 304.671 629.211 311.325 626.408L333.251 615.556C338.49 613.066 338.314 611.935 342.496 611.211 346.677 610.486 352.267 610.9 358.343 611.211 364.419 611.522 370.523 612.498 378.953 613.077 387.383 613.655 396.752 615.191 408.921 614.683 422.91 615.993 431.657 615.688 446.234 615.682 460.812 615.675 496.393 612.737 506.051 608.909 516.748 608.46 563.819 608.559 567.5 608.5",
    stroke: "#413707",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "0.666667 0.666667",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.738 642.502C169.31 642.348 169.364 652.264 170.702 655.758 172.04 659.252 176.591 663.003 177.769 663.465 178.946 663.928 178.518 659.663 177.769 658.533 177.019 657.402 174.289 659.355 173.272 656.683 172.254 654.011 170.167 642.656 169.738 642.502Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.217 577.66C512.867 578.723 514.177 585.895 513.217 590.145 512.256 594.395 508.719 600.638 507.453 603.161 506.186 605.685 505.139 605.109 505.619 605.286 506.099 605.463 508.806 605.995 510.335 604.224 511.863 602.453 513.959 598.07 514.789 594.661 515.618 591.252 515.618 586.47 515.313 583.77 515.007 581.069 513.566 576.598 513.217 577.66Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.362 640.501C172.843 640.583 172.419 647.143 172.513 650.65 172.607 654.157 172.938 659.272 173.928 661.541 174.919 663.811 178.079 665.048 178.456 664.264 178.834 663.481 176.664 659.19 176.192 656.838 175.721 654.487 175.532 652.424 175.626 650.155 175.721 647.886 173.881 640.418 173.362 640.501Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.492 639.501C182.741 639.63 184.692 648.912 184.485 652.908 184.277 656.904 182.243 661.674 181.247 663.479 180.251 665.283 178.632 664.252 178.508 663.736 178.383 663.221 179.753 662.318 180.5 660.385 181.247 658.451 182.534 654.799 182.99 652.134 183.447 649.47 182.243 639.372 182.492 639.501Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.501 644.578C160.545 645.582 161.329 658.009 163.378 661.649 165.426 665.289 170.439 665.916 172.792 666.418 175.146 666.921 177.456 664.954 177.5 664.661 177.543 664.368 174.797 664.954 173.054 664.661 171.31 664.368 168.695 664.41 167.039 662.904 165.383 661.398 164.206 658.678 163.116 655.624 162.026 652.569 160.457 643.574 160.501 644.578Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.512 645.503C164.338 645.713 166.156 656.441 167.367 659.638 168.579 662.835 170.136 663.719 171.78 664.686 173.425 665.654 176.151 665.528 177.232 665.444 178.314 665.359 178.833 664.644 178.271 664.182 177.708 663.719 175.501 663.635 173.857 662.667 172.213 661.699 170.007 661.026 168.406 658.376 166.805 655.726 164.685 645.293 164.512 645.503Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47 646.605C189.554 647.47 189.512 654.758 188.71 657.722 187.908 660.687 186.472 663.116 184.657 664.393 182.842 665.669 178.748 665.587 177.819 665.381 176.89 665.175 178.199 663.569 179.085 663.157 179.972 662.746 181.956 663.528 183.138 662.91 184.32 662.293 185.333 661.181 186.177 659.452 187.021 657.722 187.654 654.634 188.203 652.534 188.752 650.434 189.385 645.74 189.47 646.605Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.611 659.503C155.844 659.374 159.236 664.172 161.216 665.672 163.195 667.171 165.942 668.457 168.486 668.5 171.031 668.542 176.161 666.229 176.484 665.929 176.807 665.629 172.202 666.614 170.425 666.7 168.648 666.786 168.002 667.428 165.82 666.443 163.639 665.458 157.378 659.631 156.611 659.503Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.486 659.522C196.23 659.867 193.886 664.893 190.605 665.967 187.323 667.042 178.289 666.197 176.797 665.967 175.305 665.737 179.823 664.701 181.655 664.586 183.488 664.471 186.045 665.392 187.792 665.277 189.54 665.162 190.861 664.74 192.139 663.896 193.418 663.051 196.742 659.176 196.486 659.522Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.497 665.655C174.378 664.386 170.443 671.196 169.489 675.045 168.535 678.894 168.217 685.365 168.774 688.749 169.33 692.132 172.59 696.362 172.828 695.347 173.066 694.332 169.569 687.522 170.205 682.658 170.841 677.794 174.617 666.924 174.497 665.655Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.792 666.675C178.375 667.717 181.182 674.05 181.948 678.425 182.713 682.8 182.495 690.008 182.385 692.925 182.276 695.841 181.547 697.424 181.292 695.925 181.036 694.425 181.328 687.883 180.854 683.925 180.38 679.966 179.359 674.883 178.448 672.175 177.537 669.467 177.208 665.633 177.792 666.675Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.512 666.922C179.201 665.169 184.925 669.273 186.755 672.053 188.585 674.832 190.338 679.536 190.494 683.598 190.649 687.66 188.001 697.451 187.69 696.425 187.378 695.399 189.987 687.489 188.624 682.571 187.261 677.654 179.824 668.675 179.512 666.922Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.491 666.516C172.233 666.216 166.133 670.075 163.986 672.947 161.838 675.82 160.12 680.493 159.604 683.752 159.089 687.01 160.635 692.369 160.893 692.498 161.151 692.626 160.378 687.482 161.151 684.523 161.924 681.565 163.427 677.321 165.532 674.748 167.637 672.176 172.748 666.817 172.491 666.516Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.505 666.506C182.721 666.336 190.27 669.786 192.6 671.617 194.929 673.448 196.698 677.324 196.482 677.495 196.267 677.665 193.635 673.874 191.306 672.639 188.976 671.404 182.289 666.677 182.505 666.506Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.473 668.005C177.758 669.753 175.715 678.99 175.478 682.735 175.24 686.48 176.333 690.142 176.048 690.475 175.763 690.808 174.148 687.77 173.768 684.733 173.387 681.695 173.435 675.121 173.768 672.25 174.1 669.378 177.188 666.258 177.473 668.005Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.482 666.855C176.825 665.629 172.113 667.786 170.314 670.155 168.515 672.524 166.33 678.024 165.687 681.07 165.045 684.116 166.244 689.15 166.458 688.431 166.673 687.711 167.058 680.689 168.258 677.516 169.457 674.343 176.14 668.082 176.482 666.855Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.218 620.501C244.786 620.587 244.432 627.42 244.511 631.073 244.59 634.726 244.865 640.055 245.69 642.418 246.516 644.782 249.149 646.071 249.464 645.255 249.778 644.438 247.97 639.969 247.577 637.519 247.184 635.069 247.027 632.921 247.105 630.557 247.184 628.193 245.651 620.415 245.218 620.501Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.492 620.501C254.741 620.63 256.692 629.912 256.485 633.908 256.277 637.904 254.243 642.674 253.247 644.479 252.251 646.283 250.632 645.252 250.508 644.736 250.383 644.221 251.753 643.318 252.5 641.385 253.247 639.451 254.534 635.799 254.99 633.134 255.447 630.47 254.243 620.372 254.492 620.501Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.501 625.578C232.542 626.582 233.28 639.009 235.208 642.649 237.136 646.289 241.854 646.916 244.069 647.418 246.284 647.921 248.459 645.954 248.5 645.661 248.541 645.368 245.956 645.954 244.315 645.661 242.674 645.368 240.213 645.41 238.654 643.904 237.095 642.398 235.988 639.678 234.962 636.624 233.937 633.569 232.46 624.574 232.501 625.578Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.512 626.503C235.338 626.713 237.156 637.441 238.367 640.638 239.579 643.835 241.136 644.719 242.78 645.686 244.425 646.654 247.151 646.528 248.232 646.444 249.314 646.359 249.833 645.644 249.271 645.182 248.708 644.719 246.501 644.635 244.857 643.667 243.213 642.699 241.007 642.026 239.406 639.376 237.805 636.726 235.685 626.293 235.512 626.503Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.47 627.605C261.554 628.47 261.512 635.758 260.71 638.722 259.908 641.687 258.472 644.116 256.657 645.393 254.842 646.669 250.748 646.587 249.819 646.381 248.89 646.175 250.199 644.569 251.085 644.157 251.972 643.746 253.956 644.528 255.138 643.91 256.32 643.293 257.333 642.181 258.177 640.452 259.021 638.722 259.654 635.634 260.203 633.534 260.752 631.434 261.385 626.74 261.47 627.605Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.617 640.503C226.811 640.374 230.373 645.172 232.451 646.672 234.53 648.171 237.414 649.457 240.086 649.5 242.758 649.542 248.144 647.229 248.483 646.929 248.822 646.629 243.987 647.614 242.121 647.7 240.255 647.786 239.577 648.428 237.286 647.443 234.996 646.458 228.422 640.631 227.617 640.503Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.486 639.525C268.23 639.919 265.886 645.663 262.605 646.891 259.323 648.119 250.289 647.154 248.797 646.891 247.305 646.628 251.823 645.444 253.655 645.313 255.488 645.181 258.045 646.233 259.792 646.102 261.54 645.97 262.861 645.488 264.139 644.523 265.418 643.559 268.742 639.13 268.486 639.525Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.497 646.655C246.358 645.386 241.767 652.196 240.654 656.045 239.541 659.894 239.17 666.365 239.819 669.749 240.469 673.132 244.271 677.362 244.549 676.347 244.828 675.332 240.747 668.522 241.489 663.658 242.231 658.794 246.636 647.924 246.497 646.655Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.85 647.675C249.55 648.717 252.919 655.05 253.837 659.425 254.756 663.8 254.494 671.008 254.362 673.925 254.231 676.841 253.356 678.424 253.05 676.925 252.744 675.425 253.094 668.883 252.525 664.925 251.956 660.966 250.731 655.883 249.638 653.175 248.544 650.467 248.15 646.633 248.85 647.675Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.513 647.908C250.173 646.213 256.418 650.181 258.415 652.868 260.411 655.554 262.323 660.101 262.493 664.028 262.663 667.954 259.774 677.42 259.434 676.428 259.094 675.436 261.941 667.789 260.454 663.036 258.967 658.282 250.853 649.602 250.513 647.908Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.491 647.516C243.233 647.216 237.133 651.075 234.986 653.947 232.838 656.82 231.12 661.493 230.604 664.752 230.089 668.01 231.635 673.369 231.893 673.498 232.151 673.626 231.378 668.482 232.151 665.523 232.924 662.565 234.427 658.321 236.532 655.748 238.637 653.176 243.748 647.817 243.491 647.516Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.505 647.506C254.721 647.336 262.27 650.786 264.6 652.617 266.929 654.448 268.698 658.324 268.482 658.495 268.267 658.665 265.635 654.874 263.306 653.639 260.976 652.404 254.289 647.677 254.505 647.506Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.48 648.027C248.693 649.851 247.161 659.49 246.983 663.398 246.805 667.306 247.625 671.127 247.411 671.474 247.197 671.821 245.986 668.652 245.701 665.482 245.416 662.312 245.451 655.452 245.701 652.456 245.95 649.46 248.266 646.204 248.48 648.027Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.482 647.855C247.825 646.629 243.113 648.786 241.314 651.155 239.515 653.524 237.33 659.024 236.687 662.07 236.045 665.116 237.244 670.15 237.458 669.431 237.673 668.711 238.058 661.689 239.258 658.516 240.457 655.343 247.14 649.082 247.482 647.855Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65 568.501C337.958 568.621 337.392 578.188 337.518 583.302 337.643 588.416 338.084 595.876 339.404 599.185 340.725 602.495 344.939 604.299 345.442 603.156 345.945 602.013 343.052 595.756 342.423 592.327 341.794 588.897 341.543 585.889 341.668 582.58 341.794 579.271 339.341 568.381 338.65 568.501Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.489 568.502C352.862 568.682 355.788 581.676 355.477 587.271 355.166 592.866 352.115 599.543 350.621 602.07 349.127 604.597 346.699 603.153 346.512 602.431 346.325 601.709 348.38 600.446 349.5 597.739 350.621 595.031 352.551 589.918 353.236 586.188 353.921 582.458 352.115 568.321 352.489 568.502Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.501 575.613C319.563 577.074 320.67 595.149 323.563 600.443 326.455 605.738 333.531 606.651 336.854 607.381 340.177 608.112 343.438 605.251 343.499 604.825 343.561 604.399 339.684 605.251 337.223 604.825 334.762 604.399 331.07 604.46 328.731 602.269 326.393 600.078 324.732 596.122 323.193 591.68 321.655 587.237 319.44 574.152 319.501 575.613Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.516 576.504C325.269 576.81 327.865 592.364 329.596 597 331.327 601.636 333.552 602.917 335.901 604.32 338.249 605.723 342.144 605.54 343.689 605.418 345.234 605.296 345.976 604.259 345.172 603.588 344.369 602.917 341.216 602.795 338.868 601.392 336.519 599.989 333.366 599.013 331.079 595.17 328.792 591.327 325.764 576.199 325.516 576.504Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.454 577.655C362.581 578.929 362.518 589.669 361.315 594.038 360.112 598.407 357.959 601.987 355.236 603.868 352.513 605.749 346.371 605.628 344.978 605.324 343.585 605.021 345.548 602.655 346.878 602.048 348.208 601.441 351.184 602.594 352.956 601.684 354.729 600.773 356.249 599.135 357.515 596.587 358.782 594.038 359.732 589.487 360.555 586.393 361.378 583.298 362.328 576.381 362.454 577.655Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.672 596.504C311.483 596.318 316.742 603.249 319.809 605.415 322.877 607.581 327.134 609.437 331.079 609.499 335.023 609.561 342.974 606.219 343.475 605.786 343.976 605.353 336.839 606.776 334.084 606.9 331.329 607.024 330.327 607.952 326.947 606.529 323.566 605.106 313.862 596.689 312.672 596.504Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.48 595.534C372.109 596.077 368.71 603.975 363.952 605.663 359.194 607.351 346.094 606.025 343.931 605.663 341.768 605.301 348.318 603.673 350.975 603.492 353.633 603.311 357.34 604.758 359.874 604.578 362.407 604.397 364.323 603.734 366.177 602.407 368.031 601.081 372.851 594.992 372.48 595.534Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.496 605.723C339.317 603.904 333.415 613.664 331.984 619.181 330.553 624.698 330.076 633.973 330.911 638.823 331.745 643.673 336.634 649.735 336.992 648.28 337.35 646.825 332.103 637.065 333.057 630.093 334.011 623.122 339.675 607.541 339.496 605.723Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.967 606.757C344.9 608.284 349.392 617.573 350.617 623.99 351.841 630.406 351.491 640.978 351.316 645.256 351.141 649.534 349.975 651.856 349.567 649.656 349.158 647.456 349.625 637.862 348.867 632.056 348.108 626.251 346.475 618.795 345.017 614.823 343.559 610.851 343.034 605.229 343.967 606.757Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.519 607.104C346.037 604.592 354.884 610.475 357.713 614.459 360.541 618.443 363.249 625.184 363.49 631.007 363.731 636.829 359.638 650.864 359.157 649.393 358.675 647.922 362.708 636.584 360.601 629.536 358.495 622.488 347 609.617 346.519 607.104Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.486 607.523C336.11 607.107 327.195 612.45 324.056 616.427 320.917 620.405 318.406 626.875 317.653 631.387 316.899 635.898 319.159 643.319 319.536 643.497 319.913 643.675 318.783 636.551 319.913 632.455 321.043 628.359 323.24 622.482 326.316 618.92 329.392 615.359 336.863 607.938 336.486 607.523Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.507 607.508C352.815 607.276 363.6 611.98 366.928 614.478 370.256 616.975 372.783 622.26 372.475 622.492 372.167 622.725 368.407 617.556 365.079 615.872 361.751 614.187 352.199 607.741 352.507 607.508Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.466 608.247C343.822 610.83 341.269 624.486 340.972 630.022 340.675 635.558 342.041 640.971 341.685 641.463 341.328 641.955 339.309 637.465 338.834 632.974 338.359 628.484 338.419 618.765 338.834 614.521 339.25 610.277 343.11 605.664 343.466 608.247Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.474 607.017C342.973 605.232 336.119 608.371 333.502 611.817 330.885 615.262 327.707 623.262 326.773 627.692 325.838 632.123 327.583 639.445 327.894 638.399 328.206 637.353 328.766 627.138 330.511 622.523 332.256 617.908 341.976 608.801 342.474 607.017Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.502 606.99C312.365 607.479 318.165 613.015 322.641 613.456 327.117 613.896 336.114 610.957 339.356 609.635 342.599 608.312 342.964 605.765 342.096 605.52 341.229 605.275 337.255 607.333 334.15 608.165 331.044 608.998 326.797 610.565 323.463 610.516 320.129 610.468 312.639 606.5 312.502 606.99Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.949 604.655C348.049 605.88 361.741 613.816 365.666 619.622 369.591 625.427 369.5 638.987 369.5 639.486 369.5 639.985 368.405 627.15 365.666 622.615 362.928 618.08 356.538 614.769 353.069 612.274 349.6 609.78 343.85 603.431 345.949 604.655Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.987696 0.000733812C0.393268 0.0985754-0.093082 7.87698 0.0149958 12.0353 0.123074 16.1935 0.501346 22.2597 1.63616 24.9503 2.77098 27.641 6.39158 29.1086 6.82389 28.1791 7.25621 27.2496 4.77042 22.1619 4.23003 19.3734 3.68964 16.5849 3.47348 14.1388 3.58156 11.4482 3.68964 8.75756 1.58212-0.0971078 0.987696 0.000733812Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 509.2 574.806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.198 0.00134532C5.52224 0.148108 8.06206 10.715 7.79187 15.2647 7.52167 19.8143 4.87377 25.2445 3.57683 27.2992 2.2799 29.3539 0.172384 28.1798 0.0102674 27.5927-0.151849 27.0057 1.63143 25.9783 2.60413 23.7769 3.57683 21.5754 5.25204 17.4172 5.84647 14.3841 6.4409 11.351 4.87377-0.145417 5.198 0.00134532Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 501.408 574.897)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00108078 0.0908704C0.0551198 1.26497 1.02782 15.7945 3.56766 20.0506 6.10749 24.3067 12.322 25.0405 15.2401 25.6275 18.1582 26.2146 21.0223 23.9153 21.0763 23.5729 21.1303 23.2304 17.7259 23.9153 15.5643 23.5729 13.4028 23.2304 10.1604 23.2793 8.10694 21.5182 6.05345 19.757 4.5944 16.5772 3.24342 13.006 1.89245 9.43475-0.0529583-1.08323 0.00108078 0.0908704Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 524.678 579.533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0143203 0.00354677C-0.201835 0.248151 2.0678 12.723 3.58089 16.441 5.09398 20.159 7.03938 21.1863 9.09286 22.3115 11.1463 23.4367 14.5508 23.2899 15.9018 23.1921 17.2527 23.0942 17.9012 22.2626 17.1987 21.7244 16.4962 21.1863 13.7402 21.0885 11.6867 19.9633 9.63325 18.8381 6.87727 18.0554 4.87783 14.9734 2.87838 11.8913 0.230476-0.241058 0.0143203 0.00354677Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 520.205 580.723)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.323 0.124748C15.431 1.15209 15.377 9.81108 14.3502 13.3334 13.3235 16.8557 11.4862 19.742 9.16248 21.2586 6.8388 22.7751 1.59699 22.6773 0.408131 22.4327-0.780731 22.188 0.894484 20.2801 2.02931 19.7909 3.16413 19.3017 5.70397 20.2312 7.21707 19.4974 8.73017 18.7636 10.0271 17.4427 11.1079 15.3881 12.1887 13.3334 12.9993 9.66431 13.7018 7.16935 14.4043 4.67439 15.2149-0.902589 15.323 0.124748Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 503.163 582.622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.148472 0.00281296C-0.878269-0.14395 3.66101 5.33521 6.30892 7.04745 8.95683 8.75969 12.6315 10.2273 16.0359 10.2762 19.4404 10.3252 26.3033 7.68342 26.7357 7.34097 27.168 6.99853 21.0075 8.12371 18.6298 8.22155 16.2521 8.3194 15.3875 9.05321 12.4694 7.92803 9.55126 6.80284 1.17521 0.149576 0.148472 0.00281296Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 531.825 596.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3427 0.0276404C25.0185 0.46793 22.0463 6.87659 17.8853 8.24638 13.7243 9.61617 2.26802 8.53991 0.376653 8.24638-1.51472 7.95286 4.21343 6.63199 6.53711 6.48522 8.86079 6.33846 12.1031 7.51257 14.3187 7.3658 16.5343 7.21904 18.2096 6.68091 19.8307 5.60464 21.4519 4.52838 25.667-0.412649 25.3427 0.0276404Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 505.144 597.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15383 0.17954C7.99171-1.28809 2.64184 6.58817 1.3449 11.04 0.0479597 15.4918-0.384353 22.9767 0.372195 26.8903 1.12874 30.804 5.55995 35.6961 5.88419 34.522 6.20842 33.3479 1.45298 25.4716 2.3176 19.8457 3.18223 14.2198 8.31595 1.64717 8.15383 0.17954Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 516.549 604.533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.432447 0.205468C1.29707 1.42849 5.45807 8.86446 6.59289 14.0011 7.72771 19.1378 7.40347 27.6011 7.24136 31.0256 7.07924 34.4501 5.99846 36.3091 5.62019 34.5479 5.24191 32.7868 5.67423 25.1062 4.97172 20.4587 4.26921 15.8112 2.75612 9.84287 1.40515 6.66302 0.0541741 3.48316-0.432177-1.01755 0.432447 0.205468Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 505.302 605.652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0168872 0.482482C-0.415426-1.52327 7.52833 3.17313 10.0682 6.35298 12.608 9.53283 15.0398 14.9141 15.2559 19.5616 15.4721 24.2091 11.7974 35.4119 11.3651 34.2379 10.9328 33.0638 14.5534 24.0134 12.6621 18.3875 10.7707 12.7616 0.449201 2.48824 0.0168872 0.482482Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 502.636 606.095)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.343 0.0187123C16.0188-0.323734 8.34523 4.07915 5.64329 7.35686 2.94134 10.6346 0.779782 15.9669 0.131315 19.6849-0.517153 23.4029 1.42825 29.5181 1.75248 29.6648 2.07672 29.8116 1.10402 23.9411 2.07672 20.5655 3.04942 17.19 4.94078 12.3468 7.58869 9.41154 10.2366 6.47628 16.6672 0.361159 16.343 0.0187123Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 528.018 605.007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0063496 0.00697125C0.276545-0.188713 9.73339 3.77389 12.6515 5.8775 15.5696 7.9811 17.7852 12.4329 17.515 12.6286 17.2448 12.8243 13.9484 8.47031 11.0303 7.0516 8.11222 5.63289-0.263846 0.202655 0.0063496 0.00697125Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 497.777 606.517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5193 0.594021C4.84353 2.64869 2.51985 13.5091 2.24965 17.912 1.97946 22.3149 3.22236 26.6199 2.89812 27.0113 2.57389 27.4026 0.736554 23.8314 0.304241 20.2602-0.128073 16.689-0.0740337 8.95948 0.304241 5.58394 0.682515 2.20841 4.19506-1.46065 4.5193 0.594021Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 509.423 606.234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8541 0.410936C14.2865-1.00777 8.34215 1.4872 6.07251 4.22677 3.80287 6.96634 1.04687 13.3261 0.236286 16.8484-0.574301 20.3707 0.938794 26.1923 1.20899 25.3606 1.47919 24.529 1.96554 16.4081 3.47863 12.739 4.99173 9.06994 13.4218 1.82964 13.8541 0.410936Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.998775 0.0494866 0.0494866 0.998775 520.331 604.995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.543 584.58C483.862 585.564 484.271 596.346 487.908 600.149 491.546 603.952 502.413 606.726 505.369 607.397 508.324 608.068 508.006 605.294 505.641 604.176 503.277 603.057 494.456 602.341 491.182 600.686 487.908 599.031 487.272 596.525 485.999 594.244 484.725 591.962 483.225 583.596 483.543 584.58Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.417 607.518C500.929 607.789 496.677 611.227 495.554 614.846 494.43 618.464 494.332 625.792 494.674 629.23 495.016 632.667 497.362 635.834 497.606 635.472 497.85 635.11 495.993 630.768 496.14 627.058 496.287 623.349 496.824 616.338 498.485 613.217 500.147 610.096 501.906 607.247 501.417 607.518Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.957 575.738C568.488 575.755 567.167 582.311 566.744 585.857 566.321 589.402 565.873 594.599 566.419 597.01 566.964 599.422 569.57 601.068 570.016 600.326 570.462 599.583 569.169 594.986 569.093 592.557 569.017 590.128 569.148 588.026 569.559 585.751 569.97 583.477 569.427 575.72 568.957 575.738Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.222 576.811C578.453 576.971 579.121 586.23 578.359 590.067 577.597 593.903 574.899 598.225 573.651 599.828 572.403 601.431 570.925 600.201 570.872 599.685 570.819 599.168 572.315 598.491 573.332 596.728 574.348 594.964 576.143 591.616 576.97 589.104 577.796 586.592 577.99 576.65 578.222 576.811Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.807 578.69C555.706 579.694 554.685 592.147 556.121 596.044 557.556 599.94 562.248 601.249 564.421 602.069 566.594 602.89 569.077 601.252 569.161 600.967 569.244 600.682 566.542 600.888 564.92 600.359 563.299 599.83 560.799 599.514 559.434 597.791 558.069 596.068 557.333 593.205 556.729 590.022 556.125 586.838 555.909 577.686 555.807 578.69Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.192 579.939C558.996 580.123 559.223 590.973 559.934 594.299 560.646 597.625 562.017 598.713 563.46 599.895 564.903 601.078 567.539 601.328 568.59 601.394 569.642 601.46 570.242 600.825 569.767 600.29 569.292 599.755 567.184 599.368 565.741 598.186 564.298 597.003 562.274 596.034 561.111 593.195 559.948 590.356 559.388 579.755 559.192 579.939Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.991 584.51C583.949 585.395 582.854 592.747 581.635 595.627 580.416 598.507 578.651 600.757 576.679 601.789 574.707 602.822 570.687 602.161 569.802 601.822 568.917 601.483 570.438 600.047 571.371 599.756 572.303 599.465 574.144 600.535 575.397 600.078 576.65 599.622 577.809 598.642 578.891 597.015 579.972 595.388 581.042 592.36 581.887 590.317 582.731 588.275 584.033 583.625 583.991 584.51Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.996 592.477C548.224 592.24 551.048 597.396 552.877 599.143 554.705 600.889 557.354 602.541 559.966 602.958 562.579 603.375 568.18 601.887 568.555 601.643 568.929 601.4 564.053 601.677 562.212 601.498 560.371 601.319 559.617 601.848 557.509 600.57 555.401 599.292 549.768 592.715 548.996 592.477Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.975 597.697C588.672 598.035 585.605 603.153 582.237 603.858 578.87 604.564 570.188 602.386 568.768 601.929 567.349 601.471 571.917 600.98 573.722 601.111 575.527 601.242 577.879 602.598 579.601 602.717 581.323 602.836 582.677 602.564 584.055 601.828 585.434 601.092 589.278 597.358 588.975 597.697Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.274 601.571C566.328 600.306 561.254 606.409 559.714 610.049 558.174 613.689 556.931 620.002 557.036 623.411 557.142 626.82 559.955 631.465 560.347 630.503 560.739 629.541 558.04 622.324 559.39 617.639 560.74 612.954 566.22 602.836 566.274 601.571Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.946 602.463C569.463 603.598 571.758 610.375 572.006 614.865 572.253 619.355 570.973 626.511 570.432 629.403 569.89 632.295 568.832 633.755 568.756 632.217 568.679 630.679 569.947 624.2 569.972 620.174 569.998 616.147 569.56 610.909 568.908 608.058 568.256 605.207 568.43 601.329 568.946 602.463Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.621 603.212C570.533 601.46 576.072 606.326 577.638 609.308 579.205 612.29 580.42 617.131 580.021 621.104 579.621 625.077 575.43 634.192 575.241 633.146 575.051 632.101 578.938 624.81 578.168 619.821 577.398 614.832 570.709 604.964 570.621 603.212Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.673 601.962C563.465 601.635 557.026 604.531 554.548 607.018 552.071 609.506 549.759 613.799 548.807 616.886 547.856 619.974 548.608 625.385 548.839 625.545 549.071 625.706 549.037 620.61 550.197 617.849 551.356 615.088 553.401 611.181 555.795 608.979 558.189 606.776 563.881 602.289 563.673 601.962Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.398 603.499C574.63 603.362 581.422 607.772 583.411 609.881 585.399 611.99 586.562 616.017 586.33 616.154 586.098 616.29 584.093 612.227 582.021 610.7 579.948 609.173 574.166 603.635 574.398 603.499Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.803 603.461C568.803 605.242 565.693 614.215 564.949 617.927 564.205 621.638 564.637 625.433 564.34 625.73 564.043 626.027 563.064 622.79 563.167 619.707 563.269 616.625 564.251 610.063 564.953 607.236 565.655 604.41 568.804 601.679 568.803 603.461Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.664 602.534C568.169 601.376 563.292 602.841 561.213 604.919 559.133 606.996 556.239 612.097 555.187 615 554.134 617.904 554.589 623.018 554.898 622.341 555.208 621.664 556.57 614.817 558.181 611.866 559.792 608.915 567.158 603.692 567.664 602.534Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.862112 0.000773558C0.343265 0.103915-0.0812468 8.30363 0.0130891 12.6871 0.107425 17.0706 0.437601 23.4654 1.42813 26.3017 2.41865 29.1381 5.57891 30.6852 5.95625 29.7054 6.3336 28.7256 4.16387 23.3622 3.69219 20.4227 3.22051 17.4832 3.03184 14.9047 3.12617 12.0683 3.22051 9.2319 1.38096-0.102368 0.862112 0.000773558Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 252.5 617.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65779 0.00146528C4.94833 0.161314 7.2242 11.6704 6.98208 16.6257 6.73997 21.581 4.36725 27.4954 3.20511 29.7333 2.04296 31.9712 0.154469 30.6924 0.00920033 30.053-0.136068 29.4136 1.46188 28.2947 2.33349 25.897 3.20511 23.4992 4.70621 18.9702 5.23886 15.6666 5.77151 12.3631 4.36725-0.158383 4.65779 0.00146528Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 246.5 616.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000871728 0.0953819C0.0444581 1.32777 0.829013 16.5786 2.87757 21.046 4.92613 25.5134 9.93857 26.2837 12.2922 26.8999 14.6459 27.5161 16.956 25.1026 16.9996 24.7432 17.0431 24.3837 14.2972 25.1026 12.5538 24.7432 10.8103 24.3837 8.19511 24.4351 6.53883 22.5865 4.88255 20.7379 3.70571 17.4002 2.61606 13.6517 1.5264 9.90315-0.0427147-1.13701 0.000871728 0.0953819Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 264.5 623.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0114659 0.00365996C-0.161605 0.256071 1.65564 13.129 2.86713 16.9657 4.07862 20.8023 5.63626 21.8625 7.28043 23.0235 8.9246 24.1846 11.6505 24.0332 12.7321 23.9322 13.8138 23.8313 14.3331 22.9731 13.7706 22.4178 13.2081 21.8625 11.0014 21.7615 9.35727 20.6004 7.7131 19.4393 5.50646 18.6316 3.90555 15.4512 2.30465 12.2708 0.184536-0.248751 0.0114659 0.00365996Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 261.5 624.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9695 0.132627C12.0539 1.22485 12.0117 10.4307 11.2097 14.1755 10.4076 17.9202 8.9724 20.9888 7.15726 22.6012 5.34212 24.2135 1.24749 24.1095 0.318811 23.8494-0.609867 23.5894 0.698725 21.561 1.58519 21.0409 2.47166 20.5208 4.45565 21.509 5.6376 20.7288 6.81956 19.9486 7.83266 18.5444 8.67692 16.3599 9.52117 14.1755 10.1544 10.2747 10.7031 7.62214 11.2519 4.96961 11.8851-0.959594 11.9695 0.132627Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 247.5 625.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.116526 0.0030109C-0.689295-0.15408 2.87328 5.71063 4.95145 7.54335 7.02962 9.37608 9.91361 10.947 12.5855 10.9993 15.2575 11.0517 20.6437 8.22408 20.983 7.85753 21.3223 7.49099 16.4874 8.69535 14.6213 8.80008 12.7552 8.90481 12.0766 9.69026 9.78637 8.4859 7.49614 7.28154 0.922346 0.160101 0.116526 0.0030109Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 269.5 641.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.986 0.030967C19.7303 0.524246 17.3864 7.7042 14.1049 9.23884 10.8234 10.7735 1.78863 9.5677 0.29704 9.23884-1.19455 8.90999 3.32284 7.43015 5.15537 7.26573 6.98789 7.1013 9.5449 8.41671 11.2922 8.25229 13.0395 8.08786 14.3606 7.48496 15.6391 6.27917 16.9176 5.07338 20.2417-0.462312 19.986 0.030967Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 248.5 640.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99687 0.191444C6.85776-1.37349 2.26698 7.02499 1.15407 11.772 0.0411546 16.5189-0.329817 24.5001 0.319383 28.6732 0.968583 32.8464 4.77104 38.0629 5.04927 36.8109 5.3275 35.559 1.24681 27.1605 1.98875 21.1616 2.7307 15.1626 7.13598 1.75638 6.99687 0.191444Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 257.5 649.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.350091 0.221663C1.05005 1.54108 4.41863 9.56317 5.33733 15.1047 6.25603 20.6463 5.99355 29.7767 5.8623 33.4711 5.73106 37.1655 4.85611 39.171 4.54987 37.271 4.24364 35.3711 4.59362 27.0851 4.0249 22.0713 3.45618 17.0575 2.23124 10.6187 1.13755 7.18821 0.0438571 3.75771-0.349872-1.09776 0.350091 0.221663Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 248.5 649.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0132753 0.506049C-0.326572-1.59768 5.91812 3.32812 7.91472 6.66329 9.91132 9.99847 11.823 15.6426 11.9929 20.5171 12.1628 25.3916 9.27411 37.1417 8.93426 35.9102 8.59441 34.6788 11.4406 25.1863 9.9538 19.2856 8.46697 13.385 0.353122 2.60977 0.0132753 0.506049Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 245.5 650.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9907 0.0195527C12.7329-0.338275 6.63343 4.26236 4.48571 7.68728 2.338 11.1122 0.61983 16.6841 0.104379 20.5691-0.411072 24.4541 1.13528 30.8438 1.39301 30.9972 1.65073 31.1505 0.877556 25.0164 1.65073 21.4892 2.42391 17.962 3.92731 12.9013 6.03207 9.83425 8.13683 6.76716 13.2484 0.37738 12.9907 0.0195527Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 266.5 650.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00506887 0.00717266C0.220765-0.194165 7.77014 3.88292 10.0997 6.0473 12.4292 8.21169 14.1979 12.7921 13.9822 12.9935 13.7665 13.1948 11.135 8.71503 8.80549 7.25533 6.47597 5.79563-0.210628 0.20851 0.00506887 0.00717266Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 242.5 650.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9728 0.637061C4.25783 2.84061 2.21514 14.4879 1.97761 19.2098 1.74009 23.9317 2.8327 28.5487 2.54767 28.9684 2.26264 29.3881 0.647487 25.5581 0.26745 21.7282-0.112586 17.8982-0.0650812 9.60865 0.26745 5.98853 0.599982 2.36842 3.68778-1.56649 3.9728 0.637061Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 251.5 650.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9823 0.43612C11.325-1.06953 6.61292 1.57834 4.81375 4.48581 3.01457 7.39328 0.829867 14.1428 0.187307 17.8809-0.455254 21.6191 0.744193 27.7975 0.95838 26.9149 1.17257 26.0322 1.5581 17.4137 2.75755 13.5197 3.957 9.6258 10.6396 1.94177 10.9823 0.43612Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 260.5 649.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.718427 0.000773558C0.286054 0.103915-0.0677057 8.30363 0.0109076 12.6871 0.0895208 17.0706 0.364667 23.4654 1.19011 26.3017 2.01555 29.1381 4.64909 30.6852 4.96354 29.7054 5.278 28.7256 3.46989 23.3622 3.07682 20.4227 2.68376 17.4832 2.52653 14.9047 2.60514 12.0683 2.68376 9.2319 1.1508-0.102368 0.718427 0.000773558Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 572.5 569.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99239 0.00141801C4.24142 0.15611 6.19217 11.294 5.98464 16.0894 5.77712 20.8849 3.74336 26.6085 2.74723 28.7742 1.75111 30.9399 0.132402 29.7023 0.007886 29.0836-0.11663 28.4648 1.25304 27.382 2.00014 25.0616 2.74723 22.7412 4.0339 18.3582 4.49045 15.1613 4.94701 11.9643 3.74336-0.153274 3.99239 0.00141801Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 566.5 569.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000871728 0.0953819C0.0444581 1.32777 0.829013 16.5786 2.87757 21.046 4.92613 25.5134 9.93857 26.2837 12.2922 26.8999 14.6459 27.5161 16.956 25.1026 16.9996 24.7432 17.0431 24.3837 14.2972 25.1026 12.5538 24.7432 10.8103 24.3837 8.19511 24.4351 6.53883 22.5865 4.88255 20.7379 3.70571 17.4002 2.61606 13.6517 1.5264 9.90315-0.0427147-1.13701 0.000871728 0.0953819Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 584.5 575.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0114659 0.00365996C-0.161605 0.256071 1.65564 13.129 2.86713 16.9657 4.07862 20.8023 5.63626 21.8625 7.28043 23.0235 8.9246 24.1846 11.6505 24.0332 12.7321 23.9322 13.8138 23.8313 14.3331 22.9731 13.7706 22.4178 13.2081 21.8625 11.0014 21.7615 9.35727 20.6004 7.7131 19.4393 5.50646 18.6316 3.90555 15.4512 2.30465 12.2708 0.184536-0.248751 0.0114659 0.00365996Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 581.5 576.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9695 0.132627C12.0539 1.22485 12.0117 10.4307 11.2097 14.1755 10.4076 17.9202 8.9724 20.9888 7.15726 22.6012 5.34212 24.2135 1.24749 24.1095 0.318811 23.8494-0.609867 23.5894 0.698725 21.561 1.58519 21.0409 2.47166 20.5208 4.45565 21.509 5.6376 20.7288 6.81956 19.9486 7.83266 18.5444 8.67692 16.3599 9.52117 14.1755 10.1544 10.2747 10.7031 7.62214 11.2519 4.96961 11.8851-0.959594 11.9695 0.132627Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 567.5 577.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.116526 0.0030109C-0.689295-0.15408 2.87328 5.71063 4.95145 7.54335 7.02962 9.37608 9.91361 10.947 12.5855 10.9993 15.2575 11.0517 20.6437 8.22408 20.983 7.85753 21.3223 7.49099 16.4874 8.69535 14.6213 8.80008 12.7552 8.90481 12.0766 9.69026 9.78637 8.4859 7.49614 7.28154 0.922346 0.160101 0.116526 0.0030109Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 589.5 593.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.986 0.030967C19.7303 0.524246 17.3864 7.7042 14.1049 9.23884 10.8234 10.7735 1.78863 9.5677 0.29704 9.23884-1.19455 8.90999 3.32284 7.43015 5.15537 7.26573 6.98789 7.1013 9.5449 8.41671 11.2922 8.25229 13.0395 8.08786 14.3606 7.48496 15.6391 6.27917 16.9176 5.07338 20.2417-0.462312 19.986 0.030967Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 568.5 592.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99687 0.191444C6.85776-1.37349 2.26698 7.02499 1.15407 11.772 0.0411546 16.5189-0.329817 24.5001 0.319383 28.6732 0.968583 32.8464 4.77104 38.0629 5.04927 36.8109 5.3275 35.559 1.24681 27.1605 1.98875 21.1616 2.7307 15.1626 7.13598 1.75638 6.99687 0.191444Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 577.5 601.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.350091 0.221663C1.05005 1.54108 4.41863 9.56317 5.33733 15.1047 6.25603 20.6463 5.99355 29.7767 5.8623 33.4711 5.73106 37.1655 4.85611 39.171 4.54987 37.271 4.24364 35.3711 4.59362 27.0851 4.0249 22.0713 3.45618 17.0575 2.23124 10.6187 1.13755 7.18821 0.0438571 3.75771-0.349872-1.09776 0.350091 0.221663Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 568.5 601.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0143815 0.506049C-0.353786-1.59768 6.41129 3.32812 8.57428 6.66329 10.7373 9.99847 12.8082 15.6426 12.9923 20.5171 13.1764 25.3916 10.047 37.1417 9.67878 35.9102 9.31061 34.6788 12.394 25.1863 10.7833 19.2856 9.17255 13.385 0.382549 2.60977 0.0143815 0.506049Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 566.5 602.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9907 0.0195527C12.7329-0.338275 6.63343 4.26236 4.48571 7.68728 2.338 11.1122 0.61983 16.6841 0.104379 20.5691-0.411072 24.4541 1.13528 30.8438 1.39301 30.9972 1.65073 31.1505 0.877556 25.0164 1.65073 21.4892 2.42391 17.962 3.92731 12.9013 6.03207 9.83425 8.13683 6.76716 13.2484 0.37738 12.9907 0.0195527Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 586.5 602.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00506887 0.00717266C0.220765-0.194165 7.77014 3.88292 10.0997 6.0473 12.4292 8.21169 14.1979 12.7921 13.9822 12.9935 13.7665 13.1948 11.135 8.71503 8.80549 7.25533 6.47597 5.79563-0.210628 0.20851 0.00506887 0.00717266Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 562.5 602.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9728 0.637061C4.25783 2.84061 2.21514 14.4879 1.97761 19.2098 1.74009 23.9317 2.8327 28.5487 2.54767 28.9684 2.26264 29.3881 0.647487 25.5581 0.26745 21.7282-0.112586 17.8982-0.0650812 9.60865 0.26745 5.98853 0.599982 2.36842 3.68778-1.56649 3.9728 0.637061Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 571.5 602.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9823 0.43612C11.325-1.06953 6.61292 1.57834 4.81375 4.48581 3.01457 7.39328 0.829867 14.1428 0.187307 17.8809-0.455254 21.6191 0.744193 27.7975 0.95838 26.9149 1.17257 26.0322 1.5581 17.4137 2.75755 13.5197 3.957 9.6258 10.6396 1.94177 10.9823 0.43612Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 580.5 602.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14948 0.00100563C0.457686 0.135089-0.108329 10.7947 0.0174521 16.4933 0.143233 22.1918 0.583468 30.505 1.90417 34.1923 3.22487 37.8796 7.43854 39.8908 7.94167 38.617 8.44479 37.3432 5.55183 30.3709 4.92292 26.5495 4.29401 22.7281 4.04245 19.3761 4.16823 15.6888 4.29401 12.0015 1.84128-0.133078 1.14948 0.00100563Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 346.5 564.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98859 0.00189068C6.36213 0.208147 9.28825 15.0586 8.97696 21.4526 8.66568 27.8465 5.61504 35.478 4.12085 38.3656 2.62666 41.2532 0.198603 39.6031 0.011829 38.7781-0.174945 37.9531 1.87957 36.5093 3.00021 33.4154 4.12085 30.3216 6.05084 24.4777 6.73568 20.215 7.42052 15.9524 5.61504-0.204366 5.98859 0.00189068Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 336.5 563.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00128195 0.127176C0.0653796 1.77036 1.21914 22.1048 4.23173 28.0614 7.24431 34.0179 14.6155 35.0449 18.0768 35.8665 21.5381 36.6881 24.9353 33.4702 24.9994 32.9909 25.0635 32.5117 21.0253 33.4702 18.4614 32.9909 15.8975 32.5117 12.0516 32.5801 9.61593 30.1153 7.18022 27.6506 5.44958 23.2003 3.84714 18.2022 2.2447 13.2042-0.0628157-1.51601 0.00128195 0.127176Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 364.5 571.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0163799 0.00487995C-0.230864 0.341428 2.36519 17.5054 4.0959 22.6209 5.8266 27.7364 8.0518 29.1499 10.4006 30.6981 12.7494 32.2462 16.6435 32.0443 18.1888 31.9096 19.7341 31.775 20.4758 30.6308 19.6722 29.8903 18.8687 29.1499 15.7163 29.0153 13.3675 27.4672 11.0187 25.9191 7.86636 24.8421 5.57936 20.6016 3.29236 16.3611 0.263624-0.331668 0.0163799 0.00487995Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 358.5 573.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9543 0.17131C18.0809 1.5821 18.0176 13.473 16.8145 18.31 15.6114 23.147 13.4586 27.1106 10.7359 29.1932 8.01317 31.2758 1.87123 31.1414 0.478216 30.8055-0.914801 30.4696 1.04809 27.8496 2.37779 27.1778 3.70748 26.506 6.68348 27.7824 8.45641 26.7747 10.2293 25.767 11.749 23.9531 13.0154 21.1316 14.2818 18.31 15.2315 13.2715 16.0547 9.84527 16.8778 6.41907 17.8276-1.23948 17.9543 0.17131Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 338.5 574.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.172014 0.00383206C-1.01753-0.196101 4.24151 7.26808 7.30928 9.60063 10.3771 11.9332 14.6344 13.9325 18.5787 13.9992 22.5229 14.0658 30.4741 10.467 30.975 10.0005 31.4758 9.53399 24.3385 11.0668 21.5838 11.2001 18.8291 11.3334 17.8274 12.3331 14.4465 10.8002 11.0657 9.26741 1.36156 0.203765 0.172014 0.00383206Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 371.5 595.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9791 0.0371604C29.5955 0.629095 26.0796 9.24504 21.1574 11.0866 16.2351 12.9282 2.68295 11.4812 0.44556 11.0866-1.79183 10.692 4.98426 8.91618 7.73305 8.71887 10.4818 8.52156 14.3174 10.1001 16.9383 9.90274 19.5592 9.70543 21.5409 8.98195 23.4587 7.535 25.3764 6.08805 30.3626-0.554775 29.9791 0.0371604Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 340.5 594.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99553 0.248359C9.79679-1.78183 3.23855 9.1135 1.64867 15.2717 0.0587924 21.43-0.471167 31.7839 0.456262 37.1977 1.38369 42.6115 6.81577 49.3788 7.21324 47.7547 7.61071 46.1305 1.78116 35.2352 2.84108 27.4528 3.901 19.6705 10.1943 2.27854 9.99553 0.248359Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 353.5 605.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.466788 0.279995C1.40007 1.94663 5.89151 12.0798 7.11644 19.0797 8.34138 26.0795 7.9914 37.6127 7.8164 42.2793 7.64141 46.9459 6.47481 49.4791 6.0665 47.0792 5.65818 44.6792 6.12483 34.2127 5.36653 27.8795 4.60824 21.5463 2.97499 13.4131 1.51673 9.07984 0.0584761 4.74658-0.466496-1.38664 0.466788 0.279995Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 339.5 606.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0199129 0.660675C-0.489858-2.08586 8.87718 4.34504 11.8721 8.6993 14.867 13.0536 17.7344 20.4223 17.9893 26.7862 18.2442 33.1501 13.9112 48.4905 13.4014 46.8828 12.8916 45.275 17.1609 32.8822 14.9307 25.1785 12.7005 17.4748 0.529683 3.4072 0.0199129 0.660675Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 336.5 606.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9863 0.0252293C18.6097-0.436484 9.69501 5.49982 6.55604 9.91908 3.41708 14.3383 0.905905 21.5279 0.152554 26.5407-0.600798 31.5536 1.65926 39.7985 2.03593 39.9964 2.41261 40.1942 1.28258 32.2792 2.41261 27.728 3.54264 23.1768 5.73991 16.6469 8.8161 12.6894 11.8923 8.73181 19.363 0.486942 18.9863 0.0252293Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 366.5 607.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00724124 0.00937963C0.315379-0.253908 11.1002 5.07767 14.4281 7.90801 17.756 10.7384 20.2827 16.7282 19.9746 16.9914 19.6664 17.2547 15.9072 11.3966 12.5793 9.48774 9.25138 7.5789-0.300897 0.272667 0.00724124 0.00937963Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 330.5 607.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.966 0.812802C5.32229 3.62423 2.76892 18.4846 2.47202 24.5091 2.17511 30.5336 3.54087 36.4242 3.18458 36.9597 2.8283 37.4952 0.809358 32.6087 0.334313 27.7221-0.140732 22.8356-0.0813515 12.2593 0.334313 7.64054 0.749978 3.02178 4.60972-1.99862 4.966 0.812802Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 344.5 607.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9743 0.565341C16.4728-1.38643 9.61879 2.046 7.00181 5.81494 4.38484 9.58388 1.20708 18.3332 0.272446 23.179-0.662188 28.0248 1.08246 36.0338 1.39401 34.8896 1.70555 33.7455 2.26633 22.5733 4.01098 17.5256 5.75563 12.4779 15.4758 2.51711 15.9743 0.565341Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 357.5 606.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.002398 1.67577C-0.139193 2.22677 5.85427 8.45397 10.479 8.94985 15.1038 9.44573 24.4006 6.13937 27.7513 4.65146 31.1019 3.16356 31.4795 0.298091 30.5829 0.0225286 29.6862-0.253034 25.5805 2.06156 22.3715 2.99835 19.1624 3.93513 14.7735 5.6986 11.3285 5.64349 7.88342 5.58838 0.143989 1.12478 0.002398 1.67577Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 371.5 605.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.467793 0.168434C2.65478 1.49794 16.9176 10.1149 21.0063 16.4176 25.095 22.7203 24.9999 37.4432 24.9999 37.9848 24.9999 38.5263 23.8588 24.5914 21.0063 19.6675 18.1538 14.7435 11.4977 11.149 7.88439 8.44072 4.27119 5.73257-1.71919-1.16107 0.467793 0.168434Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 337.5 604.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.101 568.624C497.484 568.715 496.508 578.307 496.364 583.454 496.221 588.601 496.238 596.12 497.239 599.505 498.241 602.889 501.872 604.888 502.374 603.761 502.875 602.634 500.632 596.217 500.247 592.742 499.862 589.266 499.79 586.231 500.066 582.91 500.342 579.589 498.718 568.533 498.101 568.624Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.449 568.872C510.774 569.07 512.737 582.264 512.18 587.876 511.624 593.487 508.57 600.066 507.111 602.54 505.652 605.015 503.558 603.456 503.427 602.722 503.297 601.988 505.192 600.808 506.327 598.136 507.461 595.464 509.438 590.408 510.235 586.688 511.031 582.968 510.125 568.674 510.449 568.872Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.098 574.694C481.081 576.148 481.191 594.162 483.54 599.554 485.89 604.945 492.232 606.169 495.195 607.043 498.159 607.918 501.243 605.221 501.32 604.8 501.396 604.38 497.855 605.053 495.655 604.519 493.454 603.986 490.119 603.881 488.116 601.599 486.113 599.317 484.808 595.311 483.639 590.827 482.469 586.343 481.114 573.239 481.098 574.694Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.709 576.014C485.472 576.305 487.04 591.845 488.368 596.519 489.695 601.193 491.632 602.562 493.673 604.058 495.715 605.553 499.223 605.545 500.617 605.493 502.012 605.441 502.729 604.446 502.04 603.745 501.351 603.043 498.525 602.782 496.483 601.286 494.441 599.791 491.657 598.682 489.791 594.77 487.925 590.858 485.946 575.722 485.709 576.014Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.961 579.117C519.009 580.392 518.424 591.095 517.152 595.398 515.881 599.701 513.816 603.176 511.335 604.933 508.854 606.689 503.473 606.302 502.266 605.939 501.059 605.576 502.897 603.302 504.094 602.755 505.29 602.208 507.843 603.486 509.444 602.656 511.044 601.826 512.458 600.259 513.694 597.773 514.931 595.288 515.989 590.793 516.864 587.744 517.738 584.695 518.913 577.841 518.961 579.117Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.723 595.429C472.677 595.195 477.007 602.201 479.623 604.453 482.24 606.705 485.927 608.706 489.423 608.94 492.919 609.174 500.134 606.257 500.599 605.856 501.065 605.455 494.664 606.532 492.214 606.532 489.765 606.532 488.831 607.395 485.901 605.855 482.971 604.315 474.77 595.663 473.723 595.429Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.078 597.345C526.717 597.873 523.27 605.645 518.91 607.127 514.549 608.609 502.841 606.695 500.915 606.235 498.989 605.776 504.957 604.435 507.354 604.372 509.751 604.308 513.012 605.925 515.298 605.857 517.584 605.788 519.339 605.208 521.071 603.96 522.803 602.712 527.438 596.817 527.078 597.345Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.582 606.07C497.506 604.247 491.525 613.713 489.919 619.151 488.313 624.589 487.41 633.822 487.948 638.699 488.486 643.577 492.741 649.851 493.146 648.416 493.551 646.98 489.146 637 490.379 630.088 491.612 623.176 497.659 607.893 497.582 606.07Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.212 606.978C502.026 608.534 505.847 617.94 506.698 624.348 507.55 630.757 506.698 641.205 506.322 645.43 505.946 649.656 504.721 651.9 504.44 649.703 504.159 647.506 505.074 638.032 504.637 632.25 504.199 626.468 503.01 619.012 501.816 615.011 500.622 611.011 500.398 605.422 501.212 606.978Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.509 607.819C503.187 605.317 511.064 611.528 513.48 615.589 515.895 619.65 518.065 626.427 518.002 632.185 517.94 637.942 513.477 651.606 513.104 650.132 512.732 648.658 517.008 637.653 515.408 630.601 513.809 623.549 503.83 610.321 503.509 607.819Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.196 606.994C493.884 606.554 485.727 611.607 482.749 615.522 479.772 619.437 477.223 625.92 476.329 630.484 475.435 635.047 477.06 642.707 477.384 642.905 477.708 643.103 477.068 635.795 478.275 631.671 479.481 627.547 481.722 621.656 484.623 618.161 487.524 614.667 494.508 607.434 494.196 606.994Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.525 607.704C508.815 607.476 518.292 612.857 521.162 615.606 524.032 618.356 526.037 623.973 525.747 624.201 525.457 624.429 522.336 618.878 519.424 616.975 516.512 615.072 508.236 607.932 508.525 607.704Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.14 608.429C501.347 610.986 498.294 624.296 497.746 629.726 497.199 635.156 498.213 640.542 497.855 641.009 497.498 641.477 495.829 636.967 495.603 632.53 495.378 628.093 495.907 618.539 496.502 614.384 497.098 610.23 500.933 605.872 501.14 608.429Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.528 607.258C500.059 605.526 493.797 608.308 491.296 611.58 488.796 614.851 485.574 622.574 484.525 626.888 483.476 631.201 484.674 638.476 485.003 637.462 485.332 636.447 486.329 626.431 488.109 621.972 489.889 617.513 498.997 608.99 499.528 607.258Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0449625 0.100974C0.376547 1.34198 0.80287 14.9366 4.59197 19.7314 8.38107 24.5261 19.7012 28.0236 22.7799 28.8697 25.8586 29.7158 25.527 26.2185 23.064 24.8082 20.601 23.398 11.4125 22.4954 8.00222 20.4083 4.59197 18.3212 3.92891 15.1623 2.60268 12.2853 1.27645 9.40843-0.286622-1.14003 0.0449625 0.100974Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 524.5 579.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91716 0.0223315C6.42859 0.361614 2.1774 4.6588 1.05354 9.18204-0.0703115 13.7053-0.168048 22.865 0.174029 27.162 0.516107 31.4591 2.86144 35.4171 3.10578 34.9647 3.35012 34.5124 1.49336 29.0844 1.63996 24.448 1.78657 19.8117 2.324 11.0478 3.9853 7.14647 5.64659 3.24512 7.40573-0.316951 6.91716 0.0223315Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 512.5 608.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.78984 0.00077979C0.314488 0.104752-0.0744357 8.37052 0.0119918 12.7893 0.0984194 17.2081 0.400916 23.6544 1.30841 26.5136 2.21589 29.3729 5.11122 30.9324 5.45693 29.9447 5.80264 28.957 3.8148 23.5504 3.38267 20.5872 2.95053 17.624 2.77767 15.0247 2.8641 12.1655 2.95053 9.30627 1.26519-0.103192 0.78984 0.00077979Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 172.916 633.449)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15677 0.00142961C4.41605 0.157387 6.44712 11.3863 6.23105 16.221 6.01497 21.0557 3.89748 26.8261 2.86034 29.0095 1.8232 31.1929 0.137853 29.9453 0.00821068 29.3214-0.121432 28.6976 1.30463 27.6059 2.08249 25.2665 2.86034 22.9272 4.19998 18.5084 4.67534 15.2853 5.15069 12.0621 3.89748-0.154528 4.15677 0.00142961Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 166.708 634.023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000864282 0.0965639C0.0440784 1.34423 0.821933 16.784 2.853 21.3068 4.88406 25.8296 9.85368 26.6094 12.1872 27.2332 14.5208 27.8571 16.8112 25.4137 16.8544 25.0498 16.8976 24.6859 14.1751 25.4137 12.4465 25.0498 10.718 24.6859 8.12512 24.7379 6.48298 22.8664 4.84085 20.9949 3.67406 17.6158 2.59371 13.8209 1.51336 10.0259-0.0423498-1.1511 0.000864282 0.0965639Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 185.796 637.494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0114517 0.00376897C-0.161405 0.263698 1.65359 13.5201 2.86358 17.471 4.07358 21.4219 5.62928 22.5136 7.27142 23.7093 8.91356 24.905 11.636 24.749 12.7164 24.6451 13.7967 24.5411 14.3153 23.6573 13.7535 23.0855 13.1918 22.5136 10.9878 22.4097 9.3457 21.214 7.70356 20.0183 5.49964 19.1866 3.90072 15.9114 2.3018 12.6363 0.184308-0.25616 0.0114517 0.00376897Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 182.359 639.026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2535 0.132564C12.3399 1.22427 12.2967 10.4258 11.4756 14.1688 10.6546 17.9118 9.18529 20.9789 7.32708 22.5905 5.46887 24.2021 1.27709 24.0981 0.326375 23.8382-0.624338 23.5782 0.715303 21.5508 1.6228 21.0309 2.5303 20.5111 4.56137 21.4988 5.77137 20.719 6.98137 19.9392 8.01851 18.5356 8.88279 16.3522 9.74708 14.1688 10.3953 10.2698 10.9571 7.61854 11.5189 4.96726 12.1671-0.959141 12.2535 0.132564Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 168.969 642.074)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.118731 0.00298918C-0.702338-0.152968 2.92765 5.66943 5.04514 7.48893 7.16264 9.30842 10.1012 10.868 12.8237 10.92 15.5462 10.972 21.0344 8.16474 21.3801 7.80084 21.7258 7.43694 16.7994 8.63261 14.898 8.73658 12.9965 8.84055 12.3051 9.62034 9.97156 8.42467 7.63799 7.229 0.9398 0.158946 0.118731 0.00298918Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 193.368 654.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2662 0.029372C20.0069 0.497244 17.6301 7.30738 14.3026 8.76298 10.9751 10.2186 1.8137 9.0749 0.301203 8.76298-1.21129 8.45107 3.36941 7.04745 5.22762 6.89149 7.08583 6.73554 9.67868 7.9832 11.4505 7.82724 13.2222 7.67128 14.5619 7.09944 15.8583 5.95575 17.1547 4.81206 20.5254-0.4385 20.2662 0.029372Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 172.153 657.162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52044 0.190788C6.3908-1.36879 2.11262 7.00095 1.07549 11.7317 0.0383524 16.4624-0.307359 24.4163 0.297636 28.5751 0.902631 32.734 4.44617 37.9326 4.70546 36.6849 4.96474 35.4373 1.16191 27.0675 1.85334 21.0891 2.54476 15.1108 6.65008 1.75037 6.52044 0.190788Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 182.092 664.398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.345821 0.218341C1.03725 1.51799 4.36474 9.41986 5.27224 14.8784 6.17974 20.3369 5.92045 29.3305 5.79081 32.9695 5.66117 36.6085 4.79688 38.584 4.49438 36.7125 4.19188 34.841 4.5376 26.6792 3.97581 21.7405 3.41403 16.8019 2.20403 10.4596 1.12368 7.08049 0.0433222 3.7014-0.345605-1.08131 0.345821 0.218341Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 173.241 666.269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0135044 0.512712C-0.332209-1.61871 6.02027 3.37194 8.05134 6.75103 10.0824 10.1301 12.027 15.8486 12.1999 20.7872 12.3728 25.7259 9.43419 37.6307 9.08848 36.383 8.74277 35.1354 11.6381 25.518 10.1256 19.5396 8.61312 13.5612 0.359218 2.64414 0.0135044 0.512712Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 171.162 666.899)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0692 0.0198846C12.81-0.344017 6.67355 4.33471 4.51285 7.81777 2.35214 11.3008 0.623579 16.9673 0.10501 20.9182-0.413559 24.8691 1.14215 31.3674 1.40143 31.5233 1.66072 31.6793 0.882864 25.441 1.66072 21.854 2.43857 18.2669 3.95106 13.1203 6.06855 10.0012 8.18604 6.88202 13.3285 0.383786 13.0692 0.0198846Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 191.298 664.197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00507765 0.00740801C0.221148-0.200536 7.78361 4.01033 10.1172 6.24573 12.4507 8.48113 14.2225 13.2119 14.0064 13.4198 13.7904 13.6277 11.1543 9.00099 8.82074 7.4934 6.48718 5.9858-0.210993 0.215352 0.00507765 0.00740801Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 167.331 667.643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.614 0.631238C3.87329 2.81464 2.01508 14.3555 1.79901 19.0342 1.58293 23.7129 2.57686 28.2877 2.31758 28.7036 2.05829 29.1195 0.589009 25.3245 0.243296 21.5295-0.102418 17.7346-0.0592034 9.52082 0.243296 5.93379 0.545795 2.34677 3.35472-1.55217 3.614 0.631238Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 176.595 666.631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.079 0.436682C11.4247-1.07091 6.67111 1.58037 4.8561 4.49158 3.0411 7.40279 0.83717 14.161 0.188955 17.9039-0.459261 21.6469 0.750741 27.8333 0.966813 26.9495 1.18288 26.0657 1.57181 17.4361 2.78182 13.5371 3.99182 9.63819 10.7333 1.94427 11.079 0.436682Z",
    stroke: "#213315",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "#C7B395",
    fillRule: "evenodd",
    transform: "matrix(-0.989891 0.141833 0.141833 0.989891 185.162 664.655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C1.81358 4.41426 3.86821 7.58191 9.44852 11.3058 14.0989 14.1215 19.2452 15.3886 23.0502 16.5125",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.989283 -0.146011 -0.146011 0.989283 319.709 295.661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C3.60859 4.2456 2.387 2.99164 8.19948 6.77864 13.0433 9.64204 17.2483 10.1492 21.2115 11.2922",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.999176 0.0405878 0.0405878 0.999176 314.803 297.864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C2.57504 3.09462 1.70333 2.1806 5.85104 4.94095 9.30751 7.02808 12.3081 7.39771 15.1363 8.23087",
    stroke: "#4F4437",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    strokeDasharray: "1.33333 1",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.998723 0.0505186 0.0505186 0.998723 308.333 300.524)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.927 249.272C672.145 259.317 702.064 294.799 716.105 308.757 730.146 322.716 735.395 328.064 749.173 333.021 762.952 337.978 788.409 338.5 798.776 338.5 809.143 338.5 810.324 334.587 811.373 333.021 812.423 331.456 806.649 331.586 805.075 329.108 803.5 326.629 803.763 321.933 801.925 318.15 800.088 314.367 799.563 311.888 794.052 306.409 788.541 300.93 778.699 291.669 768.857 285.277 759.015 278.884 747.992 273.536 735.001 268.057 722.01 262.578 701.276 255.664 690.91 252.403 680.543 249.142 677.131 248.881 672.801 248.489 668.47 248.098 657.71 239.227 664.927 249.272Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.9 328.345C842.05 325.187 845.828 318.594 847.18 314.415 848.533 310.236 851.611 306.522 855.016 303.272 858.42 300.021 864.437 296.632 867.608 294.914 870.78 293.196 872.692 293.707 874.044 292.964 875.397 292.221 872.832 293.8 875.723 290.457 878.615 287.114 885.564 278.199 891.394 272.905 897.224 267.612 907.205 261.344 910.703 258.697 914.201 256.051 911.076 258.976 912.382 257.026 913.688 255.076 916.066 248.9 918.538 246.996 921.01 245.093 924.088 245.511 927.213 245.604 930.338 245.696 935.002 247.368 937.287 247.554 939.572 247.739 945.729 245.604 944.283 251.175 942.837 256.747 932.483 271.698 928.612 280.984 924.741 290.271 924.974 299.789 921.057 306.893 917.139 313.997 912.568 319.198 905.106 323.609 897.644 328.02 885.984 332.57 876.283 333.359 866.582 334.149 851.751 331.502 846.9 328.345Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.514 327.119C765.326 330.177 767.066 341.807 769.747 347.969 772.428 354.132 776.331 359.321 781.599 364.093 786.866 368.866 793.639 374.055 801.352 376.603 809.065 379.152 819.647 379.8 827.878 379.383 836.108 378.966 843.774 376.928 850.735 374.101 857.696 371.275 864.751 367.568 869.642 362.425 874.533 357.282 878.719 349.869 880.083 343.243 881.447 336.618 879.142 326.795 877.825 322.671 876.508 318.547 875.568 318.548 872.182 318.501 868.795 318.455 862.728 319.752 857.508 322.393 852.287 325.034 845.138 330.27 840.859 334.347 836.579 338.425 834.274 343.892 831.828 346.857 829.383 349.822 827.643 350.935 826.185 352.139 824.727 353.344 824.539 353.993 823.081 354.085 821.623 354.178 818.848 353.483 817.437 352.695 816.026 351.908 815.838 350.61 814.615 349.359 813.392 348.108 812.357 346.811 810.1 345.189 807.842 343.568 804.456 341.251 801.07 339.629 797.684 338.008 793.263 336.386 789.782 335.459 786.302 334.533 783.339 335.042 780.188 334.069 777.037 333.096 772.992 330.965 770.875 329.621 768.759 328.277 765.702 324.061 765.514 327.119Z",
    stroke: "#76553E",
    strokeMiterlimit: 8,
    fill: "#F8BECF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.353 75.8051C521.117 75.34 523.24 75.2414 523.89 75.8386 524.54 76.4358 525.112 78.1773 524.255 79.3888 523.398 80.6004 519.954 79.2262 519.304 78.629 518.653 78.0318 519.589 76.2702 520.353 75.8051Z",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.123447 1.94346C0.492623 1.03591 2.45913-0.156953 3.4143 0.0170205 4.36947 0.190994 5.85449 1.34683 5.85449 2.98717 5.85449 4.62751 2.15392 5.63627 1.19874 5.4623 0.24357 5.28832-0.24573 2.85101 0.123447 1.94346Z",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.994871 0.101149 0.101149 0.994871 530.43 76.5654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.586 414.793C229.926 414.316 230.995 413.728 231.388 413.935 231.781 414.141 232.254 415.073 231.944 416.033 231.635 416.993 229.74 417.001 229.347 416.794 228.954 416.588 229.246 415.269 229.586 414.793Z",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0608599 1.30337C0.242866 0.69473 1.21237-0.105259 1.68327 0.0114147 2.15418 0.128089 2.8863 0.903245 2.8863 2.00333 2.8863 3.10341 1.06189 3.77993 0.590988 3.66326 0.120082 3.54658-0.121146 1.91201 0.0608599 1.30337Z",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.919028 0.394192 0.394192 0.919028 234.614 412.935)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5 202.5C234.939 200.573 241.378 198.646 250.113 198.217 260.049 198.37 270.381 196.847 280.119 197.837 286.243 198.312 285.469 198.56 285.469 198.56",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.864 206.447C244.188 204.073 247.713 203.299 256.467 202.159 266.475 201.471 273.548 198.555 283.423 198.681",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.948 181.956C262.648 179.962 268.275 179.721 273.349 179.989 278.423 180.257 284.082 182.22 290.392 183.565L312.811 190.061C318.104 192.031 321.658 192.777 323.55 192.989L335.558 194.332",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.778 169.591C298.903 169.145 302.69 170.518 306.026 172.043 309.361 173.567 312.808 176.246 316.79 178.738L330.656 188.6C333.858 191.185 336.103 192.582 337.328 193.216L345.105 197.24",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.73245C1.17768 4.52377 7.36535 2.79656 10.2908 2.23503 13.2162 1.6735 16.7738 1.75531 20.5914 1.48771L35.907 0.126544C39.2585 0.260768 40.8441 0.161622 41.9543 0L48.118 0.0569962",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0.77459 0.632464 0.632464 -0.77459 309.953 167.673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.74079C0.823594 1.72875 5.39507 1.10988 7.44092 0.639699 9.48678 0.169522 13.5455 0.224069 16.2153 0L25.7224 0.115721C28.0663 0.228108 29.1751 0.145092 29.9515 0.0097643L34.262 0.0574878",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-0.283367 -0.959011 -0.959011 0.283367 349.708 197.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.698 196.802C345.765 196.515 343.431 192.438 342.061 190.709 340.692 188.98 340.712 187.434 339.579 184.985L336.001 173.437C335.525 171.133 334.424 167.954 333.977 167.276 332.518 164.668 333.001 163.354 330.247 161.609",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.674 152.104C365.049 158.071 360.423 164.039 357.132 171.821 353.841 179.604 352.817 179.161 349.929 198.798",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.5 101.5C400.775 106.971 394.826 111.572 389.717 119.109 383.265 126.645 387.815 121.246 374.5 141.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5 112.5C402.893 121.597 394.617 130.693 387.077 139.789 379.538 148.886 372.78 158.654 367.263 167.079 361.747 175.504 356.605 185.272 353.978 190.342 351.351 195.412 351.502 197.5 351.502 197.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5 160.5C351.209 164.877 349.918 169.255 349.252 175.226 348.586 181.196 348.544 192.296 348.502 196.325 348.461 200.354 349.002 199.402 349.002 199.402",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.5 137.5C396.507 142.447 390.207 152.43 384.493 158.827 378.779 165.224 372.1 169.864 367.216 175.882 362.332 181.899 363.28 175.217 356.5 190.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 193.5 257.171 193.971C262.838 194.637 268.614 195.696 274.5 197.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5 171.5C272.819 171.649 276.369 171.934 280.202 173.517 284.035 175.101 289.281 178.669 292.498 181 295.714 183.33 294.905 182.718 299.5 187.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.676 160.5C323.545 163.496 323.264 166.534 323.901 169.867 324.538 173.201 323.939 173.201 327.5 180.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5 165.309C239.876 163.904 243.391 163.444 248.476 163.071 253.561 162.697 257.504 161.999 265.008 163.071 272.512 164.142 288.282 166.464 293.5 169.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5 157.5C251.578 157.656 253.656 157.813 256.823 158.813 259.99 159.813 260.649 159.344 268.5 163.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5 168.984C228.367 168.601 231.234 168.219 234.607 168.793 237.98 169.366 241.589 170.641 245.738 172.425 249.887 174.21 254.947 177.365 259.5 179.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5 184.5C222.2 182.061 225.467 179.692 230.3 177.859 235.133 176.025 244.233 174.088 247.5 173.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 141.196C258.831 140.174 261.163 139.153 264.238 139.614 267.314 140.075 271.282 141.756 274.952 143.963 278.623 146.171 282.955 150.289 286.262 152.859 289.569 155.429 291.421 157.11 294.794 159.383 298.167 161.657 301.937 164.391 306.5 166.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5 132.834C270.444 132.471 272.388 132.109 274.233 133.455 276.078 134.8 277.692 137.733 279.57 140.907 281.448 144.081 282.041 146.566 285.5 152.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5 97.5001C332.043 101.289 335.328 104.346 337.775 107.869 340.223 111.391 341.801 113.618 343.186 118.636 344.571 123.654 345.408 125.715 346.084 133.192 346.761 140.669 348.049 149.875 347.244 163.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.5 92.5001C362.46 94.386 359.42 96.2721 356.794 99.4486 354.168 102.625 351.439 106.43 349.746 111.559 348.053 116.688 347.086 124.397 346.637 130.221 346.188 136.044 346.982 140.346 347.051 146.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5 92.5001C407.465 94.5651 398.901 100.456 392.5 105.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.5 124.5C369.65 129.097 365.8 133.695 362.3 139.528 358.8 145.362 356.833 147.8 352.5 159.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5 85.5001C386.848 88.8111 383.195 92.1222 380.558 96.7675 377.92 101.413 375.045 108.793 374.673 113.372 374.301 117.952 374.639 116.502 374.673 119.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5 86.5001C374.599 91.8808 368.833 97.4289 364.378 104.949 359.922 112.468 356.078 122.027 353.765 131.619 351.452 141.211 351.35 145.556 350.5 162.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5 115.507C280.757 114.441 282.78 114.308 285.722 114.707 288.664 115.107 290.269 114.374 296.153 117.907 302.037 121.44 312.802 128.139 321.027 135.904 329.252 143.67 341.02 157.834 345.5 164.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5 96.5001C343.323 98.8751 342.146 101.25 341.715 104.417 341.284 107.583 341.582 109.332 341.914 115.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5 95.5001C310.411 97.7205 315.06 100.04 319.101 103.056 323.142 106.072 326.493 108.922 329.745 113.595 332.998 118.268 335.823 122.61 338.615 131.094 341.408 139.578 346.073 151.741 346.5 164.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 131.946C273.793 131.317 276.087 130.688 278.48 130.556 280.872 130.424 282.601 130.49 285.858 131.152 289.115 131.813 293.303 132.409 298.022 134.526 302.742 136.644 307.262 138.86 314.175 143.856 321.088 148.851 330.626 156.825 339.5 164.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.5 104.579C289.472 104.037 294.259 106.341 297.926 109.661 301.593 112.981 305.09 117.385 307.5 124.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5 411.872C173.75 411.135 179 410.398 186.7 410.512 194.4 410.625 207.4 411.721 214.7 412.552 222 413.384 224.8 414.14 230.5 415.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.525 426.5C197.391 425.699 197.625 424.833 202.954 423.167 208.284 421.5 221.121 418.33 229.5 416.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.862 429.5C206.023 427.185 206.761 426.109 207.867 424.609 208.974 423.109 210.516 420.924 213.5 420.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5 406.5C215.883 406.533 218.267 406.567 221.1 407.9 223.933 409.233 226.2 409.8 230.5 414.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5 405.5C255.452 406.424 250.521 406.093 246.688 407.593 242.855 409.093 237.776 408.988 234.5 414.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5 407.5C269.865 408.241 261.413 409.36 255.231 410.149 249.049 410.937 245.497 411.315 242.406 412.23 239.315 413.144 241.551 411.536 235.5 414.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.672 415.618C242.775 416.28 250.578 417.477 257.277 418.934 263.977 420.39 267.647 421.558 275.868 424.359",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5 416.5C240.054 418.515 243.609 420.53 246.776 422.864 249.942 425.197 252.883 427.283 255.5 430.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 417.5C230.106 419.567 228.713 421.733 227.879 423.9 227.046 426.067 226.615 427.333 226.5 430.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5 403.5C229.75 405.435 231 407.37 231.833 409.204 232.667 411.037 232.204 409.611 233.5 414.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.506 423.5C165.472 422.2 165.438 419.3 169.771 417.3 174.103 415.3 184.494 411.967 191.5 411.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 410.233C267.889 409.71 279.278 409.186 287.611 409.731 295.945 410.275 302.38 411.783 306.5 413.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.5 20.5001C470.458 24.3483 476.417 28.1966 483.881 34.5095 491.345 40.8224 503.087 49.2107 509.286 58.3774 515.484 67.5441 513.171 63.1771 519.5 75.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.5 22.5001C475.077 24.6623 478.655 26.8245 483.988 31.6579 489.321 36.4912 496.172 42.5542 503.5 51.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.5 30.5001C498.848 33.4678 500.443 36.8078 502.11 40.8078 503.776 44.8077 504.63 47.6539 506.5 54.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 24.5001C527.93 25.7297 526.359 26.9595 525.192 28.7928 524.026 30.6261 523.039 31.9676 522.5 35.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.5 26.5001C519.271 27.4407 520.953 29.322 522.074 32.9136 523.196 36.5052 524.003 40.952 524.227 48.0497 524.451 55.1475 524.99 63.4853 523.42 75.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.5 32.5001C556.626 33.6638 553.752 34.8276 550.493 37.931 547.233 41.0345 542.901 46.6379 539.941 51.1207 536.982 55.6035 534.58 61.2932 532.735 64.8277 530.891 68.3621 530.248 70.2155 528.875 72.3276 527.502 74.4397 524.5 77.5001 524.5 77.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.5 32.5001C547 34.7889 545.417 37.0334 544.25 39.7 543.083 42.3666 542.583 45.1667 541.5 48.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.5 39.5001C564.603 41.0417 562.705 42.5834 560.872 45.2501 559.039 47.9167 556.651 53.2501 555.5 55.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5 50.7419C580.344 49.8287 577.187 48.9155 572.344 49.9773 567.502 51.0391 559.719 54.1821 554.443 57.1128 549.168 60.0435 544.369 64.5458 540.693 67.5613 537.018 70.5769 534.424 73.55 532.392 75.2065 530.359 76.863 528.5 77.5001 528.5 77.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.5 59.5774C587.759 59.4693 582.018 59.3613 577.11 60.0957 572.201 60.8301 568.061 62.1695 564.049 63.9839 560.037 65.7985 556.622 68.8658 553.037 70.9828 549.451 73.0998 546.293 75.4327 542.537 76.6856 538.781 77.9385 532.464 78.2409 530.5 78.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.5 79.5562C534.631 80.0826 537.763 80.6091 542.643 79.7991 547.524 78.9892 555.126 75.9113 560.784 74.6963 566.442 73.4813 569.551 72.3878 576.592 72.5093 583.632 72.6308 596.373 73.9268 603.024 75.4253 609.676 76.9238 612.051 77.6526 616.5 81.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.5 81.5001C532.875 82.0644 535.251 82.6289 539.829 82.8025 544.407 82.9761 551.619 82.0644 557.968 82.542 564.317 83.0196 571.659 83.6709 577.922 85.6681 584.184 87.6653 591.224 91.3123 595.543 94.5252 599.861 97.7381 602.453 101.95 603.835 104.945 605.217 107.941 604.051 107.073 603.835 112.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5 86.5001C448.543 84.1814 448.586 81.8627 451.588 78.7711 454.591 75.6796 460.853 70.3122 466.515 67.9505 472.177 65.5889 479.382 64.086 485.559 64.6013 491.735 65.1166 498.641 68.7664 503.574 71.0421 508.506 73.3178 512.667 77.0965 515.154 78.2558 517.642 79.4152 517.599 79.1576 518.5 77.9982",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.625 112.5C488.368 109.948 488.454 108.434 489.394 106.011 490.333 103.589 491.231 100.994 494.264 97.9658 497.297 94.9378 503.533 90.3525 507.592 87.8436 511.65 85.3347 516.477 84.4695 518.613 82.9123 520.749 81.355 520.578 81.6145 520.407 78.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.5 87.5001C504.502 91.0885 501.922 94.6056 499.829 97.8613 497.735 101.117 496.587 103.594 495.939 107.034 495.291 110.474 495.42 113.616 495.939 118.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.5 80.5001C524.954 82.4672 527.408 84.4345 529.567 87.2118 531.726 89.9891 533.807 92.535 535.456 97.1638 537.105 101.793 539.147 109.662 539.461 114.985 539.775 120.308 538.126 126.017 537.341 129.103 536.555 132.189 535.927 131.571 534.749 133.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.5 82.5001C537.255 84.4822 543.852 85.959 549.886 89.589 555.919 93.219 562.149 100.277 565.702 104.28 569.255 108.283 570.402 110.693 571.204 113.607 572.006 116.522 570.975 119.787 570.516 121.769 570.058 123.751 570.058 122.935 568.453 125.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5 84.5001C544.754 86.0087 552.008 87.5174 558.747 90.6875 565.487 93.8577 573.369 99.7396 577.938 103.521 582.508 107.302 582.736 111.045 586.163 113.375 589.59 115.705 594.235 115.934 598.5 117.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.5 42.9273C428.689 41.5189 431.878 40.1105 436.4 39.7299 440.923 39.3493 445.793 39.3112 452.635 40.6434 459.476 41.9756 469.836 44.4499 477.45 47.7234 485.065 50.997 492.564 56.2879 498.323 60.2846 504.082 64.2813 508.644 69.0013 512.006 71.7039 515.369 74.4065 517.263 75.7007 518.5 76.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5 27.8362C434.892 27.4643 440.285 27.0924 446.32 28.5409 452.355 29.9894 459.012 32.5342 465.709 36.5273 472.406 40.5205 480.426 46.706 486.5 52.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5 66.9024C430.577 62.9111 436.654 58.9199 445.039 57.2335 453.423 55.547 465.231 54.5727 474.808 56.7838 484.385 58.9948 494.308 64.1291 502.5 70.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.5 112.5C541.886 115.706 544.272 119.071 545.605 122.238 546.939 125.404 547.255 126.275 547.5 131.5",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5 113.5C477.932 106.254 478.364 99.0079 481.318 93.8125 484.273 88.6172 489.818 84.5158 495.227 82.3283 500.636 80.1407 509.727 81.3255 513.773 80.6876 517.818 80.0496 518.045 80.2774 519.5 78.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.5 103.5C463.293 99.4649 465.086 95.4299 468.672 92.4475 472.259 89.465 478.879 87.0965 483.017 85.6053 487.155 84.1142 491.523 83.851 493.5 83.5001",
    stroke: "#548235",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "5.33333 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.5 200.5C225.727 199.094 225.909 197.508 228.773 196.147 231.636 194.787 238.591 193.427 242.682 192.339 246.773 191.251 250.818 190.843 253.318 189.618 255.818 188.394 256.409 187.351 257.682 184.994 258.955 182.636 259.182 177.875 260.955 175.472 262.727 173.069 265.318 171.528 268.318 170.576 271.318 169.623 275.409 169.941 278.955 169.76 282.5 169.578 284.955 170.122 289.591 169.487 294.227 168.853 301.909 167.356 306.773 165.951 311.636 164.545 315.227 161.916 318.773 161.054 322.318 160.193 325.273 160.51 328.046 160.782 330.818 161.054 333.136 162.006 335.409 162.686 337.682 163.367 339.273 164.953 341.682 164.863 344.091 164.772 347.682 163.23 349.864 162.142 352.046 161.054 352.773 159.694 354.773 158.334 356.773 156.974 359.227 154.933 361.864 153.981 364.5 153.029 368.5 154.117 370.591 152.621 372.682 151.125 373.773 147.724 374.409 145.004 375.045 142.283 374.5 139.699 374.409 136.299 374.318 132.898 373.455 127.911 373.864 124.601 374.273 121.291 375.182 119.115 376.864 116.44 378.546 113.765 380.636 110.545 383.955 108.55 387.273 106.555 393.546 105.558 396.773 104.47 400 103.382 401.136 103.019 403.318 102.022 405.5 101.024 408.409 99.6185 409.864 98.4849 411.318 97.3514 411.136 96.0819 412.046 95.2204 412.955 94.359 413.909 93.7695 415.318 93.3162 416.727 92.8628 420.5 92.5001 420.5 92.5001",
    stroke: "#385723",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.5 257.5C915.442 255.382 919.384 253.265 922.991 252.206 926.599 251.147 930.519 251.544 933.147 251.147 935.774 250.75 937.2 250.265 938.759 249.824 940.318 249.382 941.476 249.338 942.5 248.5",
    stroke: "#76553E",
    strokeWidth: 1.33333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 146.5C882.382 152.273 885.264 158.046 887.707 166.38 890.149 174.713 892.69 187.313 894.155 196.5 895.621 205.687 896.109 214.07 896.5 221.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 154.5C882.801 163.785 886.103 173.07 888.436 181.903 890.77 190.737 892.557 198.516 893.5 207.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 169.5C882 175.507 884.5 181.514 886.167 186.181 887.833 190.848 887.076 190.5 889.5 197.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.5 170.5C700.259 171.931 701.278 171.983 702.278 172.983 703.278 173.983 703.13 173.948 704.5 176.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.5 170.5C706.8 172.965 708.267 174.042 710.1 176.542 711.933 179.042 713.033 180.049 715.5 185.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.5 172.5C713.988 175.275 716.149 177.554 717.982 181.221 719.816 184.887 720.83 189.05 722.5 194.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.5 174.5C720.796 178.25 722.956 181.932 724.418 185.243 725.881 188.554 726.595 191.156 727.276 194.365 727.956 197.574 727.922 194.804 728.5 204.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.5 177.5C727.356 181.555 729.212 185.611 730.473 190.973 731.734 196.335 732.563 205.753 733.068 209.674 733.572 213.595 733.356 210.344 733.5 214.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.5 181.5C736.65 185.661 737.733 189.52 738.5 195.593 739.267 201.666 739.667 211.196 740.1 217.94 740.533 224.685 740.2 226.967 741.1 236.06 742 245.153 744 264.044 745.5 272.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.5 179.5C732.597 183.649 733.694 187.799 734.403 192.149 735.113 196.499 735.339 201.117 735.758 205.6 736.177 210.084 736.629 214.736 736.919 219.052 737.21 223.369 737.403 228.957 737.5 231.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.5 184.5C741.438 191.701 742.205 198.238 742.75 205.008 743.296 211.777 743.466 219.144 743.773 225.117 744.08 231.091 744.284 236.068 744.591 240.847 744.898 245.625 744.796 248.346 745.614 253.789 746.432 259.231 747.25 268.489 749.5 273.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.5 187.5C746.033 193.28 746.567 198.391 746.9 206.343 747.233 214.294 747.267 227.257 747.5 235.208 747.733 243.16 747.7 248.138 748.3 254.051 748.9 259.965 750.4 267.114 751.1 270.689 751.8 274.264 751.6 272.76 752.5 275.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.5 191.5C750.019 196.652 750.537 200.647 750.611 206.36 750.685 212.073 750.093 219.536 749.945 225.777 749.796 232.019 749.611 238.524 749.722 243.808 749.833 249.091 749.908 252.625 750.611 257.479 751.315 262.333 753.13 269.763 753.945 272.934 754.759 276.104 755.019 272.967 755.5 276.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.59 194.5C754.696 199.245 754.625 202.987 754.59 208.333 754.555 213.68 754.555 221.064 754.378 226.577 754.201 232.091 753.635 236.902 753.529 241.413 753.423 245.924 753.635 249.499 753.741 253.643 753.847 257.786 754.095 265.271 754.166 266.273 754.236 267.275 753.741 257.686 754.166 259.657 754.59 261.628 752.751 268.846 756.5 277.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.717 197.5C759.045 202.067 759.373 206.633 759.455 211.5 759.537 216.367 759.537 221.733 759.209 226.7 758.881 231.667 757.856 236.9 757.487 241.3 757.118 245.7 757.159 249.167 756.995 253.1 756.831 257.033 756.462 261.6 756.503 264.9 756.544 268.2 756.995 270.8 757.241 272.9 757.487 275 757.569 275.367 757.979 277.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.853 204.5C764.257 212.296 764.661 220.091 764.435 227.239 764.209 234.386 763.239 241.101 762.496 247.384 761.752 253.667 760.427 260.15 759.974 264.937 759.522 269.724 759.813 273.846 759.78 276.107 759.748 278.367 759.166 276.04 759.78 278.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.056 217.5C772.365 225.411 772.866 232.569 772.081 239.776 771.296 246.982 768.685 254.759 767.347 260.739 766.009 266.719 764.637 272.194 764.054 275.655 763.47 279.115 763.265 277.603 763.848 281.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.5 250.5C776.831 256.003 776.53 256.981 775.357 260.951 774.183 264.92 771.536 271.126 770.459 274.318 769.382 277.51 769.218 278.906 768.892 280.103 768.565 281.301 768.794 278.507 768.5 281.5",
    stroke: "#EDEDED",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.5 171.5C697.66 173.628 699.82 175.09 701.424 178.138 703.029 181.187 704.263 184.584 705.127 189.79 705.991 194.997 706.213 203.924 706.608 209.376 707.004 214.828 707.418 219.318 707.5 222.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.5 181.5C709.485 184.135 710.152 185.276 710.719 190.33 711.285 195.384 711.743 205.523 711.9 211.822 712.058 218.121 711.507 221.951 711.664 228.127 711.822 234.302 712.373 243.649 712.846 248.878 713.318 254.106 713.87 256.33 714.5 259.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.5 187.5C717.247 191.752 718.84 195.01 719.645 198.632 720.449 202.254 720.708 204.876 720.328 209.231 719.948 213.585 718.088 220.241 717.367 224.759 716.645 229.278 716.304 232.729 716 236.344 715.696 239.959 715.468 243.246 715.544 246.45 715.62 249.655 716.076 253.229 716.455 255.57 716.835 257.912 717.139 258.528 717.822 260.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.99 200.5C726.151 204.382 727.312 207.606 727.478 211.234 727.644 214.862 726.856 218.059 725.985 222.268 725.114 226.477 723.165 232.321 722.253 236.489 721.341 240.658 720.967 243.764 720.511 247.278 720.055 250.793 719.599 255.207 719.516 257.577 719.433 259.947 719.682 260.151 720.014 261.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.5 220.5C733.319 222.951 733.138 225.401 732.053 228.902 730.967 232.403 728.193 237.881 726.987 241.506 725.781 245.13 725.379 247.725 724.816 250.649 724.253 253.574 723.811 256.91 723.61 259.052 723.409 261.194 723.53 260.699 723.61 263.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.5 233.5C735.88 236.063 735.303 238.667 734.449 241.127 733.594 243.587 732.526 245.433 731.372 248.262 730.218 251.091 728.338 255.397 727.526 258.103 726.714 260.81 726.671 261.589 726.5 264.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.5 246.5C738.454 249.948 737.408 252.017 736.421 254.086 735.434 256.155 734.329 257.535 733.579 258.914 732.829 260.293 732.434 261.098 731.921 262.362 731.408 263.626 730.816 264.546 730.5 266.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.5 259.5C741.1 261.576 738.533 263.195 737.367 264.529 736.2 265.862 736.317 265.9 735.5 267.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.445 116.5C753.258 119.869 753.617 119.18 753.459 126.558 753.3 133.935 752.816 151.331 752.494 160.764 752.173 170.197 751.671 178.531 751.53 183.154 751.388 187.776 751.807 179.689 751.646 188.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.5 128.5C748.472 140.579 746.444 152.658 745.167 161.318 743.889 169.978 743.278 176.764 742.833 180.461 742.389 184.158 742.722 178.334 742.5 183.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.5 111.5C756.612 115.293 757.724 119.085 758.533 126.566 759.342 134.046 760.05 147.909 760.353 156.383 760.657 164.858 760.404 170.56 760.353 177.412 760.303 184.265 760.05 190.229 760.05 197.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.5 113.5C761.111 117.703 763.721 121.906 765.499 126.888 767.276 131.869 768.331 136.332 769.164 143.389 769.998 150.446 770.442 161.24 770.497 169.231 770.553 177.222 769.702 184.958 769.498 191.336 769.293 197.715 768.882 200.599 769.271 207.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.5 116.5C766.559 119.184 769.617 121.867 771.62 126.192 773.623 130.517 774.706 135.416 775.518 142.451 776.33 149.485 776.546 159.386 776.492 168.401 776.438 177.416 775.41 189.401 775.193 196.54 774.977 203.679 775.247 207.575 775.193 211.235 775.139 214.895 774.868 214.175 774.868 218.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.5 120.5C775.157 123.33 777.112 125.453 778.778 129.621 780.443 133.79 782.338 136.787 782.493 145.511 782.647 154.234 780.377 170.851 779.706 181.963 779.036 193.075 778.623 203.927 778.468 212.184 778.313 220.44 778.726 223.14 778.778 231.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.5 122.5C780.304 125.291 783.108 128.083 784.941 132.517 786.774 136.952 788.445 141.804 788.499 149.109 788.553 156.413 786.073 166.222 785.264 176.343 784.456 186.465 783.916 198.883 783.647 209.839 783.377 220.796 783.108 232.639 783.647 242.083 784.186 251.526 785.857 259.822 786.882 266.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.5 126.5C786.687 129.05 789.875 131.599 791.346 136.802 792.817 142.006 792.545 150.747 792.327 157.72 792.109 164.692 790.747 169.115 790.038 178.637 789.33 188.159 788.458 205.225 788.077 214.851 787.695 224.477 787.532 229.785 787.75 236.393 787.968 243.001 787.913 245.394 789.384 254.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.5 130.5C794.556 134.092 797.612 137.684 798.834 143.618 800.057 149.553 799.313 158.246 798.834 166.106 798.356 173.967 796.921 180.682 795.964 190.781 795.008 200.88 793.662 218.247 793.094 226.7 792.527 235.153 792.452 236.815 792.559 241.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.651 135.5C802.491 139.393 805.18 143.285 806.179 150.548 807.178 157.811 805.616 169.829 804.643 179.077 803.671 188.325 801.367 196.968 800.343 206.038 799.319 215.109 798.5 226.133 798.5 233.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.5 141.5C809.001 144.23 811.502 146.959 812.818 150.647 814.135 154.336 814.183 160.822 814.398 163.631 814.613 166.44 814.476 165.238 814.107 167.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 148.5C816.526 151.08 818.553 153.102 819.553 154.769 820.553 156.435 820.342 154.398 820.5 158.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 101.5C881.638 106.719 876.775 111.937 871.545 124.892 866.315 137.847 858.96 162.294 855.119 179.229 851.279 196.164 850.134 206.032 848.5 226.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.5 106.5C875.138 110.775 871.776 115.049 867.563 125.043 863.35 135.037 856.99 152.095 853.222 166.463 849.455 180.832 846.579 201.582 844.958 211.255 843.338 220.928 844.756 210.011 843.5 224.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.5 112.5C866.888 119.322 863.276 126.144 859.418 135.374 855.56 144.604 850.798 154.877 847.351 167.88 843.903 180.882 839.306 203.676 838.731 213.387 837.172 222.617 837.952 210.297 837.5 223.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.5 116.5C860.125 121.649 856.75 126.797 852.065 139.851 847.38 152.905 838.645 180.716 835.389 194.824 832.134 208.932 832.491 207.027 832.531 224.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.5 124.5C851.456 130.143 848.412 135.786 844.472 146.345 840.532 156.903 833.648 175.956 830.863 187.85 828.077 199.743 828.276 211.595 827.759 217.704 827.241 223.812 827.639 210.827 827.759 224.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.5 135.5C839.17 146.105 834.84 156.71 831.49 167.436 828.141 178.161 825.036 190.177 823.402 199.855 821.768 209.532 821.155 210.016 821.686 225.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.5 144.5C831.271 150.969 828.041 157.722 825.054 167.062 822.067 176.402 818.192 191.12 816.577 200.541 815.689 212.631 815.084 210.246 815.851 226.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.5 160.5C818.12 171.298 813.781 181.287 811.447 192.287 809.114 203.287 808.869 220.596 808.5 226.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.5 186.5C805.716 192.476 803.932 198.452 802.993 204.975 802.054 211.498 802.007 221.384 801.866 225.638 801.726 229.892 800.974 218.832 802.148 230.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.5 104.5C883.392 109.048 881.285 113.595 878.755 120.265 876.226 126.935 873.055 135.344 870.325 144.52 867.595 153.696 864.905 164.53 862.376 175.323 859.847 186.116 856.796 200.75 855.15 209.279 853.504 217.809 854.467 211.381 852.5 226.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.5 113.5C888.528 118 887.556 122.5 886.389 127 885.222 131.5 890.537 111.531 882.5 140.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.5 165.5C875.676 170.465 865.913 221.782 864.5 230.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.5 121.5C890.565 126.147 889.63 130.795 888.63 134.962 887.63 139.128 888.109 139.088 885.5 146.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.482 127.5C894.523 131.167 894.565 134.833 893.735 139.5 892.904 144.167 892.655 144.708 889.5 155.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.5 107.5C884.104 118.467 880.809 129.534 878.228 138.707 875.646 147.881 873.735 154.609 872.012 162.542 870.288 170.474 868.238 179.017 866.678 186.104 865.119 193.191 863.949 198.829 862.652 205.862 861.355 212.895 860.126 224.694 859.5 228.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.5 134.5 897.974 145.7C897.14 150.367 897.798 152.72 893.5 162.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.368 143.5C902.53 147.081 902.692 150.661 901.881 155.328 901.07 159.994 901.07 160.477 897.5 171.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.039 156.5C906.669 160.735 906.676 162.447 905.919 166.614 905.163 170.781 907.174 167.163 901.5 181.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.9 179.01C906.485 184.33 906.771 182.816 906.43 184.736 906.088 186.655 908.051 182.79 904.852 190.526",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 180.5C877.283 190.4 875.067 200.3 873.5 208.1 871.933 215.9 870.933 223.233 870.1 227.3 869.267 231.367 872.1 224.167 868.5 232.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.5 191.5C883.667 198.319 882.833 205.138 881.7 211.011 880.567 216.885 879.067 222.658 877.7 226.74 876.333 230.821 875.467 232.149 873.5 235.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.5 203.5C889.447 207.742 889.395 211.985 887.395 217.818 885.395 223.652 884.588 228.623 877.5 238.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.5 219.5C893.414 224.847 893.329 230.193 886.5 239.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.5 136.5C971.529 137.88 969.557 139.261 966.473 144.665 963.389 150.069 958.665 160.838 954.996 168.925 951.326 177.012 949.608 183.077 944.455 193.185 939.302 203.294 930.791 219.04 924.077 229.576 917.362 240.112 908.929 250.415 904.167 256.402 899.404 262.39 904.635 257.258 895.5 265.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.5 137.5C966.206 138.75 963.911 140 960.667 143.827 957.424 147.655 953.824 151.209 949.037 160.465 944.25 169.722 937.367 188.469 931.948 199.366 926.528 210.262 920.357 219.792 916.52 225.846 912.682 231.9 907.5 238.5 907.5 238.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.5 137.5C973.75 140.965 972 144.43 969.2 151.902 966.4 159.375 963.483 171.067 958.7 182.333 953.917 193.599 952.672 199.252 940.5 219.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.5 143.5C973.974 152.531 971.449 161.562 968.625 171.361 965.801 181.16 961.744 195.602 959.557 202.292 957.369 208.981 958.006 206.463 955.5 211.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.5 152.5C976.157 158.913 974.814 165.326 973.663 171.681 972.512 178.036 971.787 184.66 970.593 190.63 969.399 196.6 970.295 194.674 966.5 207.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.5 179.5C977 187.228 977.5 190.026 977 194.526 976.5 199.026 976.458 199.3 974.5 206.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.5 140.5C955.331 144.551 951.359 148.758 947.17 154.29 942.981 159.821 938.12 166.522 934.366 173.689 930.612 180.857 928.32 189.817 924.644 197.296 920.969 204.775 923.933 200.88 913.5 219.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.5 141.5C952.402 142.885 950.106 144.152 947.138 146.724 944.169 149.296 940.171 152.739 936.688 156.934 933.204 161.129 929.404 165.68 926.238 171.893 923.071 178.106 926.04 171.457 916.5 193.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.5 144.5C943.173 145.358 939.22 147.308 935.697 149.883 932.174 152.457 928.73 155.344 925.364 159.947 921.998 164.55 919.219 169.504 915.5 177.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.5 148.5C926.583 150.71 923.667 152.92 921.167 155.753 918.667 158.587 917.437 160.287 914.5 165.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.5 153.5C916.052 155.06 914.603 156.62 912.5 159.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.5 210.5 1015.79 211.382C1012.22 212.802 1008.83 214.37 1004.03 219.023 999.226 223.677 986.971 239.303 986.971 239.303 981.186 246.161 975.402 253.41 969.324 260.17 963.245 266.93 956.971 274.474 950.5 279.862 944.03 285.25 937.412 289.855 930.5 292.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.5 207.5C1009.92 207.65 1007.33 207.799 1003.85 210.792 1000.37 213.785 996.845 218.623 991.627 225.456 986.409 232.29 980.296 242.614 972.544 251.792 964.791 260.97 952.118 274.237 945.111 280.522 938.104 286.807 936.016 287.355 930.5 289.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.5 206.5C998.79 206.772 997.081 207.044 994.345 209.762 991.609 212.481 988.043 216.485 984.086 222.812 980.129 229.139 975.586 240.211 970.604 247.724 965.621 255.238 960.54 261.762 954.19 267.892 947.839 274.021 944.322 279.162 932.5 284.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.5 206.5C986.931 207.294 984.361 208.087 982.088 210.072 979.815 212.056 978.333 213.941 975.862 218.405 973.391 222.869 969.586 232.046 967.264 236.857 964.941 241.669 963.854 243.752 961.927 247.274 960 250.796 959.111 253.574 955.701 257.988 952.292 262.403 945.67 269.843 941.47 273.762 937.27 277.681 937.319 277.185 930.5 281.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.5 208.5C974.153 209.654 970.806 210.808 967.46 214.688 964.113 218.567 960.569 225.049 957.42 231.777 954.27 238.505 952.547 247.933 948.56 255.054 944.574 262.174 937.437 269.442 933.5 274.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.5 210.5C964.057 212.118 960.614 213.735 957.779 216.088 954.943 218.441 952.715 220.598 950.487 224.618 948.26 228.637 945.576 236.726 944.411 240.206 943.247 243.686 943.703 243.833 943.5 245.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.5 217.5C946.89 219.048 944.281 220.597 942.044 223.016 939.807 225.435 937.67 228.436 936.079 232.016 934.488 235.597 934.389 235.355 932.5 244.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.5 215.929C1030.33 214.804 1026.16 213.679 1021.47 215.342 1016.78 217.005 1011.84 220.966 1006.36 225.905 1000.88 230.844 988.59 244.978 988.59 244.978 982.765 251.188 977.581 256.91 971.41 263.17 965.24 269.429 957.341 277.645 951.565 282.536 945.79 287.426 941.1 290.018 936.756 292.512 932.411 295.006 933.053 294.957 925.5 297.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.5 191.5C900.046 198.425 901.836 205.603 902.34 214.769 902.844 223.936 902.138 236.276 900.525 246.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.5 171.5C895.337 175.507 898.174 179.515 900.136 186.32 902.098 193.124 903.742 204.466 904.272 212.329 904.802 220.193 904.378 218.529 903.317 233.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.5 235.5C1004.35 239.358 1000.21 243.216 992.917 251.839 985.625 260.463 972.19 278.265 964.748 287.242 957.306 296.218 953.16 301.261 948.266 305.699 943.371 310.137 940.674 311.902 935.38 313.869 930.085 315.836 921.195 317.399 916.5 317.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.5 249.5C982.288 259.667 974.284 269.835 966.733 278.564 959.182 287.294 952.285 296.225 946.194 301.876 940.103 307.528 934.968 310.202 930.186 312.473 925.404 314.743 922.232 314.895 917.5 315.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.5 272.5C957.384 284.54 949.293 293.097 943.093 299.067 936.892 305.037 935.228 306.082 931.296 308.321 927.364 310.56 924.037 311.555 919.5 312.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.5 231.5 988.766 263.893C980.693 274.141 972.922 285.388 966.06 292.987 959.197 300.585 953.243 305.584 947.592 309.483 941.94 313.382 937.5 314.882 932.151 316.382 926.803 317.881 920.092 318.631 915.5 318.481",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.5 250.5C939.129 254.994 935.758 259.487 932.694 264.96 929.629 270.433 926.156 277.814 924.113 283.337 922.07 288.86 922.121 293.178 920.436 298.098 918.75 303.019 916.656 308.793 914 312.86 911.344 316.927 908.535 318.835 904.5 322.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.5 251.5C935.614 254.009 932.677 256.12 930.139 259.249 927.601 262.379 925.859 264.961 923.271 270.276 920.683 275.591 917 284.93 914.611 291.139 912.222 297.348 911.177 302.415 908.938 307.531 906.698 312.648 903.413 318.509 901.174 321.837 898.934 325.165 897.839 325.563 895.5 327.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.5 252.5C929.604 254.732 926.709 256.964 924.04 259.804 921.371 262.645 918.953 264.319 916.486 269.543 914.018 274.768 911.55 284.609 909.234 291.152 906.917 297.696 904.399 304.188 902.586 308.804 900.773 313.42 900.371 315.398 898.356 318.848 896.342 322.297 893.925 325.645 890.5 329.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.5 252.5C924.763 254.019 922.025 255.539 919.664 257.665 917.304 259.792 915.395 261.21 913.336 265.262 911.276 269.313 909.167 276.352 907.308 281.973 905.45 287.594 904.094 293.317 902.185 298.988 900.276 304.66 898.167 311.294 895.856 316.004 893.546 320.713 890.381 324.663 888.322 327.246 886.263 329.829 885.911 329.778 883.5 331.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.5 257.5C912.71 260.383 909.92 263.266 907.5 267.428 905.08 271.59 902.809 277.105 900.981 282.47 899.154 287.835 897.92 294.053 896.537 299.619 895.154 305.184 894.858 311.051 892.685 315.865 890.512 320.678 885.969 325.692 883.5 328.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.5 264.5C902.097 266.589 898.504 271.429 896.473 275.811 894.441 280.193 893.599 285.135 892.311 290.79 891.023 296.446 890.378 304.292 888.743 309.744 887.108 315.195 885.027 318.966 882.5 323.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.5 273.5C889.85 276.89 887.2 280.281 885.3 284.651 883.4 289.021 882.4 294.244 881.1 299.719 879.8 305.194 878.6 312.979 877.5 317.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.5 290.5C877.117 291.824 875.735 293.147 874.648 295.794 873.562 298.441 872.673 303.098 871.982 306.382 871.29 309.667 871.438 311.726 870.5 315.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.5 296.5C867.263 298.167 866.026 299.833 865.026 303.167 864.026 306.5 863.184 312.51 862.5 316.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.5 301.5C857.629 304.122 856.757 306.743 856.26 309.91 855.762 313.076 855.43 316.97 855.513 320.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.5 311.5C849.706 313.975 848.912 316.45 848.819 319.653 848.502 321.986 848.409 323.656 848.596 325.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.5 218.5C899.273 230.74 899.349 239.939 897.682 248.605 896.015 257.272 895.561 260.617 889.5 270.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.5 357.692C877.483 358.287 879.467 358.883 882.967 358.185 886.467 357.486 889.85 357.075 896.5 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.5 358.737C876.06 359.653 877.621 360.569 881.287 360.496 884.954 360.423 890.298 360.129 896.5 358.297 902.702 356.464 910.036 352.286 918.5 349.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.5 360.47C876.358 362.149 878.217 363.828 881.236 364.276 884.256 364.723 887.469 364.574 892.618 363.156 897.767 361.738 907.291 357.671 912.13 355.768 916.969 353.865 918.092 352.784 921.654 351.739 925.215 350.694 927.577 350.209 933.5 349.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.5 364.33C877.844 366.309 880.188 368.287 884.172 368.479 888.156 368.671 893 367.519 899.406 365.483 905.813 363.447 914.094 358.76 922.609 356.263 931.125 353.766 940.344 351.499 950.5 350.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.5 368.875C882.402 370.243 884.305 371.612 888.188 371.493 892.07 371.374 898.593 369.946 903.796 368.161 908.998 366.376 913.114 363.083 919.404 360.782 925.693 358.482 934.351 355.903 941.534 354.356 948.717 352.809 955.045 351.976 962.5 351.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.5 373.135C886.24 374.405 886.98 375.676 890.64 375.48 894.3 375.285 901.036 374.308 907.46 371.963 913.885 369.618 922.178 364.185 929.187 361.411 936.195 358.636 943.126 356.799 949.511 355.314 955.897 353.829 958.739 352.539 967.5 352.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.5 376.818C897.693 377.445 900.886 378.071 905.784 376.583 910.681 375.095 923.884 367.891 923.884 367.891 929.095 365.424 931.446 364.015 937.049 361.783 942.651 359.551 949.978 356.223 957.5 354.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.5 379.707C904.531 380.461 906.562 381.215 911.783 379.243 917.005 377.272 927.101 371.203 933.831 367.879 940.561 364.555 946.054 361.695 952.166 359.298 958.277 356.902 962.184 355.124 970.5 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.5 381.5C914.117 381.461 916.734 381.422 922.434 378.933 928.134 376.444 938.835 370.028 945.698 366.567 952.561 363.106 958.144 360.344 963.611 358.167 969.078 355.989 971.25 355.095 978.5 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.5 381.5C924.942 381.105 928.383 380.709 932.764 378.653 937.144 376.596 941.446 372.641 947.782 369.161 954.117 365.681 964.325 360.381 970.778 357.771 977.231 355.161 978.835 355.003 986.5 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.5 380.5C940.792 378.768 945.085 377.035 949.611 374.527 954.138 372.018 958.586 368.274 963.659 365.447 968.732 362.62 974.741 359.553 980.048 357.562 985.355 355.571 989.023 354.814 995.5 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.5 375.5 970.897 365.83C975.729 363.09 977.894 361.115 982.495 359.06 987.095 357.005 992.933 355.313 998.5 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.5 338.5C791.117 338.749 787.734 338.998 785.202 340.109 782.67 341.22 780.402 342.102 779.306 345.167 778.21 348.232 778.512 353.251 778.625 358.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.5 340.915C797.472 340.556 792.444 340.196 789.197 340.915 785.95 341.635 784.287 341.635 783.02 345.232 781.753 348.83 781.278 356.584 781.595 362.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.5 343.214C801.649 342.7 798.798 342.185 796.233 342.739 793.669 343.294 790.722 343.967 789.115 346.541 787.507 349.115 786.933 354.857 786.589 358.184 786.245 361.51 787.01 360.599 787.048 366.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.5 346.486C806.305 345.789 803.11 345.091 800.493 345.789 797.875 346.486 795.374 348.501 793.795 350.671 792.217 352.84 791.409 355.669 791.024 358.807 790.639 361.945 789.869 363.805 791.486 369.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.5 336.784C787.494 336.505 784.488 336.226 782.053 337.022 779.618 337.818 777.031 338.814 775.889 341.56 774.748 344.306 773.797 344.386 775.205 353.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.5 335.666C778.098 335.493 775.697 335.32 773.906 335.897 772.115 336.473 770.242 337.357 769.753 339.124 769.265 340.891 769.387 342.044 770.975 346.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.5 332.5C771.087 330.659 769.299 329.203 768.5 332.308",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.5 349.796C809.002 348.41 805.504 347.025 802.706 347.658 799.907 348.291 797.031 350.469 795.71 353.597 794.388 356.724 794.272 362.94 794.777 366.424 795.282 369.908 794.855 368.799 798.741 374.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 351.949C811.518 351.092 808.535 350.235 805.968 350.577 803.4 350.92 800.477 351.645 799.094 354.007 797.712 356.37 797.198 361.172 797.672 364.754 798.146 368.336 798.304 369.936 801.938 375.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.5 354.181C813.262 353.204 810.025 352.226 807.866 352.571 805.708 352.916 804.42 354.258 803.549 356.252 802.678 358.246 802.262 361.161 802.64 364.535 803.019 367.91 802.413 371.515 805.821 376.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.5 355.214C815.588 354.695 812.676 354.177 810.602 354.753 808.527 355.329 806.772 356.328 806.054 358.672 805.336 361.016 805.217 365.512 806.294 368.817 807.371 372.121 808.527 374.388 812.516 378.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.5 355.5C818.008 355.619 814.516 355.737 812.691 356.686 810.865 357.634 810.707 358.938 810.548 361.191 810.389 363.443 810.588 367.316 811.738 370.201 812.889 373.086 812.73 374.113 817.453 378.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.5 355.5C821.557 356.418 819.614 357.337 818.568 358.375 817.521 359.413 817.521 360.172 817.222 361.729 816.923 363.287 816.064 364.924 816.774 367.719 817.484 370.514 817.97 372.99 821.482 378.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.625 354.5C824.08 355.84 822.535 357.18 822.5 360.5 822.466 363.82 824.584 371.42 825.417 374.42 826.25 377.42 824.792 374.54 827.5 378.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 354.5C826.884 356.777 827.268 359.055 827.955 362.104 828.642 365.153 829.53 370.064 830.621 372.797 831.712 375.53 829.975 373.51 834.5 378.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.5 352.5C829.769 353.535 831.039 354.57 832.423 356.41 833.808 358.25 835.462 360.358 836.808 363.54 838.154 366.722 839.923 370.133 840.5 375.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.5 351.627C832.44 351.42 834.38 351.213 836.486 353.205 838.592 355.197 841.807 360.196 843.137 363.578 844.468 366.961 844.578 367.524 844.468 373.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.5 349.401C834.064 348.323 835.628 347.245 837.535 347.553 839.442 347.861 841.96 349.209 843.943 351.249 845.927 353.29 848.177 356.254 849.436 359.796 850.695 363.338 851.572 366.225 851.496 372.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.5 345.376C837.211 344.339 838.921 343.302 841.098 343.532 843.275 343.763 846.385 344.8 848.562 346.759 850.738 348.718 852.838 351.331 854.159 355.288 855.481 359.244 856.608 361.972 856.492 370.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.5 340.481C840.84 339.723 843.181 338.966 846.247 340.015 849.314 341.063 854.479 343.314 856.9 346.77 859.321 350.225 860.007 357.29 860.774 360.745 861.54 364.2 860.976 362.725 861.5 367.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.5 336.604C843.602 334.675 844.704 332.745 847.789 333.798 850.873 334.85 857.724 337.968 861.01 342.919 864.295 347.869 866.619 354.847 867.5 363.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.5 331.524C852.531 331.467 856.562 331.409 859.407 332.673 862.253 333.938 863.992 337.041 865.572 339.11 867.153 341.179 867.904 342.022 868.892 345.087 869.88 348.152 871.263 348.995 871.5 357.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.5 329.383C853.558 327.749 856.616 326.114 859.904 326.581 863.191 327.048 867.74 329.655 870.225 332.185 872.71 334.715 873.933 338.607 874.812 341.759 875.003 346.312 875.385 343.977 875.5 352.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.5 324.965C861.089 323.518 864.677 322.071 867.798 322.619 870.918 323.166 874.273 324.769 876.223 328.25 878.174 331.73 878.915 331.456 879.5 343.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.5 282.5C762.41 282.853 764.32 283.205 767.213 288.846 770.107 294.486 775.431 309.724 777.861 316.343 780.292 322.963 780.523 325.705 781.796 328.564 783.069 331.424 783.764 331.972 785.5 333.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.5 247.5C671.629 251.042 675.37 254.191 680.873 261.046 686.376 267.901 693.224 279.436 700.515 288.63 707.807 297.825 718.291 309.737 724.622 316.215 730.953 322.693 733.813 324.108 738.5 327.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.5 251.5C681.136 254.12 684.773 256.74 689.465 262.763 694.157 268.785 701.117 280.986 705.653 287.634 710.188 294.282 711.322 296.316 716.679 302.651 722.036 308.986 730.99 320.17 737.793 325.645 744.597 331.12 749.797 332.802 757.5 335.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.5 253.5C689.922 255.668 693.344 257.836 698.167 264.418 702.989 271 709.6 284.318 715.433 292.99 721.267 301.662 727.528 310.219 733.167 316.452 738.805 322.685 744.211 327.215 749.267 330.39 754.322 333.564 757.278 333.603 763.5 335.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.5 255.5C698.933 258.217 703.367 260.935 707.333 266.057 711.3 271.179 713.867 278.726 718.3 286.233 722.733 293.741 729.383 304.61 733.933 311.101 738.483 317.592 740.505 321.111 745.6 325.177 750.694 329.244 757.5 332.607 764.5 335.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.5 260.5C709.135 261.937 711.77 263.374 715.635 269.587 719.5 275.801 724.888 289.083 729.689 297.782 734.491 306.481 739.644 315.995 744.446 321.782 749.248 327.568 751.863 329.549 758.5 332.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.5 262.5C715.072 264.122 717.643 265.744 721.922 272.585 726.202 279.425 733.268 294.826 738.176 303.542 743.083 312.259 746.813 319.725 751.367 324.884 755.921 330.044 759.297 331.959 765.5 334.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.5 264.5C722.847 265.644 725.195 266.789 730.045 274.917 734.895 283.045 743.858 303.84 749.601 313.27 755.343 322.701 760.465 327.475 764.5 331.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.5 268.5C729.959 269.739 732.418 270.978 735.696 275.933 738.975 280.888 743.385 291.032 747.171 298.232 750.957 305.433 755.523 314.26 758.411 319.138 761.3 324.016 761.846 324.635 764.5 327.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.5 271.5C741.219 273.933 743.939 276.367 746.891 281.466 749.843 286.564 753.107 295.642 756.214 302.092 759.322 308.543 763.323 316.268 765.538 320.17 767.752 324.071 766.548 321.831 769.5 325.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.5 276.5C751.922 278.054 754.344 279.607 756.531 283.259 758.719 286.91 760.828 293.513 762.625 298.407 764.422 303.301 765.125 307.69 767.312 312.623 769.5 317.556 773.719 324.858 775.75 328.004 777.781 331.15 778.016 330.607 779.5 331.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.5 294.5C779.405 296.835 781.31 299.171 782.879 303.608 784.448 308.045 785.905 316.53 786.914 321.123 787.922 325.716 788.333 329.102 788.931 331.165 789.529 333.227 788.707 331.204 790.5 333.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.5 302.5C789.318 305.357 792.135 308.214 793.554 312.024 794.973 315.833 794.689 321.944 795.014 325.357 795.338 328.77 794.73 327.818 795.5 332.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.163 318.5C800.881 321.65 801.599 324.8 801.489 327.133 801.378 329.467 800.992 328.378 799.5 332.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.5 318.5C681.049 324.677 687.598 330.853 692.853 335.282 698.108 339.711 701.755 342.702 706.029 345.071 710.304 347.441 709.833 347.635 718.5 349.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.5 321.5C690.238 329.542 698.975 337.585 706.309 342.418 713.642 347.251 720.156 349.074 725.5 350.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.5 324.5C696.414 330.226 703.328 335.952 710.828 340.286 718.328 344.619 727.391 348.527 734.5 350.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.5 326.5C706.948 333.106 716.397 339.712 724.73 343.712 733.064 347.712 740.34 349.167 747.5 350.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.5 330.5C715.606 334.143 720.712 337.786 727.545 340.786 734.378 343.786 745.511 346.864 751.5 348.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.5 335.5C734.157 339.279 741.965 342.623 747.299 344.285 752.632 345.947 754.589 345.393 759.5 345.472",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5 310.5C664.049 313.771 666.52 317.121 670.441 320.791 674.363 324.46 681.186 329.566 685.03 332.517 688.873 335.469 684.794 334.033 693.5 338.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.5 240.667C696.363 240.434 698.226 240.201 700.088 241.787 701.951 243.372 704.108 247.897 705.677 250.182 707.245 252.468 704.941 248.69 709.5 255.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.5 268.028C623.628 266.658 625.756 265.289 631.366 268.321 636.976 271.353 647.713 279.521 655.161 286.221 662.609 292.922 670.83 303.143 676.054 308.523 681.277 313.903 679.778 312.582 686.5 318.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.5 269.874C624.663 269.394 625.826 268.914 630.186 271.602 634.547 274.29 642.444 279.186 649.663 286.003 656.882 292.819 663.568 301.268 673.5 312.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.5 271.5C634.967 277.057 642.435 282.615 648.602 288.615 654.768 294.615 657.081 297.812 664.5 307.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.5 264.947C628.88 263.738 631.844 265.14 635.827 267.268 639.811 269.396 643.649 271.621 650.401 277.715 657.154 283.808 669.493 296.866 676.343 303.831 683.193 310.795 686.448 315.196 691.5 319.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.5 262.752C633.077 261.782 634.654 260.812 637.906 262.17 641.157 263.528 645.719 266.049 651.009 270.898 656.299 275.746 663.869 284.716 669.644 291.262 675.419 297.808 681.097 305.323 685.659 310.172 690.221 315.021 692.841 317.785 697.015 320.354 701.188 322.924 705.119 324.233 710.7 325.591 716.281 326.948 722.881 327.918 730.5 328.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.5 259.665C638.543 258.656 639.587 257.648 643.323 259.665 647.059 261.681 653.804 265.427 659.918 271.766 666.032 278.105 673.941 290.351 680.006 297.699 686.072 305.046 690.779 311.674 696.31 315.852 701.842 320.03 707.665 321.326 713.196 322.767 718.728 324.208 724.162 324.544 729.5 324.496",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.5 257.521C646.681 257.377 649.686 257.905 654.096 261.261 658.506 264.618 664.952 270.756 670.961 277.661 676.971 284.567 685.209 296.699 690.153 302.693 695.096 308.687 696.695 310.845 700.621 313.626 704.546 316.408 709.392 318.278 713.706 319.381 718.019 320.484 720.781 320.772 726.5 320.244",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.5 255.759C649.781 255.469 652.062 255.18 655.071 256.337 658.08 257.493 661.817 259.276 665.554 262.698 669.291 266.119 673.125 270.986 677.492 276.865 681.86 282.744 687.247 291.948 691.761 297.972 696.274 303.995 699.283 309.585 704.573 313.007 709.863 316.428 719.035 318.163 723.5 318.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.5 253.059C655.273 252.497 658.046 251.935 661.47 253.645 664.894 255.355 668.463 257.798 673.045 263.319 677.626 268.84 683.703 279.1 688.96 286.771 694.216 294.442 699.328 304.556 704.585 309.344 709.842 314.132 716.401 315.158 720.5 315.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.5 287.5C698.928 294.241 702.356 300.982 705.856 304.982 709.356 308.982 711.082 310.315 716.5 311.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.5 330.993C729.347 331.28 732.194 331.568 734.36 331.486 736.527 331.404 736.477 331.28 739.5 330.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.5 335.325C738.5 335.477 739.5 335.629 741 335.325 742.5 335.021 743.35 334.754 745.5 333.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.5 338.5C748.843 337.889 750.185 337.278 752.5 335.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.5 245.948C675.5 245.258 677.796 245.689 679.13 245.948 680.463 246.207 677.944 244.007 681.5 247.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.5 243.853C681.686 243.511 683.872 243.169 685.705 244.11 687.539 245.051 687.021 244.837 690.5 249.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.5 241.895C690.854 241.036 691.126 241.601 692.96 243.368 694.793 245.136 697.072 248.032 699.5 252.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.5 239.561C704.4 239.254 705.4 240.105 707.3 242.139 708.8 244.462 710.1 249.868 711.5 253.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.5 334.825C892.907 337.802 900.314 340.779 906.551 342.197 912.788 343.615 915.663 343.662 922.924 343.331 930.184 343 939.638 342.859 950.115 340.212 960.591 337.566 976.477 330.573 985.784 327.454 995.091 324.335 999.672 321.5 1005.96 321.5 1012.24 321.5 1018.72 324.43 1023.5 327.454",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.5 308.5 972.984 302.088C977.597 300.511 978.763 299.798 983.182 299.035 987.602 298.272 995.858 297.406 999.5 297.508",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.5 304.5C964.781 301.74 970.062 298.979 975.562 297.313 981.062 295.646 986.173 294.5 992.5 294.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.5 298.5C969.287 296.368 972.027 295.079 974.861 294.079 977.694 293.079 980.852 292.869 983.5 292.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.5 322.355C916.585 323.293 922.67 324.231 929.991 322.651 937.312 321.072 954.427 312.879 954.427 312.879 961.118 310.164 964.221 308.338 970.136 306.364 976.052 304.39 983.858 301.823 989.918 301.034 995.979 300.244 1000.29 300.244 1006.5 301.626",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.5 324.856C912.192 325.704 917.206 326.988 924.231 326.309 931.255 325.631 940.217 323.596 948.647 320.785 957.076 317.975 965.99 312.16 974.807 309.446 983.624 306.733 994.766 304.552 1001.55 304.504 1008.33 304.455 1010.75 304.843 1015.5 309.156",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.5 327.95C906.183 329.281 916.985 331.204 923.22 331.5 930.567 330.021 934.433 331.5 946.71 327.358 958.697 323.018 964.013 319.715 970.49 317.002 976.967 314.29 979.77 312.663 985.57 311.085 991.37 309.507 999.635 307.189 1005.29 307.535 1010.95 307.88 1014.62 310.641 1019.5 313.156",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.5 329.859C899.434 331.558 902.369 333.257 909.013 334.056 915.657 334.856 926.133 336.505 936.366 334.656 946.599 332.807 960.422 326.81 970.412 322.962 980.403 319.114 989.618 313.417 996.311 311.568 1003 309.719 1006.2 310.569 1010.57 311.868 1014.93 313.168 1018.91 315.766 1022.5 319.364",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.5 332.153C899.077 335.776 908.654 339.4 920.05 339.498 931.445 339.596 946.186 336.168 957.873 332.741 969.559 329.313 981.731 321.772 990.168 318.932 998.606 316.092 1002.78 315.014 1008.5 315.7 1014.22 316.385 1020.38 319.862 1024.5 323.045",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.5 337.5C888.604 340.273 891.428 342 895.095 343.5 898.761 345 898.018 345.455 905.5 346.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.5 340.5C884.667 342.3 886.833 344.1 889 345.6 891.167 347.1 895.5 349.5 895.5 349.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.5 344.5C881.7 345.286 881.9 346.072 887.5 350.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.5 345.5C952.451 344.847 957.401 344.195 963.938 342.019 970.475 339.843 979.559 334.864 986.721 332.446 993.883 330.029 1000.61 327.273 1006.91 327.515 1013.2 327.757 1019.6 330.464 1024.5 333.897",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.5 347.324C971.649 345.781 977.215 342.768 983 340.857 988.785 338.946 994.424 336.741 1000.21 335.859 1005.99 334.978 1012.99 333.459 1017.71 335.566 1022.42 337.672 1025.92 342.866 1028.5 348.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.5 348.418 998.402 343.279C1003.77 342.332 1006.99 342.377 1010.7 342.738 1014.4 343.099 1018.01 344.316 1020.65 345.443 1023.28 346.57 1024.74 346.75 1026.5 349.5",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.5 349.5C999.906 348.654 1003.31 347.809 1006.65 347.655 1009.98 347.501 1013.07 347.143 1016.5 348.578",
    stroke: "#EDE8E9",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5 154.5C448.543 157.57 454.586 160.64 459.086 165.473 463.586 170.306 467.121 173.703 469.5 183.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 151.5C433.855 151.868 433.209 152.237 433.639 158.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5 150.5C435.216 151.028 436.931 151.556 440.5 153.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.687 160.5C429.96 167.509 429.233 174.519 429.597 181.052 429.96 187.586 431.05 194.627 432.868 199.702 434.685 204.776 437.168 207.377 440.5 211.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.5 160.5C430.952 168.371 431.405 176.241 432.827 183.638 434.248 191.035 436.252 199.569 439.031 204.879 441.81 210.19 444.201 212.529 449.5 215.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5 160.5C432.979 166.516 434.786 172.595 436.627 178.833 438.467 185.072 440.307 192.647 442.542 197.931 444.777 203.214 447.209 207.607 450.035 210.535 452.862 213.463 454.833 213.399 459.5 215.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5 160.5C433.177 162.396 434.855 164.293 436.631 167.057 438.407 169.821 438.999 172.072 442.156 177.086 445.313 182.1 452.286 191.807 455.574 197.143 458.863 202.479 460.902 206.207 461.889 209.1 462.876 211.993 462.613 212.314 461.494 214.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5 161.5 445.962 172.339C449.782 176.016 454.303 179.629 457.423 183.565 460.543 187.5 463.217 191.629 464.682 195.952 466.146 200.274 466.974 202.339 466.21 209.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5 166.5C448.573 170.436 454.646 174.371 458.993 178.113 463.34 181.855 466.665 184.887 468.582 188.952 470.5 193.016 470.372 199.597 470.5 202.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5 155.5C443.028 157.345 443.556 159.191 445.5 165.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.5 154.5C444.813 156.367 446.125 158.233 447.625 160.9 449.125 163.567 450.063 165.833 452.5 170.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5 154.5C445.637 156.395 448.774 158.291 451.613 160.839 454.453 163.387 457.557 167.178 459.538 169.788 461.519 172.398 461.321 171.839 463.5 176.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5 150.5C433.679 152.327 433.857 154.154 436.5 160.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5 150.5C434.688 151.833 435.875 153.167 436.875 154.5 437.875 155.833 437.313 154.379 439.5 158.5",
    stroke: "#C95653",
    strokeWidth: 0.333333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.5 512.992C818.786 510.796 819.071 508.6 821.07 507.042 823.068 505.483 827.065 502.862 830.491 503.642 833.917 504.421 839.77 507.467 841.626 511.717 843.481 515.967 841.84 525.813 841.626 529.143 841.412 532.472 840.198 529.355 840.341 531.693 840.484 534.03 842.411 539.414 842.482 543.168 842.554 546.922 841.768 551.314 840.769 554.219 839.77 557.123 837.557 559.531 836.487 560.594 835.416 561.656 834.345 561.94 834.345 560.594 834.345 559.248 836.273 555.21 836.487 552.519 836.701 549.827 836.273 547.347 835.63 544.443 834.988 541.539 833.632 537.785 832.632 535.093 831.633 532.401 830.634 530.418 829.635 528.293 828.635 526.168 826.708 525.034 826.637 522.342 826.566 519.651 827.993 511.717 829.206 512.142 830.42 512.567 833.917 524.893 833.917 524.893",
    stroke: "#213315",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.5 558.5C827.323 557.103 830.147 555.706 831.98 553.206 833.813 550.706 834.253 550.485 835.5 543.5",
    stroke: "#213315",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.617 543.5C822.896 541.544 822.175 539.588 822.656 536.088 823.136 532.588 823.297 529.5 826.5 522.5",
    stroke: "#213315",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.5 504.741C833.08 501.995 834.572 493.951 835.734 489.414 836.897 484.877 839.24 477.071 839.477 477.519 839.713 477.967 838.118 487.431 837.152 492.102 836.187 496.773 836.044 494.881 835.039 505.5",
    stroke: "#213315",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.5 475.095 815.113 468.052C821.36 465.59 830.919 461.69 834.984 460.327 839.048 458.963 837.43 459.645 839.5 459.872 841.57 460.099 844.167 460.364 847.403 461.69 850.64 463.015 855.043 464.757 858.919 467.824 862.796 470.892 866.898 476.648 870.661 480.094 874.425 483.539 876.495 484.448 881.5 488.5",
    stroke: "#869644",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "2.66667 2 0.666667 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.5 474.803C815.3 472.534 821.1 470.264 825.877 467.883 830.653 465.502 834.292 460.814 838.159 460.517 842.026 460.219 845.665 463.977 849.077 466.097 852.488 468.218 855.559 470.674 858.63 473.241 861.7 475.808 864.581 478.598 867.5 481.5",
    stroke: "#869644",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "2.66667 2 0.666667 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.5 467.047C832.6 464.256 834.7 461.465 836.8 460.71 838.9 459.956 841.15 461.389 843.1 462.521 845.05 463.652 845.463 464.256 848.5 467.5",
    stroke: "#869644",
    strokeWidth: 0.666667,
    strokeMiterlimit: 8,
    strokeDasharray: "2.66667 2 0.666667 2",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.118762-0.311459 139.445 52.8149 139.207 53.4378-0.118762 0.311459ZM139.506 48.9138 145.555 55.5016 136.655 56.3888Z",
    transform: "matrix(1 0 0 -1 866.5 242.002)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(1015.4 195)"
  }, "Carpel"), /*#__PURE__*/React.createElement("path", {
    d: "M0.333333-8.46668e-07 0.333421 34.6667-0.333245 34.6667-0.333333 8.46668e-07ZM4.00008 33.3333 0.000104987 41.3333-3.99992 33.3333Z",
    transform: "matrix(1 0 0 -1 861.5 133.833)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(837.839 88)"
  }, "Petal"), /*#__PURE__*/React.createElement("path", {
    d: "M855.502 271.167 1012.01 272.178 1012 272.844 855.498 271.833ZM1010.7 268.502 1018.67 272.554 1010.65 276.502Z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(1020.09 279)"
  }, "Receptacle"), /*#__PURE__*/React.createElement("path", {
    d: "M0.000830427-0.333332 156.507 0.0565686 156.505 0.723233-0.000830427 0.333332ZM155.182-3.61341 163.172 0.406509 155.162 4.38657Z",
    transform: "matrix(1 0 0 -1 855.5 296.907)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(1020.92 303)"
  }, "Stamen", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24,
    x: -58.2919,
    y: 215
  }, "Plumule")), /*#__PURE__*/React.createElement("path", {
    d: "M861.5 563.167 946.655 563.167 946.655 563.833 861.5 563.833ZM945.322 559.5 953.322 563.5 945.322 567.5Z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(962.63 571)"
  }, "Cotyledon", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24,
    x: -833.965,
    y: 24
  }, "Rhizome"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24,
    x: -539.081,
    y: 123
  }, "Root")), /*#__PURE__*/React.createElement("path", {
    d: "M358.7 631.233 413.032 672.022 412.632 672.555 358.3 631.767ZM414.167 668.289 418.164 676.291 409.364 674.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.536 658.291 189.314 608.553 189.904 608.242 216.125 657.98ZM186.692 611.442 186.5 602.5 193.769 607.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70371e-07-0.333333 67.7334-0.333238 67.7334 0.333429-4.70371e-07 0.333333ZM66.4-3.99991 74.4 0.000104987 66.4 4.00009Z",
    transform: "matrix(-1 0 0 1 254.9 184.5)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(124.003 192)"
  }, "Leaf"), /*#__PURE__*/React.createElement("path", {
    d: "M2.3926e-07-0.333333 139.6-0.333233 139.6 0.333434-2.3926e-07 0.333333ZM138.266-3.9999 146.266 0.000104987 138.266 4.0001Z",
    transform: "matrix(-1 0 0 1 350.766 228.5)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Times New Roman,Times New Roman_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 24,
    transform: "translate(125.632 235)"
  }, "Petiole"), /*#__PURE__*/React.createElement("path", {
    d: "M847.5 511.167 946.602 511.167 946.602 511.833 847.5 511.833ZM945.269 507.5 953.269 511.5 945.269 515.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotus);
export default __webpack_public_path__ + "static/media/Lotus.f6b1207108357625e1510e5113e10cf3.svg";
export { ForwardRef as ReactComponent };